Sculpteo3DViewerCommonTransform3D.prototype.toFloat32Array = function () {
  return new Float32Array(this.matrix.flatten());
};
function Sculpteo3DViewerWebGLLayer() {
  this.background = { color: { r: 0.0, g: 0.0, b: 0.0, a: 0.0 } };
  this.border = { color: { r: 0.0, g: 0.0, b: 0.0, a: 1.0 }, width: 0.0 };
  this.opacity = 1.0;
  this.frame = { x: 0.0, y: 0.0, w: 0.0, h: 0.0 };
  this.shadow = {
    color: { r: 0.0, g: 0.0, b: 0.0, a: 1.0 },
    offset: { x: 0.0, y: -3.0 },
    radius: 3.0,
    opacity: 0.0,
  };
  this.transform = Matrix.I(3);
  this.zindex = 0;
  this.interactive = 0;
  this.children = [];
}
Sculpteo3DViewerWebGL.prototype = new Sculpteo3DViewerCommon();
Sculpteo3DViewerWebGL.prototype.getModelViewMatrix = function () {
  return this.quatMat3(this.rotq.w, this.rotq.x, this.rotq.y, this.rotq.z);
};
Sculpteo3DViewerWebGL.prototype.loadFont = function (url, font_uuid) {
  log(new Date().getTime() / 1000 + " load font at " + url);
  var viewer = this;
  var font = {};
  var onerror = function (msg, req) {
    log(msg);
  };
  var onready = function (model, name) {
    log("font " + font_uuid + " ready with " + model.vbos.length + " vbos");
    if (typeof model.mesh.font == "undefined") {
      log("missing font info");
      console.log(model);
      return;
    }
    // Log("charmap: ");
    // log(model.mesh.font.charmap);
    // log("stride: ");
    // log(model.mesh.font.stride);
    if (model.mesh.font.stride.len != model.vbos.length) {
      log("warning: charmap and vbo count differ");
    }
    font.hspace = model.mesh.font.stride;
    font.charmap = model.mesh.font.charmap;
    font.vbos = model.vbos;
    viewer.fonts[font_uuid] = font;
    viewer.postEvent("font", font_uuid);
  };
  this.__loadModel(url, font_uuid, null, null, onready, onerror, function () {
    return false;
  });
};
Sculpteo3DViewerWebGL.prototype.drawRuler = function () {
  this.$ruler.addClass("hidden");
  var w = this.width;
  var h = this.height;
  var rule = 0.8;
  var ytext = 3.0;
  var xtext;
  var ruler_h = 6.0;
  var ruler_w;
  var unit;
  var mm_scale = this.mm_scale;
  var thou_scale = (1000.0 * mm_scale) / 25.4;
  var pow;
  var rescale;
  var scale = this.scale || 1 / this.scene_scale; // If there is no model design use the scene scale
  var zoom = this.zoomx;
  var xoff = 5;
  var yoff = h - 22;
  if (this.disable3D) {
    return;
  }
  if (scale == 0.0) {
    return;
  }
  if (mm_scale == 0.0) {
    /* 1 unit = mm_scale mm */
    return;
  }
  /* Metric ruler */
  pow = Math.floor(
    Math.log((zoom * scale * rule * mm_scale) / 2.0) / Math.log(10)
  );
  rescale = Math.pow(10.0, pow);
  ruler_w = (2.0 * rescale) / (scale * mm_scale);
  if (ruler_w < 0.2 * rule * zoom) {
    rescale *= 5;
    ruler_w = (2.0 * rescale) / (scale * mm_scale);
  } else if (ruler_w < 0.5 * rule * zoom) {
    rescale *= 2;
    ruler_w = (2.0 * rescale) / (scale * mm_scale);
  }
  if (rescale >= 1000.0) {
    rescale /= 1000.0;
    unit = "m";
  } else if (rescale >= 10.0) {
    rescale /= 10.0;
    unit = "cm";
  } else {
    unit = "mm";
  }
  var jtext;
  jtext = $(".Sculpteo3DViewerRuler_metric_text", this.$ruler);
  rescale = Math.floor(rescale);
  if (ruler_w < zoom && rescale > 0) {
    var text = rescale + "" + unit;
    var x, y;
    ruler_w = (ruler_w * w) / (2 * zoom);
    /* Draw the ruler */
    $(".Sculpteo3DViewerRuler_metric_start", this.$ruler).css({
      left: xoff,
      top: yoff - 6,
    });
    $(".Sculpteo3DViewerRuler_metric_length", this.$ruler).css({
      left: xoff,
      top: yoff,
      width: ruler_w,
    });
    $(".Sculpteo3DViewerRuler_metric_end", this.$ruler).css({
      left: xoff + ruler_w - 1,
      top: yoff - 6,
    });
    /* Draw the text */
    jtext.text(text);
    x = xoff + (ruler_w - jtext.width()) / 2.0;
    y = yoff - 15;
    jtext.css("left", x);
    jtext.css("top", y);
    $(
      ".Sculpteo3DViewerRuler_metric_start, .Sculpteo3DViewerRuler_metric_length, .Sculpteo3DViewerRuler_metric_end",
      this.$ruler
    ).show();
    jtext.show();
    if (typeof amt_options !== "undefined" && amt_options.shiftruler) {
      var half = $("#viewer3d").width() / 2;
      this.$ruler.css("left", half - ruler_w + "px");
    }
  } else {
    $(
      ".Sculpteo3DViewerRuler_metric_start, .Sculpteo3DViewerRuler_metric_length, .Sculpteo3DViewerRuler_metric_end",
      this.$ruler
    ).hide();
    jtext.hide();
  }
  /* Imperial ruler */
  pow = Math.floor(
    Math.log((zoom * scale * rule * thou_scale) / 2.0) / Math.log(10)
  );
  rescale = Math.pow(10.0, pow);
  ruler_w = (2.0 * rescale) / (scale * thou_scale);
  if (ruler_w < 0.2 * rule * zoom) {
    rescale *= 5;
    ruler_w = (2.0 * rescale) / (scale * thou_scale);
  } else if (ruler_w < 0.5 * rule * zoom) {
    rescale *= 2;
    ruler_w = (2.0 * rescale) / (scale * thou_scale);
  }
  if (rescale >= 1000.0) {
    rescale /= 1000.0;
    unit = "in";
  } else {
    unit = "mil";
  }
  var jtext;
  jtext = $(".Sculpteo3DViewerRuler_imperial_text", this.$ruler);
  rescale = Math.floor(rescale);
  if (ruler_w < zoom && rescale > 0) {
    var text = rescale + "" + unit;
    var x, y;
    ruler_w = (ruler_w * w) / (2 * zoom);
    /* Draw the ruler */
    $(".Sculpteo3DViewerRuler_imperial_start", this.$ruler).css({
      left: xoff,
      top: yoff,
    });
    $(".Sculpteo3DViewerRuler_imperial_length", this.$ruler).css({
      left: xoff,
      top: yoff,
      width: ruler_w,
    });
    $(".Sculpteo3DViewerRuler_imperial_end", this.$ruler).css({
      left: xoff + ruler_w - 1,
      top: yoff,
    });
    /* Draw the text */
    jtext.text(text);
    x = xoff + (ruler_w - jtext.width()) / 2.0;
    y = yoff - 1;
    jtext.css("left", x);
    jtext.css("top", y);
    $(
      ".Sculpteo3DViewerRuler_imperial_start, .Sculpteo3DViewerRuler_imperial_length, .Sculpteo3DViewerRuler_imperial_end",
      this.$ruler
    ).show();
    jtext.show();
  } else {
    $(
      ".Sculpteo3DViewerRuler_imperial_start, .Sculpteo3DViewerRuler_imperial_length, .Sculpteo3DViewerRuler_imperial_end",
      this.$ruler
    ).hide();
    jtext.hide();
  }
  this.$ruler.removeClass("hidden");
};
Sculpteo3DViewerWebGL.prototype.drawGrid = function () {
  $(".Sculpteo3DViewerGrid", this.jself).addClass("hidden");
  var rule = 0.8;
  var w = this.width;
  var h = this.height;
  var grid_scale;
  var unit;
  var mm_scale = this.mm_scale;
  var thou_scale = (1000.0 * mm_scale) / 25.4;
  var pow;
  var rescale;
  var scale = this.scale || 1 / this.scene_scale; // If there is no model design use the scene scale
  var zoom = this.zoomx;
  var xoff = 5;
  var yoff = h - 12;
  if (this.disable3D) {
    return;
  }
  if (scale == 0.0) {
    return;
  }
  if (mm_scale == 0.0) {
    /* 1 unit = mm_scale mm */
    return;
  }
  /* Metric grid */
  pow = Math.floor(
    Math.log((zoom * scale * rule * mm_scale) / 2.0) / Math.log(10)
  );
  rescale = Math.pow(10.0, pow);
  grid_scale = (2.0 * rescale) / (scale * mm_scale);
  if (grid_scale < 0.2 * rule * zoom) {
    rescale *= 5;
    grid_scale = (2.0 * rescale) / (scale * mm_scale);
  } else if (grid_scale < 0.5 * rule * zoom) {
    rescale *= 2;
    grid_scale = (2.0 * rescale) / (scale * mm_scale);
  }
  if (grid_scale < zoom && rescale > 0) {
    var x, y;
    var i, dim;
    dim = Math.ceil(zoom / grid_scale);
    /* Draw the grid */
    var html = "";
    for (var i = -dim; i <= dim; i++) {
      x = w / 2 + parseInt((i * grid_scale * w) / (2 * this.zoomx));
      if (x >= 0 && x < w) {
        html +=
          '<div class="absolute" style="top: 0px; left: ' +
          x +
          "px; width:2px; height: " +
          h +
          'px; background-color: #ffcc80; opacity: 0.3; -moz-opacity: 0.3; -ms-filter: "alpha(opacity=30)"; filter: alpha(opacity=30);"></div>';
      }
      y = h / 2 + parseInt((i * grid_scale * h) / (2 * this.zoomy));
      if (y >= 0 && y < h) {
        html +=
          '<div class="absolute" style="top: ' +
          y +
          "px; left: 0px; width:" +
          w +
          'px; height: 2px; background-color: #ffcc80; opacity: 0.3; -moz-opacity: 0.3; -ms-filter: "alpha(opacity=30)"; filter: alpha(opacity=30);"></div>';
      }
    }
    grid_scale *= 0.1;
    dim = Math.ceil(zoom / grid_scale);
    for (var i = -dim; i <= dim; i++) {
      x = w / 2 + parseInt((i * grid_scale * w) / (2 * this.zoomx));
      if (x >= 0 && x < w) {
        html +=
          '<div class="absolute" style="top: 0px; left: ' +
          x +
          "px; width:1px; height: " +
          h +
          'px; background-color: #ffcc80; opacity: 0.3; -moz-opacity: 0.3; -ms-filter: "alpha(opacity=30)"; filter: alpha(opacity=30);"></div>';
      }
      y = h / 2 + parseInt((i * grid_scale * h) / (2 * this.zoomy));
      if (y >= 0 && y < h) {
        html +=
          '<div class="absolute" style="top: ' +
          y +
          "px; left: 0px; width:" +
          w +
          'px; height: 1px; background-color: #ffcc80; opacity: 0.3; -moz-opacity: 0.3; -ms-filter: "alpha(opacity=30)"; filter: alpha(opacity=30);"></div>';
      }
    }
    $(".Sculpteo3DViewerGrid", this.jself).html(html);
  }
  $(".Sculpteo3DViewerGrid", this.jself).removeClass("hidden");
};
// Draw a quad.
//
// Takes a program and requires the vertex attribute 0 to be enabled. Takes the depth at which
// draw the quad. Finally, takes an array of 8 float representing the four vertices.
Sculpteo3DViewerWebGL.prototype.drawQuad = function (program, z, p) {
  var gl = this.gl;
  if (typeof p == "undefined") {
    p = [-1.0, -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0];
  }
  var vertexPositionsTexCoords = [
    p[0],
    p[1],
    z,
    0.0,
    0.0,
    p[2],
    p[3],
    z,
    1.0,
    0.0,
    p[6],
    p[7],
    z,
    0.0,
    1.0,
    p[6],
    p[7],
    z,
    0.0,
    1.0,
    p[2],
    p[3],
    z,
    1.0,
    0.0,
    p[4],
    p[5],
    z,
    1.0,
    1.0,
  ];
  gl.bindBuffer(gl.ARRAY_BUFFER, this._quadPositionBuffer);
  gl.bufferSubData(
    gl.ARRAY_BUFFER,
    0,
    new Float32Array(vertexPositionsTexCoords)
  );
  gl.vertexAttribPointer(program.vertexAttribute, 3, gl.FLOAT, false, 20, 0);
  gl.drawArrays(gl.TRIANGLES, 0, 6);
};
Sculpteo3DViewerWebGL.prototype.drawLine = function (coords) {
  var gl = this.gl;
  var vertexPositionsTexCoords = [];
  var nVertex = coords.length / 3;
  for (var i = 0; i < nVertex; i++) {
    vertexPositionsTexCoords.push([
      coords[3 * i],
      coords[3 * i + 1],
      coords[3 * i + 2],
      0.0,
      0.0,
    ]);
  }
  gl.uniform4f(this._programConstantColor.color, 255, 255, 255, 255);
  var program = this._programConstantColor;
  gl.bindBuffer(gl.ARRAY_BUFFER, this._linePositionBuffer);
  gl.bufferSubData(
    gl.ARRAY_BUFFER,
    0,
    new Float32Array(vertexPositionsTexCoords)
  );
  gl.vertexAttribPointer(program.vertexAttribute, 3, gl.FLOAT, false, 20, 0);
  gl.drawArrays(gl.LINE_STRIP, 0, 6);
};
Sculpteo3DViewerWebGL.prototype.drawTexturedQuad = function (
  program,
  texture,
  z,
  p,
  t
) {
  var gl = this.gl;
  var texCoords = [0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0];
  if (typeof p == "undefined") {
    p = [-1.0, -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0];
  }
  if (typeof t == "undefined") {
    t = [0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0];
  }
  var vertexPositionsTexCoords = [
    p[0],
    p[1],
    z,
    t[0],
    t[1],
    p[2],
    p[3],
    z,
    t[2],
    t[3],
    p[6],
    p[7],
    z,
    t[6],
    t[7],
    p[6],
    p[7],
    z,
    t[6],
    t[7],
    p[2],
    p[3],
    z,
    t[2],
    t[3],
    p[4],
    p[5],
    z,
    t[4],
    t[5],
  ];
  gl.bindBuffer(gl.ARRAY_BUFFER, this._quadPositionBuffer);
  gl.bufferSubData(
    gl.ARRAY_BUFFER,
    0,
    new Float32Array(vertexPositionsTexCoords)
  );
  gl.vertexAttribPointer(
    program.texCoord0Attribute,
    2,
    gl.FLOAT,
    false,
    4 * (2 + 3),
    4 * 3
  );
  gl.vertexAttribPointer(
    program.vertexAttribute,
    3,
    gl.FLOAT,
    false,
    4 * (2 + 3),
    0
  );
  gl.activeTexture(gl.TEXTURE0);
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.uniform1i(program.sampler, 0);
  gl.drawArrays(gl.TRIANGLES, 0, 6);
  gl.bindTexture(gl.TEXTURE_2D, null);
};
Sculpteo3DViewerWebGL.prototype.drawDashedLine = function (
  program,
  fromX,
  fromY,
  toX,
  toY,
  step,
  dutycycle,
  offset,
  r,
  g,
  b
) {
  var gl = this.gl;
  var dx = toX - fromX;
  var dy = toY - fromY;
  var len = Math.sqrt(dx * dx + dy * dy);
  var count = parseInt(Math.ceil(len / step));
  var positions = new Array();
  for (var i = 0; i <= count; i++) {
    var x0, y0, x1, y1;
    x0 = fromX + ((toX - fromX) * (i - 1 + offset)) / count;
    y0 = fromY + ((toY - fromY) * (i - 1 + offset)) / count;
    x1 = fromX + ((toX - fromX) * (i - 1 + offset + dutycycle)) / count;
    y1 = fromY + ((toY - fromY) * (i - 1 + offset + dutycycle)) / count;
    if (fromX < toX && x0 < fromX) {
      x0 = fromX;
    }
    if (fromX > toX && x0 > fromX) {
      x0 = fromX;
    }
    if (fromX < toX && x1 < fromX) {
      x1 = fromX;
    }
    if (fromX > toX && x1 > fromX) {
      x1 = fromX;
    }
    if (fromY < toY && y0 < fromY) {
      y0 = fromY;
    }
    if (fromY > toY && y0 > fromY) {
      y0 = fromY;
    }
    if (fromY < toY && y1 < fromY) {
      y1 = fromY;
    }
    if (fromY > toY && y1 > fromY) {
      y1 = fromY;
    }
    if (fromX < toX && x0 > toX) {
      x0 = toX;
    }
    if (fromX > toX && x0 < toX) {
      x0 = toX;
    }
    if (fromX < toX && x1 > toX) {
      x1 = toX;
    }
    if (fromX > toX && x1 < toX) {
      x1 = toX;
    }
    if (fromY < toY && y0 > toY) {
      y0 = toY;
    }
    if (fromY > toY && y0 < toY) {
      y0 = toY;
    }
    if (fromY < toY && y1 > toY) {
      y1 = toY;
    }
    if (fromY > toY && y1 < toY) {
      y1 = toY;
    }
    positions.push(x0, y0, 0.0);
    positions.push(x1, y1, 0.0);
  }
  positions = new Float32Array(positions);
  // XXX: this is inefficient, remember it
  log("XXX");
  var pbuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, pbuffer);
  gl.bufferData(gl.ARRAY_BUFFER, positions, gl.STATIC_DRAW);
  gl.bindBuffer(gl.ARRAY_BUFFER, pbuffer);
  gl.vertexAttribPointer(
    program.vertexPositionAttribute,
    3,
    gl.FLOAT,
    false,
    0,
    0
  );
  gl.drawArrays(gl.LINES, 0, positions.length / 3);
};
Sculpteo3DViewerWebGL.prototype.drawLayer = function (x, y, layer) {
  var gl = this.gl;
  var p = Array();
  var x0 = x;
  var y0 = y;
  var x1 = x + layer.frame.w;
  var y1 = y + layer.frame.h;
  x0 = (2.0 * x0) / this.width - 1.0;
  y0 = (2.0 * (this.height - 1 - y0)) / this.height - 1.0;
  x1 = (2.0 * x1) / this.height - 1.0;
  y1 = (2.0 * (this.height - 1 - y1)) / this.height - 1.0;
  p.push(x0, y1);
  p.push(x1, y1);
  p.push(x1, y0);
  p.push(x0, y0);
  // Draw background
  if (layer.background.color) {
    // Set transform
    gl.uniformMatrix4fv(
      this._programConstantColor.projectionMatrix,
      false,
      this.identity
    );
    gl.uniformMatrix4fv(
      this._programConstantColor.modelViewMatrix,
      false,
      this.identity
    );
    gl.uniform4f(
      this._programConstantColor.color,
      layer.background.color.r,
      layer.background.color.g,
      layer.background.color.b,
      layer.background.color.a
    );
    this.drawQuad(this._programConstantColor, layer.zindex, p);
  }
  if (layer.background.texture) {
    gl.useProgram(this._programSingleTexture);
    gl.enableVertexAttribArray(this._programSingleTexture.texCoord0Attribute);
    gl.uniformMatrix4fv(
      this._programSingleTexture.projectionMatrix,
      false,
      this.identity
    );
    gl.uniformMatrix4fv(
      this._programSingleTexture.modelViewMatrix,
      false,
      this.identity
    );
    this.drawTexturedQuad(
      this._programSingleTexture,
      layer.background.texture,
      layer.zindex,
      p
    );
    gl.disableVertexAttribArray(this._programSingleTexture.texCoord0Attribute);
    gl.useProgram(this._programConstantColor);
  }
};
Sculpteo3DViewerWebGL.prototype.drawSelectionBox = function (
  x0,
  y0,
  x1,
  y1,
  angle,
  bgcolor
) {
  var gl = this.gl;
  var p = Array();
  var ca = Math.cos((angle * Math.PI) / 180.0);
  var sa = Math.sin((angle * Math.PI) / 180.0);
  p.push(x0, y0);
  p.push(x0 + ca * (x1 - x0), y0 + sa * (x1 - x0));
  p.push(
    x0 + ca * (x1 - x0) - sa * (y1 - y0),
    y0 + sa * (x1 - x0) + ca * (y1 - y0)
  );
  p.push(x0 - sa * (y1 - y0), y0 + ca * (y1 - y0));
  // Set transform
  gl.uniformMatrix4fv(
    this._programConstantColor.projectionMatrix,
    false,
    this.identity
  );
  gl.uniformMatrix4fv(
    this._programConstantColor.modelViewMatrix,
    false,
    this.identity
  );
  // Draw background
  if (typeof bgcolor != "undefined") {
    gl.uniform4f(
      this._programConstantColor.color,
      bgcolor.r,
      bgcolor.g,
      bgcolor.b,
      bgcolor.a
    );
    this.drawQuad(this._programConstantColor, 0.0, p);
  }
  // Draw moving dashed line selection
  gl.disable(gl.BLEND);
  for (var i = 0; i < 4; i++) {
    gl.uniform4f(this._programConstantColor.color, 0.0, 0.0, 0.0, 1.0);
    this.drawDashedLine(
      this._programConstantColor,
      p[2 * i],
      p[2 * i + 1],
      p[2 * ((i + 1) % 4)],
      p[2 * ((i + 1) % 4) + 1],
      0.05,
      0.5,
      (this.frame % 30) / 30.0
    );
    gl.uniform4f(this._programConstantColor.color, 1.0, 1.0, 0.0, 1.0);
    this.drawDashedLine(
      this._programConstantColor,
      p[2 * i],
      p[2 * i + 1],
      p[2 * ((i + 1) % 4)],
      p[2 * ((i + 1) % 4) + 1],
      0.05,
      0.5,
      ((this.frame + 15) % 30) / 30.0
    );
  }
  gl.enable(gl.BLEND);
  this.setUpdate(false);
  this.cancelRemote();
};
Sculpteo3DViewerWebGL.prototype.drawSelectionRect = function (rect) {
  var gl = this.gl;
  var program = this._programConstantColor;
  var p = [
    rect.x,
    rect.y + rect.h,
    rect.x + rect.w,
    rect.y + rect.h,
    rect.x + rect.w,
    rect.y,
    rect.x,
    rect.y,
  ];
  // normalize p values
  for (var i = 0; i < 8; i += 2) {
    p[i] = 2 * (p[i] / this.width - 0.5); // x
    p[i + 1] = 2 * (0.5 - p[i + 1] / this.height); // y
  }
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.useProgram(program);
  gl.uniform4f(program.color, 0.25, 0.25, 1.0, 0.6); // transparent blueish
  gl.uniformMatrix4fv(program.projectionMatrix, false, this.identity);
  gl.uniformMatrix4fv(program.modelViewMatrix, false, this.identity);
  // enable blending so that we can draw the rectangle and blend it with background
  // we also disable depth test because we don't need one
  gl.enable(gl.BLEND);
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
  gl.disable(gl.DEPTH_TEST);
  gl.enableVertexAttribArray(0);
  this.drawQuad(program, 0.0, p);
  gl.disableVertexAttribArray(0);
  gl.enable(gl.DEPTH_TEST);
  gl.disable(gl.BLEND);
};
Sculpteo3DViewerWebGL.prototype._getTextLength = function (font, str) {
  var dx = 0.0;
  for (var i = 0; i < str.length; i++) {
    var c = font.charmap[str[i]];
    if (typeof c == "undefined") {
      dx++; // Blank for unknown char
    } else {
      dx += font.hspace[c];
    }
  }
  return dx;
};
Sculpteo3DViewerWebGL.prototype.drawText = function (
  x,
  y,
  ofx,
  ofy,
  font,
  str,
  color,
  scale,
  angle
) {
  var gl = this.gl;
  if (!str) {
    return;
  }
  gl.uniform4f(
    this._programConstantColor.color,
    color.r,
    color.g,
    color.b,
    color.a
  );
  var c = font.charmap[str[0]];
  if (typeof c == "undefined") {
    ofx += scale * 0.5;
  } else {
    ofx += font.hspace[c] * scale * 0.5;
  }
  ofy += scale * 0.5;
  var dx = 0.0;
  for (var i = 0; i < str.length; i++) {
    c = font.charmap[str[i]];
    if (typeof c == "undefined") {
      dx += scale; // Blank for unknown char
      continue;
    }
    var vbo = font.vbos[c + 1];
    var mvMatrix = Sculpteo3DViewerCommonTransform3D.translation(
      ofx + dx,
      ofy,
      0.0
    );
    mvMatrix = mvMatrix.x(
      Sculpteo3DViewerCommonTransform3D.scale(
        scale * 0.5,
        scale * 0.5,
        scale * 0.5,
        1.0
      )
    );
    var arad = (angle * Math.PI) / 180.0;
    mvMatrix = Sculpteo3DViewerCommonTransform3D.rotation(
      arad,
      0.0,
      0.0,
      1.0
    ).x(mvMatrix);
    mvMatrix = Sculpteo3DViewerCommonTransform3D.translation(x, y, 0.0).x(
      mvMatrix
    );
    gl.uniformMatrix4fv(
      this._programConstantColor.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    // Log("char " + text.str[i] + " mapped to " + c + " vbo " + vbo + " " +
    // vbo.positions.numItems + " at " + dx);
    this.drawModelWithPositionsAndNormals(
      [vbo],
      this._programConstantColor.vertexAttribute,
      null
    );
    dx += font.hspace[c] * scale;
  }
};
Sculpteo3DViewerWebGL.prototype.getTextOnMesh = function (
  x,
  y,
  ofx,
  ofy,
  font,
  str,
  color,
  scale,
  angle,
  height
) {
  var c = font.charmap[str[0]];
  if (typeof c == "undefined") {
    ofx += scale * 0.5;
  } else {
    ofx += font.hspace[c] * scale * 0.5;
  }
  ofy += scale * 0.5;
  var nodes = [];
  var dx = 0.0;
  for (var i = 0; i < str.length; i++) {
    c = font.charmap[str[i]];
    if (typeof c == "undefined") {
      dx += scale; // Blank for unknown char
      continue;
    }
    // 2D transform
    var mvMatrix = Sculpteo3DViewerCommonTransform3D.translation(
      ofx + dx,
      ofy,
      0.0
    );
    mvMatrix = mvMatrix.x(
      Sculpteo3DViewerCommonTransform3D.scale(
        scale * 0.5,
        scale * 0.5,
        height * 0.5
      )
    );
    var arad;
    arad = (angle * Math.PI) / 180.0;
    mvMatrix = Sculpteo3DViewerCommonTransform3D.rotation(
      arad,
      0.0,
      0.0,
      1.0
    ).x(mvMatrix);
    var pt = mvMatrix.x([0.0, 0.0, 0.0, 1.0]);
    // Reconstruct position and normal at that location
    var dn = this.depthAndNormalAtLocation(x + pt[0], y + pt[1]);
    if (dn == null) {
      dx += font.hspace[c] * scale; // Skip char
      continue;
    }
    var vbo = font.vbos[c + 1];
    var z = dn.z + 0.01;
    var nx, ny, nz;
    nx = dn.nx;
    ny = dn.ny;
    nz = dn.nz;
    // 3D transform
    upx = 0.0;
    upy = 1.0;
    upz = 0.0;
    Zx = nx;
    Zy = ny;
    Zz = nz;
    // X=normalize(cross(up, n))
    Zcupx = Zy * upz - upy * Zz;
    Zcupy = Zz * upx - upz * Zx;
    Zcupz = Zx * upy - upx * Zy;
    l = Math.sqrt(Zcupx * Zcupx + Zcupy * Zcupy + Zcupz * Zcupz);
    Xx = -Zcupx / l;
    Xy = -Zcupy / l;
    Xz = -Zcupz / l;
    // Y=cross(Z, X)
    Yx = ny * Xz - Xy * nz;
    Yy = nz * Xx - Xz * nx;
    Yz = nx * Xy - Xx * ny;
    var T = new Sculpteo3DViewerCommonTransform3D([
      Xx,
      Yx,
      Zx,
      0.0,
      Xy,
      Yy,
      Zy,
      0.0,
      Xz,
      Yz,
      Zz,
      0.0,
      0.0,
      0.0,
      0.0,
      1.0,
    ]);
    mvMatrix = mvMatrix.x(T);
    mvMatrix = Sculpteo3DViewerCommonTransform3D.translation(x, y, z).x(
      mvMatrix
    );
    // In object space
    var iMvMatrix = this.mvMatrix.inverse();
    mvMatrix = iMvMatrix.x(mvMatrix);
    node = new Sculpteo3DViewerCommonNode([vbo], mvMatrix);
    node.color = color;
    nodes.push(node);
    dx += font.hspace[c] * scale;
  }
  return nodes;
};
Sculpteo3DViewerWebGL.prototype.appendTextOnMesh = function (
  x,
  y,
  ofx,
  ofy,
  font,
  str,
  color,
  scale,
  angle,
  height
) {
  var nodes = this.getTextOnMesh(
    x,
    y,
    ofx,
    ofy,
    font,
    str,
    color,
    scale,
    angle,
    height
  );
  // TODO: create union tree and insert it in the scene
  // this.nodes = this.nodes.concat(nodes);
};
Sculpteo3DViewerWebGL.prototype.drawTextOnMesh = function (
  x,
  y,
  ofx,
  ofy,
  font,
  str,
  color,
  scale,
  angle,
  height
) {
  var gl = this.gl;
  var nodes = this.getTextOnMesh(
    x,
    y,
    ofx,
    ofy,
    font,
    str,
    color,
    scale,
    angle,
    height
  );
  gl.enable(gl.DEPTH_TEST);
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];
    if (typeof node == "undefined") {
      continue;
    }
    gl.uniform4f(
      this._programConstantColor.color,
      node.color.r,
      node.color.g,
      node.color.b,
      node.color.a
    );
    var mvMatrix = this.mvMatrix.x(node.transform);
    gl.uniformMatrix4fv(
      this._programConstantColor.projectionMatrix,
      false,
      this.pMatrix.toFloat32Array()
    );
    gl.uniformMatrix4fv(
      this._programConstantColor.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    this.drawModelWithPositionsAndNormals(
      node.model,
      this._programConstantColor.vertexAttribute,
      null
    );
  }
  gl.disable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.drawUILabels = function (ui) {
  if (typeof ui.labels == "undefined") {
    return;
  }
  var gl = this.gl;
  for (var j = 0; j < ui.labels.length; j++) {
    var label = ui.labels[j];
    if (typeof this.fonts[label.font_uuid] == "undefined") {
      return;
    }
    var font = this.fonts[label.font_uuid];
    this.drawText(
      label.x,
      label.y,
      0.0,
      0.0,
      font,
      label.str,
      label.color,
      label.scale,
      label.angle
    );
  }
};
Sculpteo3DViewerWebGL.prototype.drawUITextInputs = function (ui) {
  if (typeof ui.textinputs == "undefined") {
    return;
  }
  var gl = this.gl;
  for (var j = 0; j < ui.textinputs.length; j++) {
    var textinput = ui.textinputs[j];
    if (typeof this.fonts[textinput.font_uuid] == "undefined") {
      return;
    }
    var font = this.fonts[textinput.font_uuid];
    var scale = textinput.scale;
    var margin = textinput.margin;
    var cursorsize = 0.1;
    var l =
      (this._getTextLength(
        font,
        textinput.str
          ? textinput.str
          : textinput.placeholder
          ? textinput.placeholder
          : ""
      ) +
        cursorsize +
        2.0 * margin) *
      scale;
    var h = scale * (1.0 + 2.0 * margin);
    // Draw region and background
    this.drawSelectionBox(
      textinput.x,
      textinput.y,
      textinput.x + l,
      textinput.y + h,
      textinput.angle,
      textinput.bgcolor
    );
    // Draw the text or placeholder
    var ofx = margin * scale;
    var ofy = margin * scale;
    if (textinput.str) {
      this.drawText(
        textinput.x,
        textinput.y,
        ofx,
        ofy,
        font,
        textinput.str,
        textinput.color,
        scale,
        textinput.angle
      );
    } else if (textinput.placeholder) {
      this.drawText(
        textinput.x,
        textinput.y,
        ofx,
        ofy,
        font,
        textinput.placeholder,
        textinput.phcolor,
        scale,
        textinput.angle
      );
    }
    // Draw cursor
    if (this.ui.focus == textinput && this.frame % 60 > 30) {
      gl.uniform4f(
        this._programConstantColor.color,
        textinput.color.r,
        textinput.color.g,
        textinput.color.b,
        textinput.color.a
      );
      l = this._getTextLength(font, textinput.str ? textinput.str : "");
      var x0 = (l + margin) * scale;
      var y0 = margin * scale;
      var w = cursorsize * scale;
      var h = scale;
      var mvMatrix = Sculpteo3DViewerCommonTransform3D.translation(x0, y0, 0.0);
      var arad = (textinput.angle * Math.PI) / 180.0;
      mvMatrix = Sculpteo3DViewerCommonTransform3D.rotation(
        arad,
        0.0,
        0.0,
        1.0
      ).x(mvMatrix);
      mvMatrix = Sculpteo3DViewerCommonTransform3D.translation(
        textinput.x,
        textinput.y,
        0.0
      ).x(mvMatrix);
      gl.uniformMatrix4fv(
        this._programConstantColor.modelViewMatrix,
        false,
        mvMatrix.toFloat32Array()
      );
      this.drawQuad(this._programConstantColor, 0.0, [0, 0, w, 0, w, h, 0, h]);
    }
  }
};
/* Draw all the 2D UI */
Sculpteo3DViewerWebGL.prototype.drawUI = function (ui) {
  var gl = this.gl;
  // Use the constant color shader with no z-test and blending enabled
  // projection matrix is identity
  // modelview matrix used to move elements inside the canvas
  gl.disable(gl.DEPTH_TEST);
  gl.enable(gl.BLEND);
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
  gl.useProgram(this._programConstantColor);
  gl.enableVertexAttribArray(this._programConstantColor.vertexAttribute);
  // Text on mesh
  if (this.ui.text_on_mesh) {
    var font_id = this.ui.text_on_mesh.font;
    if (this.fonts[font_id]) {
      var font = this.fonts[font_id];
      // Get mouse location in object coordinates
      var x = ((2.0 * this.mouse_x) / (this.width - 1.0) - 1.0) * this.zoom;
      var y = ((2.0 * this.mouse_y) / (this.height - 1.0) - 1.0) * -this.zoom;
      var str = this.ui.text_on_mesh.str;
      var scale = this.ui.text_on_mesh.scale;
      var color = this.ui.text_on_mesh.color;
      var angle = this.ui.text_on_mesh.angle;
      var height = this.ui.text_on_mesh.height;
      var margin = 0.2;
      var ofx = margin * scale;
      var ofy = margin * scale;
      this.drawTextOnMesh(
        x,
        y,
        ofx,
        ofy,
        font,
        str,
        color,
        scale,
        angle,
        height
      );
      var cursorsize = 0.1;
      var l =
        (this._getTextLength(font, str) + cursorsize + 2.0 * margin) * scale;
      var h = scale * (1.0 + 2.0 * margin);
      var zoom = this.zoom;
      this.drawSelectionBox(
        x / zoom,
        y / zoom,
        (x + l) / zoom,
        (y + h) / zoom,
        angle
      );
    }
  }
  gl.uniformMatrix4fv(
    this._programConstantColor.projectionMatrix,
    false,
    this.identity
  );
  // Text labels
  this.drawUILabels(ui);
  // Selection rectangle
  if (ui.selection_rect) {
    this.drawSelectionBox(
      ui.selection_rect.x0,
      ui.selection_rect.y0,
      ui.selection_rect.x1,
      ui.selection_rect.y1,
      0.0
    );
  }
  // Text inputs
  this.drawUITextInputs(ui);
  // Layers
  /*
   *
   * For (var k in this.ui.layout) { var info = this.ui.layout[k];
   * this.drawLayer(info.x, info.y, info.layer); }
   */
  gl.disable(gl.BLEND);
  gl.disableVertexAttribArray(this._programConstantColor.vertexAttribute);
  gl.enable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.UILabel = function (font_uuid, str, opts) {
  var defaults = {
    x: 0.0,
    y: 0.0,
    scale: 1.0,
    angle: 0.0,
    color: { r: 0.0, g: 0.0, b: 0.0, a: 1.0 },
  };
  if (typeof opts == "undefined") {
    opts = {};
  }
  $.extend(defaults, opts);
  var label = { font_uuid: font_uuid, str: str };
  $.extend(label, defaults);
  this.ui.labels.push(label);
  return label;
};
Sculpteo3DViewerWebGL.prototype.UITextInput = function (font_uuid, opts) {
  var textinput;
  var viewer = this;
  var defaults = {
    x: 0.0,
    y: 0.0,
    scale: 1.0,
    margin: 0.2,
    angle: 0.0,
    color: { r: 0.0, g: 0.0, b: 0.0, a: 1.0 },
    bgcolor: { r: 1.0, g: 1.0, b: 1.0, a: 0.5 },
    phcolor: { r: 0.5, g: 0.5, b: 0.5, a: 1.0 },
    box: function () {
      // XXX: ugly, should make a class
      if (typeof viewer.fonts[textinput.font_uuid] == "undefined") {
        return [0.0, 0.0, 0.0, 0.0, 0.0];
      }
      var font = viewer.fonts[textinput.font_uuid];
      var scale = textinput.scale;
      var margin = textinput.margin;
      var cursorsize = 0.1;
      var l =
        (viewer._getTextLength(
          font,
          textinput.str
            ? textinput.str
            : textinput.placeholder
            ? textinput.placeholder
            : ""
        ) +
          cursorsize +
          2.0 * margin) *
        scale;
      var h = scale * (1.0 + 2.0 * margin);
      return [
        textinput.x,
        textinput.y,
        textinput.x + l,
        textinput.y + h,
        textinput.angle,
      ];
    },
  };
  if (typeof opts == "undefined") {
    opts = {};
  }
  $.extend(defaults, opts);
  textinput = { font_uuid: font_uuid };
  $.extend(textinput, defaults);
  this.ui.textinputs.push(textinput);
  this.ui.focus = textinput;
  return textinput;
};
Sculpteo3DViewerWebGL.prototype.setUpdate = function (render_dirty, status) {
  if (render_dirty) {
    this.render_age++;
  }
  this.update = true;
  if (this.jImageDiv) {
    this.jImageDiv.style.display = "none";
  } else {
    this.$imageDiv.hide();
  }
  if (
    !(
      this.mousedown &&
      (this.mousedown[1] || this.mousedown[2] || this.mousedown[3])
    ) &&
    (!this.autorotate || this.loading) &&
    (!this.ui || !this.ui.cursorNode)
  ) {
    this.cancelRemote(status);
    if (!this.local && status != "abort" && status != "noRender")
      this.remoteRender();
  } else {
    this.cancelRemote();
  }
};
Sculpteo3DViewerWebGL.prototype._remoteRender = function () {
  var id;
  if (!this.design_uuid) {
    return;
  }
  if (this.local) {
    return;
  }
  if (typeof this.renderurl != "string") {
    return;
  }
  if (this.render_age == this.remote_age) {
    // Reuse the old image
    if (!this.local) {
      this.$canvas.hide();
      if (!this.disable3D) {
        this.$imageDiv.show().css("opacity", this.loading ? 0.3 : 1.0);
      }
    }
    return;
  }
  if (this.rendering == this.render_age) {
    // Already rendering this age
    return;
  }
  var viewer_width = this.width;
  var viewer_height = this.height;
  var imageUrl = this.getSnapshotUrl(viewer_width, viewer_height, 0);
  var imageUrl2 = this.getSnapshotUrl(viewer_width, viewer_height, 2);
  var viewer = this;
  viewer.imageurl = imageUrl;
  viewer.imageurl2 = null;
  var age = this.render_age;
  var loader = new ImageLoader(imageUrl);
  loader.loadEvent = function (imageUrl, image) {
    if (age != viewer.render_age) {
      if (viewer.rendering == age && !viewer.loading) {
        viewer.postEvent("renderstop");
      }
      return;
    }
    image.width = viewer_width;
    image.height = viewer_height;
    image.id = "Sculpteo3DViewerImage";
    viewer.$imageDiv.empty().append(image);
    if (!viewer.local) {
      if (!viewer.disable3D) {
        viewer.$imageDiv.show().css("opacity", viewer.loading ? 0.3 : 1.0);
      }
      viewer.$canvas.hide();
    }
    viewer.remote_age = age;
    delete viewer.rendering;
    if (!viewer.loading) {
      viewer.postEvent("renderstop");
    }
    viewer.update = false;
  };
  loader.errorEvent = function (imageUrl, image) {
    if (age != viewer.render_age) {
      if (viewer.rendering == age && !viewer.loading) {
        viewer.postEvent("renderstop");
      }
      return;
    }
    delete viewer.rendering;
    viewer.postEvent("renderstop");
  };
  if (viewer.quality > 1 && viewer.patch_render == 1) {
    /* Compute the final width & height of the image */
    var tmp = 0;
    var width = viewer_width;
    var height = viewer_height;
    if (this.render_width > 0 && this.render_height > 0) {
      while (width > this.render_width || height > this.render_height) {
        width = width >> 1;
        height = height >> 1;
      }
    }
    /* Compute the number of patches */
    /* Increase patch size if the final number of patch is too high (100000 is an arbitrary value) */
    var patch_number;
    do {
      var tw =
        parseInt(width + viewer.patch_width - 1) / parseInt(viewer.patch_width);
      var th =
        parseInt(height + viewer.patch_height - 1) /
        parseInt(viewer.patch_height);
      patch_number = parseInt(tw) * parseInt(th);
      if (tmp > 0) {
        if (tmp % 2) {
          viewer.patch_width += 1;
        } else {
          viewer.patch_height += 1;
        }
      }
      ++tmp;
    } while (patch_number > 100000);
    /* Create the StreamingImageLoader used to steam content to the client window */
    var loader2 = new StreamingImageLoader(
      viewer,
      imageUrl2,
      viewer_width,
      viewer_height,
      patch_number
    );
  } else {
    var loader2 = new ImageLoader(imageUrl2);
  }
  loader2.setupEvent = function (imageUrl2, image) {
    viewer.$imageDiv.empty().append(image);
    if (!viewer.local) {
      if (!viewer.disable3D) {
        viewer.$imageDiv.show().css("opacity", viewer.loading ? 0.3 : 1.0);
      }
    }
  };
  loader2.loadEvent = function (imageUrl2, image) {
    if (age != viewer.render_age) {
      if (viewer.rendering == age && !viewer.loading) {
        viewer.postEvent("hqrenderstop");
      }
      return;
    }
    if (image.tagName.toLowerCase() === "img") {
      image.width = viewer_width;
      image.height = viewer_height;
      image.id = "Sculpteo3DViewerImage";
      viewer.$imageDiv.empty().append(image);
    }
    if (!viewer.local) {
      if (!viewer.disable3D) {
        viewer.$imageDiv.show().css("opacity", viewer.loading ? 0.3 : 1.0);
      }
      // Hide only if we use img or if the streaming finish successfully
      //if (image.tagName.toLowerCase() === "img") // condition if we use img (like site_v1)
      // TODO: Detect if the streaming finish successfully, no timeout, no interruption, ...
      viewer.$canvas.hide();
    }
    viewer.remote_age = age;
    delete viewer.rendering;
    if (!viewer.loading) {
      viewer.postEvent("hqrenderstop");
    }
    viewer.update = false;
  };
  loader2.errorEvent = function (imageUrl2, image, status) {
    if (age != viewer.render_age) {
      if (viewer.rendering == age && !viewer.loading) {
        viewer.postEvent("hqrenderstop", status);
      }
      return;
    }
    viewer.remote_age = age;
    delete viewer.rendering;
    if (!viewer.loading) {
      viewer.postEvent("hqrenderstop", status);
    }
    viewer.update = false;
  };
  if (viewer.timeout) {
    clearTimeout(viewer.timeout);
  }
  if (viewer.timeout2) {
    clearTimeout(viewer.timeout2);
    viewer.timeout2 = null;
  }
  if (viewer.quality > 1 && !viewer.wireframe && !viewer.loading) {
    viewer.imageurl2 = imageUrl2;
    viewer.timeout2 = setTimeout(function () {
      if (!viewer.loading) {
        viewer.postEvent("hqrenderstart");
      }
      var cookie = "webgl/" + viewer.viewer_uuid + "/" + new Date().getTime();
      Utils.setCookie("sculpteo-viewer", cookie, 0, "/");
      loader2.load();
      viewer.rendering = age;
    }, viewer.render_timeout2);
  } else {
    viewer.timeout = setTimeout(function () {
      if (!viewer.loading) {
        viewer.postEvent("renderstart");
      }
      var cookie = "webgl/" + viewer.viewer_uuid + "/" + new Date().getTime();
      Utils.setCookie("sculpteo-viewer", cookie, 0, "/");
      loader.load();
      viewer.rendering = age;
    }, viewer.render_timeout);
  }
};
Sculpteo3DViewerWebGL.prototype.createViewerFrame = function (
  jself,
  viewerId,
  options,
  width,
  height
) {
  var extra_html = "";
  var shaders = [
    "main",
    "depthMap",
    "UberShader",
    "constantColor",
    "SSAO",
    "Blur",
    "BlurGauss",
    "singleTexture",
    "CombineDepthMap",
    "CopyDepthMap",
    "CSGmax",
    "PBRShader",
    "constantColorCSGTest",
  ];
  for (var k = 0; k < shaders.length; k++) {
    extra_html +=
      '<script id="shader-' +
      shaders[k] +
      "-fs-" +
      viewerId +
      '" src="' +
      STATIC_URL +
      "js/webgl/" +
      shaders[k] +
      '.fsh" type="x-shader/x-fragment"></script>';
    extra_html +=
      '<script id="shader-' +
      shaders[k] +
      "-vs-" +
      viewerId +
      '" src="' +
      STATIC_URL +
      "js/webgl/" +
      shaders[k] +
      '.vsh" type="x-shader/x-vertex"></script>';
  }
  Sculpteo3DViewerCommon.prototype.createViewerFrame.call(
    this,
    jself,
    viewerId,
    options,
    width,
    height,
    "Sculpteo3DViewerWebGL",
    extra_html
  );
};
/*
 * Shaders are now packed in a single shaders.js file by the compress_shaders
 * management command Sculpteo3DViewerWebGL.prototype.getShaderOld =
 * function(gl, id) { var shaderScript = document.getElementById(id); if
 * (!shaderScript) { return null; }
 *
 * var str = ""; if (shaderScript.src != "" ||
 * typeof(shaderScript.attributes['srcUrl']) != "undefined") { var srcUrl =
 * (shaderScript.src!='')?shaderScript.src:(shaderScript.attributes['srcUrl'].value);
 *
 * xmlHttp = new XMLHttpRequest(); xmlHttp.open('GET', srcUrl, false);
 * xmlHttp.send(null);
 *
 * if(xmlHttp.status == 200 || xmlHttp.status == 0) { str =
 * xmlHttp.responseText; } } else { var k = shaderScript.firstChild; while (k) {
 * if (k.nodeType == 3) { str += k.textContent; } k = k.nextSibling; } }
 *
 * var shader; if (shaderScript.type == "x-shader/x-fragment") { shader =
 * gl.createShader(gl.FRAGMENT_SHADER); } else if (shaderScript.type ==
 * "x-shader/x-vertex") { shader = gl.createShader(gl.VERTEX_SHADER); } else {
 * return null; }
 *
 * gl.shaderSource(shader, str); gl.compileShader(shader);
 *
 * if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) { console.log("shader " +
 * id + " failed to compile"); console.log(gl.getShaderInfoLog(shader)); return
 * null; } else { var ret = gl.getShaderInfoLog(shader); if (ret) log(ret); }
 *
 * return shader; }
 */
Sculpteo3DViewerWebGL.prototype.getShader = function (gl, id, type, no_text) {
  var shader, str;
  if (type == "fragment") {
    str = SHADERS[id].fsh;
    shader = gl.createShader(gl.FRAGMENT_SHADER);
  } else if (type == "vertex") {
    str = SHADERS[id].vsh;
    shader = gl.createShader(gl.VERTEX_SHADER);
  } else {
    return null;
  }
  if (no_text) {
    str = str.replace(/%has_text%/g, 0);
  } else {
    str = str.replace(/%has_text%/g, 1);
  }
  gl.shaderSource(shader, str);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    console.log("shader " + id + " failed to compile");
    console.log(gl.getShaderInfoLog(shader));
    return null;
  } else {
    var ret = gl.getShaderInfoLog(shader);
    if (ret) {
      log(ret);
    }
  }
  return shader;
};

function WebglError(msg) {
  this.msg = msg;
}

Sculpteo3DViewerWebGL.prototype.loadShader = function (
  gl,
  name,
  attributes,
  uniforms,
  no_text
) {
  // Var fragmentShader = this.getShaderOld(gl, "shader-" + name +
  // "-fs-"+this.viewerId);
  // var vertexShader = this.getShaderOld(gl, "shader-" + name +
  // "-vs-"+this.viewerId);
  var fragmentShader = this.getShader(gl, name, "fragment", no_text);
  var vertexShader = this.getShader(gl, name, "vertex");
  if (!fragmentShader || !vertexShader) {
    throw new WebglError("Shader compilation failed");
  }
  var _shaderProgram = gl.createProgram();
  gl.attachShader(_shaderProgram, vertexShader);
  gl.attachShader(_shaderProgram, fragmentShader);
  gl.linkProgram(_shaderProgram);
  if (!gl.getProgramParameter(_shaderProgram, gl.LINK_STATUS) && !no_text) {
    console.log("here");
    return this.loadShader(gl, name, attributes, uniforms, 1);
  } else if (!gl.getProgramParameter(_shaderProgram, gl.LINK_STATUS)) {
    console.log("shader " + name + " failed to link");
    console.log(gl.getProgramInfoLog(_shaderProgram));
    // JAlert(String.format(gettext("Could not initialise WebGL shaders, switching back to default 3D technology<br><a href='{0}#webgl' target='_blank'>More information here</a>"), URLS['help']));
    if (this.restartTimeout) {
      clearTimeout(this.restartTimeout);
    }
    var that = this;
    this.restartTimeout = setTimeout(function () {
      that.sculpteo3dviewer.Sculpteo3DViewer(
        "selectViewer",
        Sculpteo3DViewerCaps & Sculpteo3DViewerCap_flash ? "flash" : "static",
        true
      );
    });
    return;
  } else {
    var ret = gl.getProgramInfoLog(_shaderProgram);
    if (ret) {
      log(ret);
    }
  }
  gl.useProgram(_shaderProgram);
  for (var k in attributes) {
    _shaderProgram[k] = gl.getAttribLocation(_shaderProgram, attributes[k]);
  }
  for (var k in uniforms) {
    _shaderProgram[k] = gl.getUniformLocation(_shaderProgram, uniforms[k]);
    if (_shaderProgram[k] == null) {
      console.log("uniform " + uniforms[k] + " not found");
    }
  }
  return _shaderProgram;
};
Sculpteo3DViewerWebGL.prototype.initShaders = function (gl) {
  this.shaderProgram = this.loadShader(
    gl,
    "main",
    {
      vertexPositionAttribute: "aVertexPosition",
      vertexNormalAttribute: "aVertexNormal",
      textureCoordAttribute: "aTextureCoord",
    },
    {
      cameraPos: "uCameraPos",
      pMatrixUniform: "uPMatrix",
      mvMatrixUniform: "uMVMatrix",
      nMatrixUniform: "uNMatrix",
      uPointSize: "uPointSize",
      samplerUniform: "uSampler",
      envmapSamplerUniform: "uEnvmapSampler",
      perlinSamplerUniform: "uPerlinSampler",
      materialShininessUniform: "uMaterialShininess",
      materialAmbientColorUniform: "uMaterialAmbientColor",
      materialDiffuseColorUniform: "uMaterialDiffuseColor",
      materialSpecularColorUniform: "uMaterialSpecularColor",
      useTexturesUniform: "uUseTextures",
      useEnvmapUniform: "uUseEnvmap",
      usePerlinUniform: "uUsePerlin",
      perlinScaleUniform: "uPerlinScale",
      perlinAmplitudeUniform: "uPerlinAmplitude",
      perlinOriginUniform: "uPerlinOrigin",
      ambientColorUniform: "uAmbientColor",
      light0DirectionUniform: "uLight0Direction",
      light0SpecularColorUniform: "uLight0SpecularColor",
      light0DiffuseColorUniform: "uLight0DiffuseColor",
      light1DirectionUniform: "uLight1Direction",
      light1SpecularColorUniform: "uLight1SpecularColor",
      light1DiffuseColorUniform: "uLight1DiffuseColor",
      useBadOrientationUniform: "uUseBadOrientation",
      badOrientationColorUniform: "uBadOrientationColor",
      cutColor: "cutColor",
      cutAxis: "cutAxis",
      doubleCut: "doubleCut",
      uDoubleCut: "uDoubleCut",
    }
  );
  // Load the HQ shaders
  this._programSSAO = this.loadShader(
    gl,
    "SSAO",
    {
      vertexAttribute: "position",
    },
    {
      ao_strength: "ao_strength",
      ao_scale_div_dmax: "ao_scale_div_dmax",
      ao_radius_div_scale: "ao_radius_div_scale",
      viewportSize: "viewportSize",
      noiseSampler: "uNoiseSampler",
      depthMap: "depthMap",
      viewportScale: "viewportScale",
    }
  );
  this._programBlur = this.loadShader(
    gl,
    "Blur",
    {
      vertexAttribute: "position",
    },
    {
      sampler: "uSampler",
      scale: "uScale",
    }
  );
  this._programBlurGauss = this.loadShader(
    gl,
    "BlurGauss",
    {
      vertexAttribute: "position",
    },
    {
      sampler: "uSampler",
      scale: "uScale",
      gammaGain: "uGammaGain",
    }
  );
  this._programDepthMap = this.loadShader(
    gl,
    "depthMap",
    {
      vertexAttribute: "position",
      normalAttribute: "normal",
    },
    {
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
      zBounds: "u_zBounds",
    }
  );
  this._programConstantColor = this.loadShader(
    gl,
    "constantColor",
    {
      vertexAttribute: "position",
    },
    {
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
      color: "color",
    }
  );
  this._programConstantColorCSGTest = this.loadShader(
    gl,
    "constantColorCSGTest",
    {
      vertexAttribute: "position",
    },
    {
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
      color: "color",
      csgMap: "csgMap",
      viewportScale: "viewportScale",
    }
  );
  this._programSingleTexture = this.loadShader(
    gl,
    "singleTexture",
    {
      vertexAttribute: "position",
      texCoord0Attribute: "uv",
    },
    {
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
      sampler: "sampler",
    }
  );
  this._programFlatTransparent = this.loadShader(
    gl,
    "flatTransparent",
    {
      vertexPositionAttribute: "aVertexPosition",
      vertexNormalAttribute: "aVertexNormal",
    },
    {
      projectionMatrix: "projectionMatrix",
      modelViewMatrix: "modelViewMatrix",
      normalMatrix: "normalMatrix",
      opacity: "uOpacity",
      materialAmbientColor: "uMaterialAmbientColor",
      materialDiffuseColor: "uMaterialDiffuseColor",
      ambientColor: "uAmbientColor",
      lightDirection1: "uLight0Direction",
      lightDiffuseColor1: "uLight0DiffuseColor",
      lightDirection2: "uLight1Direction",
      lightDiffuseColor2: "uLight1DiffuseColor",
    }
  );
  this._programUberShader = this.loadShader(
    gl,
    "UberShader",
    {
      vertexAttribute: "position",
      normalAttribute: "normal",
      colorAttribute: "color",
      texCoord0Attribute: "a_texture",
    },
    {
      cameraPos: "uCameraPos",
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
      normalMatrix: "normalMatrix",
      envmapSampler: "uEnvmapSampler",
      envmapBias: "uEnvmapBias",
      perlinSamplerUniform: "uPerlinSampler",
      usePerlinUniform: "uUsePerlin",
      perlinScaleUniform: "uPerlinScale",
      perlinAmplitudeUniform: "uPerlinAmplitude",
      perlinOriginUniform: "uPerlinOrigin",
      gaussAmplitude: "uGaussAmplitude",
      materialAmbientColor: "uMaterialAmbientColor",
      materialDiffuseColor: "uMaterialDiffuseColor",
      materialSpecularColor: "uMaterialSpecularColor",
      materialShininess: "uMaterialShininess",
      opacity: "uOpacity",
      ambientColor: "uAmbientColor",
      lightDirection1: "uLight1Direction",
      lightDiffuseColor1: "uLight1DiffuseColor",
      lightSpecularColor1: "uLight1SpecularColor",
      lightDirection2: "uLight2Direction",
      lightDiffuseColor2: "uLight2DiffuseColor",
      lightSpecularColor2: "uLight2SpecularColor",
      shadowMap: "shadowMap",
      lightModelviewProjMatrix: "lightModelviewProjMatrix",
      shadowMap2: "shadowMap2",
      lightModelviewProjMatrix2: "lightModelviewProjMatrix2",
      aoMap: "aoMap",
      csgMap: "csgMap",
      csgMode: "csgMode",
      uZBounds: "uZBounds",
      viewportScale: "viewportScale",
      renderType: "renderType",
      sampler: "uSampler",
    }
  );
  this._programCombineDM = this.loadShader(
    gl,
    "CombineDepthMap",
    {
      vertexAttribute: "position",
      texCoord0Attribute: "uv",
    },
    {
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
      sampler: "sampler",
      sampler2: "sampler2",
    }
  );
  this._programCopyDM = this.loadShader(
    gl,
    "CopyDepthMap",
    {
      vertexAttribute: "position",
      texCoord0Attribute: "uv",
    },
    {
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
    }
  );
  this._programCSGmax = this.loadShader(
    gl,
    "CSGmax",
    {
      vertexAttribute: "position",
      texCoord0Attribute: "uv",
    },
    {
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
      dimension_x: "dimension_x",
      dimension_y: "dimension_y",
      sampler: "sampler",
    }
  );
  this._programPBRShader = this.loadShader(
    gl,
    "PBRShader",
    {
      vertexAttribute: "position",
      normalAttribute: "normal",
      colorAttribute: "color",
      texCoord0Attribute: "a_texture",
    },
    {
      cameraPos: "uCameraPos",
      modelViewMatrix: "modelViewMatrix",
      projectionMatrix: "projectionMatrix",
      normalMatrix: "normalMatrix",
      envDiffSampler: "uEnvDiffSampler",
      envSpecSampler: "uEnvSpecSampler",
      envmapBias: "uEnvmapBias",
      perlinSamplerUniform: "uPerlinSampler",
      usePerlinUniform: "uUsePerlin",
      perlinScaleUniform: "uPerlinScale",
      perlinAmplitudeUniform: "uPerlinAmplitude",
      perlinOriginUniform: "uPerlinOrigin",
      materialFresnel0: "uMaterialFresnel0",
      materialDiffuseColor: "uMaterialDiffuseColor",
      materialSpecularColor: "uMaterialSpecularColor",
      materialRoughness: "uMaterialRoughness",
      materialGloss: "uMaterialGloss",
      // Opacity: "uOpacity",
      // ambientColor: "uAmbientColor",
      lightDirection1: "uLight1Direction",
      lightDiffuseColor1: "uLight1DiffuseColor",
      // LightSpecularColor1: "uLight1SpecularColor",
      lightDirection2: "uLight2Direction",
      lightDiffuseColor2: "uLight2DiffuseColor",
      // LightSpecularColor2: "uLight2SpecularColor",
      shadowMap: "shadowMap",
      lightModelviewProjMatrix: "lightModelviewProjMatrix",
      shadowMap2: "shadowMap2",
      lightModelviewProjMatrix2: "lightModelviewProjMatrix2",
      aoMap: "aoMap",
      csgMap: "csgMap",
      csgMode: "csgMode",
      uZBounds: "uZBounds",
      viewportScale: "viewportScale",
      renderType: "renderType",
      sampler: "uSampler",
    }
  );
  gl.useProgram(this.shaderProgram);
};
function nearestUpperPow2(v) {
  v--;
  v |= v >> 1;
  v |= v >> 2;
  v |= v >> 4;
  v |= v >> 8;
  v |= v >> 16;
  return v + 1;
}
Sculpteo3DViewerWebGL.prototype.initTextures = function (gl) {
  this._csgWidth = nearestUpperPow2(gl.viewportWidth);
  this._csgHeight = nearestUpperPow2(gl.viewportHeight);
  var noise_url = STATIC_URL + "images/noise.png";
  this.noise_texture = gl.createTexture();
  this.noise_texture.image = new Image();
  this.noise_texture.image.crossOrigin = "";
  var viewer = this;
  this.noise_texture.image.onload = function () {
    gl.bindTexture(gl.TEXTURE_2D, viewer.noise_texture);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texImage2D(
      gl.TEXTURE_2D,
      0,
      gl.RGBA,
      gl.RGBA,
      gl.UNSIGNED_BYTE,
      viewer.noise_texture.image
    );
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.bindTexture(gl.TEXTURE_2D, null);
  };
  this.noise_texture.image.src = noise_url;
  if (this.envmap_url) {
    this.envmap_texture = gl.createTexture();
    this.envmap_texture.image = new Image();
    this.envmap_texture.image.crossOrigin = "";
    this.envmap_texture.image.onload = function () {
      gl.bindTexture(gl.TEXTURE_2D, viewer.envmap_texture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(
        gl.TEXTURE_2D,
        0,
        gl.RGBA,
        gl.RGBA,
        gl.UNSIGNED_BYTE,
        viewer.envmap_texture.image
      );
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      if (viewer.experimental_envmap_lod) {
        gl.texParameteri(
          gl.TEXTURE_2D,
          gl.TEXTURE_MIN_FILTER,
          gl.LINEAR_MIPMAP_LINEAR
        );
        gl.generateMipmap(gl.TEXTURE_2D);
      } else {
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      }
      gl.bindTexture(gl.TEXTURE_2D, null);
    };
    this.envmap_texture.image.src = this.envmap_url;
  } else {
    this.envmap_texture = null;
  }
  if (this.cubemap_url) {
    this.cubemap_texture = gl.createTexture();
    this.cubemap_texture.image = new Image();
    this.cubemap_texture.image.crossOrigin = "";
    this.cubemap_texture.image.onload = function () {
      var iw = nearestUpperPow2(viewer.cubemap_texture.image.width);
      var ih = nearestUpperPow2(viewer.cubemap_texture.image.height);
      var envText = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, envText);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
      gl.texImage2D(
        gl.TEXTURE_2D,
        0,
        gl.RGBA,
        iw,
        ih,
        0,
        gl.RGBA,
        gl.UNSIGNED_BYTE,
        null
      );
      gl.texSubImage2D(
        gl.TEXTURE_2D,
        0,
        0,
        0,
        gl.RGBA,
        gl.UNSIGNED_BYTE,
        viewer.cubemap_texture.image
      );
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.bindTexture(gl.TEXTURE_2D, null);
      var ifb = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, ifb);
      gl.framebufferTexture2D(
        gl.FRAMEBUFFER,
        gl.COLOR_ATTACHMENT0,
        gl.TEXTURE_2D,
        envText,
        0
      );
      var canRead =
        gl.checkFramebufferStatus(gl.FRAMEBUFFER) == gl.FRAMEBUFFER_COMPLETE;
      gl.bindTexture(gl.TEXTURE_CUBE_MAP, viewer.cubemap_texture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
      gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
      if (canRead) {
        // Read the pixels
        var size = viewer.cubemap_texture.image.width / 6;
        var env_pos = [0, size];
        var mip_pos = [0, size * 2];
        var imgData = new Uint8Array(4 * size * size);
        var mip = 0;
        while (size > 0) {
          gl.readPixels(
            env_pos[0] + size * 0,
            env_pos[1],
            size,
            size,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.texImage2D(
            gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
            mip,
            gl.RGBA,
            size,
            size,
            0,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.readPixels(
            env_pos[0] + size * 1,
            env_pos[1],
            size,
            size,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.texImage2D(
            gl.TEXTURE_CUBE_MAP_POSITIVE_X,
            mip,
            gl.RGBA,
            size,
            size,
            0,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.readPixels(
            env_pos[0] + size * 2,
            env_pos[1],
            size,
            size,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.texImage2D(
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
            mip,
            gl.RGBA,
            size,
            size,
            0,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.readPixels(
            env_pos[0] + size * 3,
            env_pos[1],
            size,
            size,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.texImage2D(
            gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
            mip,
            gl.RGBA,
            size,
            size,
            0,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.readPixels(
            env_pos[0] + size * 4,
            env_pos[1],
            size,
            size,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.texImage2D(
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Z,
            mip,
            gl.RGBA,
            size,
            size,
            0,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.readPixels(
            env_pos[0] + size * 5,
            env_pos[1],
            size,
            size,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          gl.texImage2D(
            gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
            mip,
            gl.RGBA,
            size,
            size,
            0,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            imgData
          );
          if (mip == 0) {
            env_pos = mip_pos;
          } else {
            env_pos[0] += size * 6;
          }
          size = ~~(size / 2);
          mip++;
        }
        viewer.cubemap_texture.mip_levels = mip - 1;
        gl.texParameteri(
          gl.TEXTURE_CUBE_MAP,
          gl.TEXTURE_WRAP_S,
          gl.CLAMP_TO_EDGE
        );
        gl.texParameteri(
          gl.TEXTURE_CUBE_MAP,
          gl.TEXTURE_WRAP_T,
          gl.CLAMP_TO_EDGE
        );
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(
          gl.TEXTURE_CUBE_MAP,
          gl.TEXTURE_MIN_FILTER,
          gl.LINEAR_MIPMAP_LINEAR
        );
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
        env_pos = [0, 0];
        size = viewer.cubemap_texture.image.width / 6;
        viewer.cubemap_texture_diff = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, viewer.cubemap_texture_diff);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.readPixels(
          env_pos[0] + size * 0,
          env_pos[1],
          size,
          size,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.texImage2D(
          gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
          0,
          gl.RGBA,
          size,
          size,
          0,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.readPixels(
          env_pos[0] + size * 1,
          env_pos[1],
          size,
          size,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.texImage2D(
          gl.TEXTURE_CUBE_MAP_POSITIVE_X,
          0,
          gl.RGBA,
          size,
          size,
          0,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.readPixels(
          env_pos[0] + size * 2,
          env_pos[1],
          size,
          size,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.texImage2D(
          gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
          0,
          gl.RGBA,
          size,
          size,
          0,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.readPixels(
          env_pos[0] + size * 3,
          env_pos[1],
          size,
          size,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.texImage2D(
          gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
          0,
          gl.RGBA,
          size,
          size,
          0,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.readPixels(
          env_pos[0] + size * 4,
          env_pos[1],
          size,
          size,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.texImage2D(
          gl.TEXTURE_CUBE_MAP_NEGATIVE_Z,
          0,
          gl.RGBA,
          size,
          size,
          0,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.readPixels(
          env_pos[0] + size * 5,
          env_pos[1],
          size,
          size,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.texImage2D(
          gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
          0,
          gl.RGBA,
          size,
          size,
          0,
          gl.RGBA,
          gl.UNSIGNED_BYTE,
          imgData
        );
        gl.texParameteri(
          gl.TEXTURE_CUBE_MAP,
          gl.TEXTURE_WRAP_S,
          gl.CLAMP_TO_EDGE
        );
        gl.texParameteri(
          gl.TEXTURE_CUBE_MAP,
          gl.TEXTURE_WRAP_T,
          gl.CLAMP_TO_EDGE
        );
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
        // Unbind the framebuffer
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      }
    };
    this.cubemap_texture.image.src = this.cubemap_url;
  } else {
    this.cubemap_texture = null;
  }
  this.perlin_url = STATIC_URL + "images/perlin.png";
  if (this.perlin_url) {
    this.perlin = gl.createTexture();
    this.perlin.image = new Image();
    this.perlin.image.crossOrigin = "";
    var viewer = this;
    this.perlin.image.onload = function () {
      gl.bindTexture(gl.TEXTURE_2D, viewer.perlin);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(
        gl.TEXTURE_2D,
        0,
        gl.RGBA,
        gl.RGBA,
        gl.UNSIGNED_BYTE,
        viewer.perlin.image
      );
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.bindTexture(gl.TEXTURE_2D, null);
    };
    this.perlin.image.src = this.perlin_url;
  } else {
    this.perlin = null;
  }
  // Shadow depthmap for light 1 (RGBA)
  this._depthRenderBuffer = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, this._depthRenderBuffer);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._csgWidth,
    this._csgHeight,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Shadow depthmap for light 2 (RGBA)
  this._depthRenderBuffer2 = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, this._depthRenderBuffer2);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._csgWidth,
    this._csgHeight,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Depth map for AO
  this._depthMap = gl.createTexture();
  this._depthMap.width = this._csgWidth;
  this._depthMap.height = this._csgHeight;
  gl.bindTexture(gl.TEXTURE_2D, this._depthMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._depthMap.width,
    this._depthMap.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  // SSAO
  var SSAO_resolution = this.texture_size;
  this._aoMap = gl.createTexture();
  this._aoMap.width = SSAO_resolution;
  this._aoMap.height = SSAO_resolution;
  gl.bindTexture(gl.TEXTURE_2D, this._aoMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._aoMap.width,
    this._aoMap.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  // Gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER,
  // gl.LINEAR_MIPMAP_NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  this._blurMap = gl.createTexture();
  this._blurMap.width = SSAO_resolution;
  this._blurMap.height = SSAO_resolution;
  gl.bindTexture(gl.TEXTURE_2D, this._blurMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._blurMap.width,
    this._blurMap.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  this._selectMap = gl.createTexture();
  this._selectMap.width = this.texture_size;
  this._selectMap.height = this.texture_size;
  gl.bindTexture(gl.TEXTURE_2D, this._selectMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._selectMap.width,
    this._selectMap.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  this._selectBlurMap = gl.createTexture();
  this._selectBlurMap.width = this.texture_size;
  this._selectBlurMap.height = this.texture_size;
  gl.bindTexture(gl.TEXTURE_2D, this._selectBlurMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._selectBlurMap.width,
    this._selectBlurMap.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  // Combined shadow map of light 1 & 2
  this._combinedShadowMap = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, this._combinedShadowMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this.texture_size,
    this.texture_size,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Debug Map for counting the number of layers during the CSGmultiLayer computation
  this._debugMap = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, this._debugMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    nearestUpperPow2(gl.viewportWidth),
    nearestUpperPow2(gl.viewportHeight),
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  gl.bindTexture(gl.TEXTURE_2D, null);
  // Scratch Map for the csg pingpong buffer algorithm (Fake Triple Buffering)
  this._tmpMap = gl.createTexture();
  this._tmpMap.width = this._csgWidth;
  this._tmpMap.height = this._csgHeight;
  gl.bindTexture(gl.TEXTURE_2D, this._tmpMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._tmpMap.width,
    this._tmpMap.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Depth Map1 for the csg pingpong buffer algorithm
  this._DepthMap1 = gl.createTexture();
  this._DepthMap1.width = this._csgWidth;
  this._DepthMap1.height = this._csgHeight;
  gl.bindTexture(gl.TEXTURE_2D, this._DepthMap1);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._DepthMap1.width,
    this._DepthMap1.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Depth Map2 for the csg pingpong buffer algorithm
  this._DepthMap2 = gl.createTexture();
  this._DepthMap2.width = this._csgWidth;
  this._DepthMap2.height = this._csgHeight;
  gl.bindTexture(gl.TEXTURE_2D, this._DepthMap2);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._DepthMap2.width,
    this._DepthMap2.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Array for the PingPong algorithm
  this.pingPongBuffer = [this._DepthMap1, this._DepthMap2];
  this.PPCurrent = 0;
  gl.bindTexture(gl.TEXTURE_2D, null);
  // Building FBO used for the high quality render
  this._fboHighQuality = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboHighQuality);
  this._fboHighQuality.width = this.texture_size;
  this._fboHighQuality.height = this.texture_size;
  var renderbuffer = gl.createRenderbuffer();
  gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
  gl.renderbufferStorage(
    gl.RENDERBUFFER,
    gl.DEPTH_STENCIL,
    this._fboHighQuality.width,
    this._fboHighQuality.height
  );
  gl.framebufferRenderbuffer(
    gl.FRAMEBUFFER,
    gl.DEPTH_STENCIL_ATTACHMENT,
    gl.RENDERBUFFER,
    renderbuffer
  );
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._aoMap,
    0
  );
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clearStencil(0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
  // Build FBO for the CSG render (must have same size as the screen)
  this._fboCSG = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  this._fboCSG.width = nearestUpperPow2(gl.viewportWidth);
  this._fboCSG.height = nearestUpperPow2(gl.viewportHeight);
  var renderbuffer = gl.createRenderbuffer();
  gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
  gl.renderbufferStorage(
    gl.RENDERBUFFER,
    gl.DEPTH_STENCIL,
    this._fboCSG.width,
    this._fboCSG.height
  );
  gl.framebufferRenderbuffer(
    gl.FRAMEBUFFER,
    gl.DEPTH_STENCIL_ATTACHMENT,
    gl.RENDERBUFFER,
    renderbuffer
  );
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._depthMap,
    0
  );
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clearStencil(0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
  gl.bindRenderbuffer(gl.RENDERBUFFER, null);
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  // Some fixed VBOs for quads
  var vertexPositionsTexCoords = [
    -1.0, -1.0, 1.0, 0.0, 0.0, 1.0, -1.0, 1.0, 1.0, 0.0, -1.0, 1.0, 1.0, 0.0,
    1.0, -1.0, 1.0, 1.0, 0.0, 1.0, 1.0, -1.0, 1.0, 1.0, 0.0, 1.0, 1.0, 1.0, 1.0,
    1.0,
  ];
  this._quadPositionBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, this._quadPositionBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(vertexPositionsTexCoords),
    gl.DYNAMIC_DRAW
  );
};
Sculpteo3DViewerWebGL.prototype.updateTextures = function () {
  var gl = this.gl;
  this._csgWidth = nearestUpperPow2(gl.viewportWidth);
  this._csgHeight = nearestUpperPow2(gl.viewportHeight);
  // Noise Texture, envmap, cubemap and perlin ( Don't need to be updated )
  // Shadow depthmap for light 1 (RGBA)
  gl.deleteTexture(this._depthRenderBuffer);
  this._depthRenderBuffer = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, this._depthRenderBuffer);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._csgWidth,
    this._csgHeight,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Shadow depthmap for light 2 (RGBA)
  gl.deleteTexture(this._depthRenderBuffer2);
  this._depthRenderBuffer2 = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, this._depthRenderBuffer2);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._csgWidth,
    this._csgHeight,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Depth map for AO
  gl.deleteTexture(this._depthMap);
  this._depthMap = gl.createTexture();
  this._depthMap.width = this._csgWidth;
  this._depthMap.height = this._csgHeight;
  gl.bindTexture(gl.TEXTURE_2D, this._depthMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._depthMap.width,
    this._depthMap.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  // SSAO ( Don't need to be updated )
  // Combined shadow map of light 1 & 2
  gl.deleteTexture(this._combinedShadowMap);
  this._combinedShadowMap = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, this._combinedShadowMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this.texture_size,
    this.texture_size,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Debug Map for counting the number of layers during the CSGmultiLayer computation
  /*this._debugMap = gl.createTexture();
	gl.bindTexture(gl.TEXTURE_2D, this._debugMap);
	gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, nearestUpperPow2(gl.viewportWidth), nearestUpperPow2(gl.viewportHeight), 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	gl.bindTexture(gl.TEXTURE_2D, null);*/
  // Scratch Map for the csg pingpong buffer algorithm (Fake Triple Buffering)
  gl.deleteTexture(this._tmpMap);
  this._tmpMap = gl.createTexture();
  this._tmpMap.width = this._csgWidth;
  this._tmpMap.height = this._csgHeight;
  gl.bindTexture(gl.TEXTURE_2D, this._tmpMap);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._tmpMap.width,
    this._tmpMap.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Depth Map1 for the csg pingpong buffer algorithm
  gl.deleteTexture(this._DepthMap1);
  this._DepthMap1 = gl.createTexture();
  this._DepthMap1.width = this._csgWidth;
  this._DepthMap1.height = this._csgHeight;
  gl.bindTexture(gl.TEXTURE_2D, this._DepthMap1);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._DepthMap1.width,
    this._DepthMap1.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Depth Map2 for the csg pingpong buffer algorithm
  gl.deleteTexture(this._DepthMap2);
  this._DepthMap2 = gl.createTexture();
  this._DepthMap2.width = this._csgWidth;
  this._DepthMap2.height = this._csgHeight;
  gl.bindTexture(gl.TEXTURE_2D, this._DepthMap2);
  gl.texImage2D(
    gl.TEXTURE_2D,
    0,
    gl.RGBA,
    this._DepthMap2.width,
    this._DepthMap2.height,
    0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    null
  );
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  // Array for the PingPong algorithm
  this.pingPongBuffer = [this._DepthMap1, this._DepthMap2];
  this.PPCurrent = 0;
  gl.bindTexture(gl.TEXTURE_2D, null);
  // Building FBO used for the high quality render
  if (gl.isFramebuffer(this._fboHighQuality))
    gl.deleteFramebuffer(this._fboHighQuality);
  this._fboHighQuality = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboHighQuality);
  this._fboHighQuality.width = this.texture_size;
  this._fboHighQuality.height = this.texture_size;
  if (gl.isRenderbuffer(renderbuffer)) gl.deleteRenderbuffer(renderbuffer);
  var renderbuffer = gl.createRenderbuffer();
  gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
  gl.renderbufferStorage(
    gl.RENDERBUFFER,
    gl.DEPTH_STENCIL,
    this._fboHighQuality.width,
    this._fboHighQuality.height
  );
  gl.framebufferRenderbuffer(
    gl.FRAMEBUFFER,
    gl.DEPTH_STENCIL_ATTACHMENT,
    gl.RENDERBUFFER,
    renderbuffer
  );
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._aoMap,
    0
  );
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clearStencil(0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
  // Build FBO for the CSG render (must have same size as the screen)
  if (gl.isFramebuffer(this._fboCSG)) gl.deleteFramebuffer(this._fboCSG);
  this._fboCSG = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  this._fboCSG.width = nearestUpperPow2(gl.viewportWidth);
  this._fboCSG.height = nearestUpperPow2(gl.viewportHeight);
  if (gl.isRenderbuffer(renderbuffer)) gl.deleteRenderbuffer(renderbuffer);
  var renderbuffer = gl.createRenderbuffer();
  gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
  gl.renderbufferStorage(
    gl.RENDERBUFFER,
    gl.DEPTH_STENCIL,
    this._fboCSG.width,
    this._fboCSG.height
  );
  gl.framebufferRenderbuffer(
    gl.FRAMEBUFFER,
    gl.DEPTH_STENCIL_ATTACHMENT,
    gl.RENDERBUFFER,
    renderbuffer
  );
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._depthMap,
    0
  );
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clearStencil(0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
  gl.bindRenderbuffer(gl.RENDERBUFFER, null);
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  // Some fixed VBOs for quads
  var vertexPositionsTexCoords = [
    -1.0, -1.0, 1.0, 0.0, 0.0, 1.0, -1.0, 1.0, 1.0, 0.0, -1.0, 1.0, 1.0, 0.0,
    1.0, -1.0, 1.0, 1.0, 0.0, 1.0, 1.0, -1.0, 1.0, 1.0, 0.0, 1.0, 1.0, 1.0, 1.0,
    1.0,
  ];
  if (gl.isBuffer(this._quadPositionBuffer))
    gl.deleteBuffer(this._quadPositionBuffer);
  this._quadPositionBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, this._quadPositionBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(vertexPositionsTexCoords),
    gl.DYNAMIC_DRAW
  );
};

Sculpteo3DViewerWebGL.prototype.makeOrtho = function (
  left,
  right,
  bottom,
  top,
  znear,
  zfar
) {
  var tx = -(right + left) / (right - left);
  var ty = -(top + bottom) / (top - bottom);
  var tz = -(zfar + znear) / (zfar - znear);
  return new Sculpteo3DViewerCommonTransform3D([
    2 / (right - left),
    0,
    0,
    tx,
    0,
    2 / (top - bottom),
    0,
    ty,
    0,
    0,
    -2 / (zfar - znear),
    tz,
    0,
    0,
    0,
    1,
  ]);
};
Sculpteo3DViewerWebGL.prototype.frustum = function (
  left,
  right,
  bottom,
  top,
  near,
  far
) {
  var A = (right + left) / (right - left);
  var B = (top + bottom) / (top - bottom);
  var C = -(far + near) / (far - near);
  var D = -(2 * far * near) / (far - near);
  return new Sculpteo3DViewerCommonTransform3D([
    (2 * near) / (right - left),
    0,
    0,
    0,
    0,
    (2 * near) / (top - bottom),
    0,
    0,
    A,
    B,
    C,
    D,
    0,
    0,
    -1,
    0,
  ]);
};
Sculpteo3DViewerWebGL.prototype.makePerspective = function (
  fovy,
  aspect,
  zNear,
  zFar
) {
  var radians = ((fovy / 2) * Math.PI) / 180;
  var deltaZ = zFar - zNear;
  var sine = Math.sin(radians);
  if (deltaZ == 0 || sine == 0 || aspect == 0) {
    return null;
  }
  var cotangent = Math.cos(radians) / sine;
  return new Sculpteo3DViewerCommonTransform3D([
    cotangent / aspect,
    0,
    0,
    0,
    0,
    cotangent,
    0,
    0,
    0,
    0,
    -(zFar + zNear) / deltaZ,
    (-2 * zNear * zFar) / deltaZ,
    0,
    0,
    -1,
    0,
  ]);
  /*
	Var top = Math.tan(fovy * Math.PI / 360) * zNear;
	var bottom = -top;
	var left = aspect * bottom;
	var right = aspect * top;
	return this.frustum(left, right, bottom, top, zNear, zFar);
	*/
};
Sculpteo3DViewerWebGL.prototype.mvLoadIdentity = function () {
  this.mvMatrix = new Sculpteo3DViewerCommonTransform3D();
};
Sculpteo3DViewerWebGL.prototype.multMatrix = function (m) {
  this.mvMatrix = this.mvMatrix.x(m);
};
Sculpteo3DViewerWebGL.prototype.mvTranslate = function (v) {
  var m = Sculpteo3DViewerCommonTransform3D.translation(v[0], v[1], v[2]);
  this.multMatrix(m);
};
Sculpteo3DViewerWebGL.prototype.mvRotate = function (angle, v) {
  var arad = (angle * Math.PI) / 180.0;
  var m = Sculpteo3DViewerCommonTransform3D.rotation(arad, v[0], v[1], v[2]);
  this.multMatrix(m);
};
Sculpteo3DViewerWebGL.prototype.mvScale = function (v) {
  var m = Sculpteo3DViewerCommonTransform3D.scale(v[0], v[1], v[2]);
  this.multMatrix(m);
};
Sculpteo3DViewerWebGL.prototype.setMatrixUniforms = function (gl) {
  gl.uniformMatrix4fv(
    this.shaderProgram.pMatrixUniform,
    false,
    this.pMatrix.toFloat32Array()
  );
  gl.uniformMatrix4fv(
    this.shaderProgram.mvMatrixUniform,
    false,
    this.mvMatrix.toFloat32Array()
  );
  var normalMatrix = this.mvMatrix.inverse();
  normalMatrix = normalMatrix.transpose();
  gl.uniformMatrix4fv(
    this.shaderProgram.nMatrixUniform,
    false,
    normalMatrix.toFloat32Array()
  );
};
Sculpteo3DViewerWebGL.prototype._setNode = function (node) {
  if (typeof node.operation != "undefined") {
    this._setNode(node.A);
    this._setNode(node.B);
  } else {
    var mesh = node;
    mesh.material_count = mesh.material.length;
    mesh.vertex_count = mesh.v.length;
    mesh.face_count = mesh.f.length;
    model = this.buildModel(mesh, function () {});
    log(model.vbos);
    this.nodes.push(new Sculpteo3DViewerCommonNode(model.vbos));
    this.setUpdate(true);
  }
};
Sculpteo3DViewerWebGL.prototype.setScene = function (root) {
  log("setScene called");
  log(root);
  // Just recurse and add all the meshes until we have full CSG support
  this.nodes = [];
  this._setNode(root);
};
Sculpteo3DViewerWebGL.prototype.setTexture = function (img, index) {
  var createTextureFromImage = function (image) {
    var isPowerOfTwo = function (x) {
      return (x & (x - 1)) == 0;
    };
    var nextHighestPowerOfTwo = function (x) {
      --x;
      for (var i = 1; i < 32; i <<= 1) {
        x = x | (x >> i);
      }
      return x + 1;
    };
    if (!isPowerOfTwo(image.width) || !isPowerOfTwo(image.height)) {
      // Scale up the texture to the next highest power of two dimensions.
      var canvas = document.createElement("canvas");
      canvas.width = nextHighestPowerOfTwo(image.width);
      canvas.height = nextHighestPowerOfTwo(image.height);
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      image = canvas;
    }
    return image;
  };
  // Get main model node
  var node = this.scene.nodes["model"];
  if (typeof node == "undefined") {
    return;
  }
  var vbos = node.model;
  if (!vbos) {
    return;
  }
  var image, material;
  if (typeof img == "undefined") {
    return;
  }
  if (typeof img == "object") {
    // Assume img is a loaded Image DOM element
    image = createTextureFromImage(img);
    image.loaded = true;
  } else {
    // Assume img is a url
    image = new Image(); // This is just a proxy, it will be replaced
    image.loaded = false;
    var tmpimg = new Image();
    tmpimg.crossOrigin = "";
    var viewer = this;
    tmpimg.onload = function () {
      material.texture = createTextureFromImage(tmpimg);
      material.texture.loaded = true;
      viewer.update = true;
    };
    tmpimg.src = img;
  }
  material = {
    texture: image,
  };
  if (typeof index == "undefined") {
    // No specific material, set them all
    // TODO: split in two and set only on uvmapped faces?
    for (var vbi = 0; vbi < vbos.length; vbi++) {
      vbos[vbi].material = material;
    }
  } else {
    for (var vbi = 0; vbi < vbos.length; vbi++) {
      if (vbos[vbi].mi == index) {
        vbos[vbi].material = material;
        break;
      }
    }
  }
};

function buildVbo(
  gl,
  mesh,
  faces,
  mi,
  gi,
  material_to_vcolor,
  vsn,
  invert_normal,
  normal_offset
) {
  var t = new Triangle();
  var vertexNormals = [];
  var vertexTextureCoords = [];
  var vertexColors = [];
  var vertexPositions = [];
  var edgePositions = [];
  var borderPositions = [];
  var nmedgePositions = [];
  var nmvertexPositions = [];
  var selectedPositions = [];
  var vertexAttributes = [];
  var overhangVertices = [];

  var _count = 0;
  var _mi = mi;

  for (var j = 0; j < faces.length; j++) {
    i = faces[j];
    var v0, v1, v2;

    if (invert_normal) {
      v2 = mesh.f[3 * i + 0];
      v1 = mesh.f[3 * i + 1];
      v0 = mesh.f[3 * i + 2];
    } else {
      v0 = mesh.f[3 * i + 0];
      v1 = mesh.f[3 * i + 1];
      v2 = mesh.f[3 * i + 2];
    }

    t.ax = mesh.v[3 * v0 + 0];
    t.ay = mesh.v[3 * v0 + 1];
    t.az = mesh.v[3 * v0 + 2];
    t.bx = mesh.v[3 * v1 + 0];
    t.by = mesh.v[3 * v1 + 1];
    t.bz = mesh.v[3 * v1 + 2];
    t.cx = mesh.v[3 * v2 + 0];
    t.cy = mesh.v[3 * v2 + 1];
    t.cz = mesh.v[3 * v2 + 2];

    // Log("Decoded facet = (" + t.ax + "," + t.ay + "," +t.az+")," +
    // "(" + t.bx + "," + t.by + "," +t.bz+")," +
    // "(" + t.cx + "," + t.cy + "," +t.cz+")");

    // Compute triangle normal
    var ux, uy, uz;
    var vx, vy, vz;

    ux = t.bx - t.ax;
    uy = t.by - t.ay;
    uz = t.bz - t.az;

    vx = t.cx - t.ax;
    vy = t.cy - t.ay;
    vz = t.cz - t.az;

    var wx, wy, wz;

    wx = t.cx - t.bx;
    wy = t.cy - t.by;
    wz = t.cz - t.bz;

    var nx = uy * vz - uz * vy;
    var ny = uz * vx - ux * vz;
    var nz = ux * vy - uy * vx;

    var lu2 = ux * ux + uy * uy + uz * uz;
    var lv2 = vx * vx + vy * vy + vz * vz;
    var lw2 = wx * wx + wy * wy + wz * wz;

    var w = lu2 * lv2;
    var w1 = lu2 * lw2;
    var w2 = lv2 * lw2;

    if (w > 0.0) {
      w = 1.0 / w;
      w1 = 1.0 / w1;
      w2 = 1.0 / w2;
      if (vsn) {
        vsn[3 * v0 + 0] += nx * w;
        vsn[3 * v0 + 1] += ny * w;
        vsn[3 * v0 + 2] += nz * w;
        vsn[3 * v1 + 0] += nx * w1;
        vsn[3 * v1 + 1] += ny * w1;
        vsn[3 * v1 + 2] += nz * w1;
        vsn[3 * v2 + 0] += nx * w2;
        vsn[3 * v2 + 1] += ny * w2;
        vsn[3 * v2 + 2] += nz * w2;
      }
    }

    var len = Math.sqrt(nx * nx + ny * ny + nz * nz);

    if (len == 0.0) {
      t.nx = t.ny = t.nz = 0.0;
    } else {
      t.nx = nx / len;
      t.ny = ny / len;
      t.nz = nz / len;
    }

    if (normal_offset) {
      t.ax -= normal_offset * nx;
      t.ay -= normal_offset * ny;
      t.az -= normal_offset * nz;
      t.bx -= normal_offset * nx;
      t.by -= normal_offset * ny;
      t.bz -= normal_offset * nz;
      t.cx -= normal_offset * nx;
      t.cy -= normal_offset * ny;
      t.cz -= normal_offset * nz;
    }

    vertexPositions.push(t.ax, t.ay, t.az, t.bx, t.by, t.bz, t.cx, t.cy, t.cz);
    vertexNormals.push(t.nx, t.ny, t.nz, t.nx, t.ny, t.nz, t.nx, t.ny, t.nz);

    if (mi == -1) {
      if (mesh.vcolor) {
        var m0 = mesh.material[mesh.vcolor[v0]];
        var m1 = mesh.material[mesh.vcolor[v1]];
        var m2 = mesh.material[mesh.vcolor[v2]];

        if (m0 && m1 && m2 && m0.color && m1.color && m2.color) {
          vertexColors.push(
            m0.color.r / 255.0,
            m0.color.g / 255.0,
            m0.color.b / 255.0,
            m1.color.r / 255.0,
            m1.color.g / 255.0,
            m1.color.b / 255.0,
            m2.color.r / 255.0,
            m2.color.g / 255.0,
            m2.color.b / 255.0
          );
        } else {
          vertexColors.push(1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0);
        }
      } else if (material_to_vcolor) {
        var mat = mesh.material[mesh.face_mi[i]];

        if (!mat) {
          mat = { color: { r: 255.0, g: 255.0, b: 255.0 } };
        }

        vertexColors.push(
          mat.color.r / 255.0,
          mat.color.g / 255.0,
          mat.color.b / 255.0,
          mat.color.r / 255.0,
          mat.color.g / 255.0,
          mat.color.b / 255.0,
          mat.color.r / 255.0,
          mat.color.g / 255.0,
          mat.color.b / 255.0
        );
      }
    }

    var uv = [0.0, 0.0, 0.0, 0.0, 0.0, 0.0];

    if (flags & Mesh.FACEINFO_TEXCOORD) {
      uv = [
        mesh.face_uv[6 * i + 0],
        mesh.face_uv[6 * i + 1],
        mesh.face_uv[6 * i + 2],
        mesh.face_uv[6 * i + 3],
        mesh.face_uv[6 * i + 4],
        mesh.face_uv[6 * i + 5],
      ];
    }

    vertexTextureCoords.push(uv[0], uv[1], uv[2], uv[3], uv[4], uv[5]);

    edgePositions.push(
      t.ax,
      t.ay,
      t.az,
      t.bx,
      t.by,
      t.bz,
      t.bx,
      t.by,
      t.bz,
      t.cx,
      t.cy,
      t.cz,
      t.cx,
      t.cy,
      t.cz,
      t.ax,
      t.ay,
      t.az
    );

    var flags = mesh.face_flag[i];

    if (flags & Mesh.FACEINFO_SELECTED) {
      selectedPositions.push(
        t.ax,
        t.ay,
        t.az,
        t.bx,
        t.by,
        t.bz,
        t.bx,
        t.by,
        t.bz,
        t.cx,
        t.cy,
        t.cz,
        t.cx,
        t.cy,
        t.cz,
        t.ax,
        t.ay,
        t.az
      );
    }

    if (flags & Mesh.FACEINFO_E0_BORDER) {
      borderPositions.push(t.ax, t.ay, t.az, t.bx, t.by, t.bz);
    }

    if (flags & Mesh.FACEINFO_E1_BORDER) {
      borderPositions.push(t.bx, t.by, t.bz, t.cx, t.cy, t.cz);
    }

    if (flags & Mesh.FACEINFO_E2_BORDER) {
      borderPositions.push(t.cx, t.cy, t.cz, t.ax, t.ay, t.az);
    }

    if (flags & Mesh.FACEINFO_E0_NON_MANIFOLD) {
      nmedgePositions.push(t.ax, t.ay, t.az, t.bx, t.by, t.bz);
    }

    if (flags & Mesh.FACEINFO_E1_NON_MANIFOLD) {
      nmedgePositions.push(t.bx, t.by, t.bz, t.cx, t.cy, t.cz);
    }

    if (flags & Mesh.FACEINFO_E2_NON_MANIFOLD) {
      nmedgePositions.push(t.cx, t.cy, t.cz, t.ax, t.ay, t.az);
    }

    if (flags & Mesh.FACEINFO_V0_NON_MANIFOLD) {
      nmvertexPositions.push(t.ax, t.ay, t.az);
    }

    if (flags & Mesh.FACEINFO_V1_NON_MANIFOLD) {
      nmvertexPositions.push(t.bx, t.by, t.bz);
    }

    if (flags & Mesh.FACEINFO_V2_NON_MANIFOLD) {
      nmvertexPositions.push(t.cx, t.cy, t.cz);
    }

    if (flags & Mesh.FACEINFO_V0_OVERHANG) {
      overhangVertices.push(v0);
    }

    if (flags & Mesh.FACEINFO_V1_OVERHANG) {
      overhangVertices.push(v1);
    }

    if (flags & Mesh.FACEINFO_V2_OVERHANG) {
      overhangVertices.push(v2);
    }
  }

  var _modelVertexPositionBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, _modelVertexPositionBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(vertexPositions),
    gl.STATIC_DRAW
  );
  _modelVertexPositionBuffer.itemSize = 3;
  _modelVertexPositionBuffer.numItems = vertexPositions.length / 3;

  var _modelVertexTextureCoordBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, _modelVertexTextureCoordBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(vertexTextureCoords),
    gl.STATIC_DRAW
  );
  _modelVertexTextureCoordBuffer.itemSize = 2;
  _modelVertexTextureCoordBuffer.numItems = vertexTextureCoords.length / 2;

  var _modelVertexNormalBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, _modelVertexNormalBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(vertexNormals),
    gl.STATIC_DRAW
  );
  _modelVertexNormalBuffer.itemSize = 3;
  _modelVertexNormalBuffer.numItems = vertexNormals.length / 3;

  var _modelEdgePositionBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, _modelEdgePositionBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(edgePositions),
    gl.STATIC_DRAW
  );
  _modelEdgePositionBuffer.itemSize = 3;
  _modelEdgePositionBuffer.numItems = edgePositions.length / 3;

  var _modelSelectedPositionBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, _modelSelectedPositionBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(selectedPositions),
    gl.STATIC_DRAW
  );
  _modelSelectedPositionBuffer.itemSize = 3;
  _modelSelectedPositionBuffer.numItems = selectedPositions.length / 3;

  var _modelBorderPositionBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, _modelBorderPositionBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(borderPositions),
    gl.STATIC_DRAW
  );
  _modelBorderPositionBuffer.itemSize = 3;
  _modelBorderPositionBuffer.numItems = borderPositions.length / 3;

  var _modelNMEdgePositionBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, _modelNMEdgePositionBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(nmedgePositions),
    gl.STATIC_DRAW
  );
  _modelNMEdgePositionBuffer.itemSize = 3;
  _modelNMEdgePositionBuffer.numItems = nmedgePositions.length / 3;

  var _modelNMVertexPositionBuffer = gl.createBuffer();

  gl.bindBuffer(gl.ARRAY_BUFFER, _modelNMVertexPositionBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array(nmvertexPositions),
    gl.STATIC_DRAW
  );
  _modelNMVertexPositionBuffer.itemSize = 3;
  _modelNMVertexPositionBuffer.numItems = nmvertexPositions.length / 3;

  var mat = mi >= 0 ? mesh.material[mi] : undefined;
  var d = {
    material: mat,
    mi: mi,
    group: gi >= 0 ? mesh.group[gi] : undefined,
    gi: gi,
    positions: _modelVertexPositionBuffer,
    texcoords: _modelVertexTextureCoordBuffer,
    normals: _modelVertexNormalBuffer,
    edges: _modelEdgePositionBuffer,
    selected_edges: _modelSelectedPositionBuffer,
    border_edges: _modelBorderPositionBuffer,
    non_manifold_edges: _modelNMEdgePositionBuffer,
    non_manifold_vertices: _modelNMVertexPositionBuffer,
    overhang_vertices: overhangVertices,
    face_count: faces.length,
  };

  if (vertexColors.length) {
    var _modelVertexColorBuffer = gl.createBuffer();

    gl.bindBuffer(gl.ARRAY_BUFFER, _modelVertexColorBuffer);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array(vertexColors),
      gl.STATIC_DRAW
    );
    _modelVertexColorBuffer.itemSize = 3;
    _modelVertexColorBuffer.numItems = vertexColors.length / 3;
    d["colors"] = _modelVertexColorBuffer;
  }

  return d;
}

Sculpteo3DViewerWebGL.prototype.buildModel = function (
  mesh,
  done,
  error,
  abort
) {
  var gl = this.gl;
  if (!gl) {
    return;
  }

  var vsn = [];
  var t = new Triangle();
  for (var i = 0; i < mesh.vertex_count; i++) {
    vsn[3 * i + 0] = 0.0;
    vsn[3 * i + 1] = 0.0;
    vsn[3 * i + 2] = 0.0;
  }
  var material_to_vcolor = false;
  var i, mi;
  // FIXME: Dirty hack to avoid having thousands of vertex buffers, one for each face by
  // converting each material to vertex color
  if (
    mesh.material_count > 10 &&
    mesh.material_count > mesh.face_count / 100 &&
    !mesh.vcolor
  ) {
    material_to_vcolor = true;
    for (mi = 0; mi < mesh.material_count; mi++) {
      if (mesh.material[mi] && !mesh.material[mi].color) {
        material_to_vcolor = false;
        break;
      }
    }
  }
  // If model has both per-vertex color and per-face color, prefer per-vertex color
  if (mesh.vcolor) {
    for (var i = 0; i < mesh.face_count; i++) {
      var v0 = mesh.f[3 * i + 0];
      var v1 = mesh.f[3 * i + 1];
      var v2 = mesh.f[3 * i + 2];
      var m0 = mesh.material[mesh.vcolor[v0]];
      var m1 = mesh.material[mesh.vcolor[v1]];
      var m2 = mesh.material[mesh.vcolor[v2]];
      if (m0 && m1 && m2 && m0.color && m1.color && m2.color) {
        mesh.face_mi[i] = -1;
      }
    }
  }
  // Build one vertex index buffer per material
  var model = { vbos: [], curves: [], leaders: [] };
  var i, mi;
  var map = {};
  var use_features =
    this.use_features || !(mesh.group_count && mesh.group_count > 0);
  // FIXME disable feature for now to use groups (only if the mesh contains overhangs)
  if (mesh.content & Mesh.SVM_CONTENT_OVERHANG) {
    use_features = false;
  }
  if (use_features) mesh.group = mesh.features;

  for (var i = 0; i < mesh.face_count; i++) {
    var mi = mesh.face_mi[i];
    if (material_to_vcolor) {
      mi = -1;
    }
    if (!map[mi + 1]) {
      map[mi + 1] = {};
    }
    var gi = mesh.face_gi ? mesh.face_gi[i] : -1;
    var feat_i = mesh.feature_map ? mesh.feature_map[i] : -1;
    if (use_features) gi = feat_i;

    if (!map[mi + 1][gi + 1]) {
      map[mi + 1][gi + 1] = [i];
    } else {
      map[mi + 1][gi + 1].push(i);
    }
  }

  mesh.group_count = mesh.group_count || 0;
  var group_count = mesh.group_count;
  if (use_features) group_count = mesh.n_feature || 0;
  for (mi = -1; mi < mesh.material_count; mi++) {
    if (!map[mi + 1]) {
      continue;
    }
    for (gi = -1; gi < group_count; gi++) {
      if (!map[mi + 1][gi + 1]) {
        continue;
      }
      // if support vbo, add twice with different normal orientations
      if (gi > -1 && mesh.group[gi].name === "support") {
        var normal_offset = undefined;
        var d = buildVbo(
          gl,
          mesh,
          map[mi + 1][gi + 1],
          mi,
          gi,
          material_to_vcolor,
          undefined,
          true,
          normal_offset
        );
        var e = buildVbo(
          gl,
          mesh,
          map[mi + 1][gi + 1],
          mi,
          gi,
          material_to_vcolor,
          vsn,
          false,
          normal_offset
        );
        d.is_support = true;
        e.is_support = true;
        model.vbos.push(d);
        model.vbos.push(e);
      } else {
        var d = buildVbo(
          gl,
          mesh,
          map[mi + 1][gi + 1],
          mi,
          gi,
          material_to_vcolor,
          vsn
        );
        model.vbos.push(d);
      }
    }
  }

  // Renormalize vertex normals
  for (var i = 0; i < mesh.vertex_count; i++) {
    var len = Math.sqrt(
      vsn[3 * i + 0] * vsn[3 * i + 0] +
        vsn[3 * i + 1] * vsn[3 * i + 1] +
        vsn[3 * i + 2] * vsn[3 * i + 2]
    );
    if (len != 0.0) {
      len = 1.0 / len;
      vsn[3 * i + 0] *= len;
      vsn[3 * i + 1] *= len;
      vsn[3 * i + 2] *= len;
    }
  }
  var k = 0;
  for (mi = -1; mi < mesh.material_count; mi++) {
    if (!map[mi + 1]) {
      continue;
    }
    for (gi = -1; gi < group_count; gi++) {
      if (!map[mi + 1][gi + 1]) {
        continue;
      }
      var vertexSmoothNormals = [];
      for (var j in map[mi + 1][gi + 1]) {
        i = map[mi + 1][gi + 1][j];
        var v0, v1, v2;
        v0 = mesh.f[3 * i + 0];
        v1 = mesh.f[3 * i + 1];
        v2 = mesh.f[3 * i + 2];

        vertexSmoothNormals.push(
          vsn[3 * v0 + 0],
          vsn[3 * v0 + 1],
          vsn[3 * v0 + 2],
          vsn[3 * v1 + 0],
          vsn[3 * v1 + 1],
          vsn[3 * v1 + 2],
          vsn[3 * v2 + 0],
          vsn[3 * v2 + 1],
          vsn[3 * v2 + 2]
        );
      }
      var _modelVertexSmoothNormalBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, _modelVertexSmoothNormalBuffer);
      gl.bufferData(
        gl.ARRAY_BUFFER,
        new Float32Array(vertexSmoothNormals),
        gl.STATIC_DRAW
      );
      _modelVertexSmoothNormalBuffer.itemSize = 3;
      _modelVertexSmoothNormalBuffer.numItems = vertexSmoothNormals.length / 3;
      model.vbos[k].smooth_normals = _modelVertexSmoothNormalBuffer;
      k++;
    }
  }
  // save overhang vertices
  for (var vbi = 0; vbi < model.vbos.length; vbi++) {
    var vbo = model.vbos[vbi];
    if (!vbo.overhang_vertices || vbo.overhang_vertices.length == 0) continue;
    var overhangVertexPositions = [];
    var overhangVertexNormals = [];
    for (var v = 0; v < vbo.overhang_vertices.length; v++) {
      var vi = vbo.overhang_vertices[v];
      overhangVertexPositions.push(
        mesh.v[3 * vi + 0],
        mesh.v[3 * vi + 1],
        mesh.v[3 * vi + 2]
      );
      overhangVertexNormals.push(
        vsn[3 * vi + 0],
        vsn[3 * vi + 1],
        vsn[3 * vi + 2]
      );
    }
    var _modelOverhangVertexPositionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, _modelOverhangVertexPositionBuffer);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array(overhangVertexPositions),
      gl.STATIC_DRAW
    );
    _modelOverhangVertexPositionBuffer.itemSize = 3;
    _modelOverhangVertexPositionBuffer.numItems =
      overhangVertexPositions.length / 3;
    var _modelOverhangVertexNormalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, _modelOverhangVertexNormalBuffer);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array(overhangVertexNormals),
      gl.STATIC_DRAW
    );
    _modelOverhangVertexNormalBuffer.itemSize = 3;
    _modelOverhangVertexNormalBuffer.numItems =
      overhangVertexNormals.length / 3;

    vbo.overhang_vertex_positions = _modelOverhangVertexPositionBuffer;
    vbo.overhang_vertex_normals = _modelOverhangVertexNormalBuffer;
  }

  // Log("total faces " + mesh.face_count);
  // log("#vbos:" + model.vbos.length);
  // Convert curves
  var ci;
  for (ci = 0; ci < mesh.curve_count; ci++) {
    var edgePositions = [];
    var i;
    for (var i = 0; i < mesh.curve_vn[ci] - 1; i++) {
      var v0, v1;
      v0 = mesh.curve[ci][i];
      v1 = mesh.curve[ci][i + 1];
      edgePositions.push(
        mesh.v[3 * v0 + 0],
        mesh.v[3 * v0 + 1],
        mesh.v[3 * v0 + 2],
        mesh.v[3 * v1 + 0],
        mesh.v[3 * v1 + 1],
        mesh.v[3 * v1 + 2]
      );
    }
    var _modelEdgePositionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, _modelEdgePositionBuffer);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array(edgePositions),
      gl.STATIC_DRAW
    );
    _modelEdgePositionBuffer.itemSize = 3;
    _modelEdgePositionBuffer.numItems = edgePositions.length / 3;
    model.curves.push({ edges: _modelEdgePositionBuffer });
  }
  //for now don't use markups
  //if(mesh.markups){
  //model.markups = mesh.markups;
  //for(var i = 0; i < model.markups.length; i++){
  //var markup = model.markups[i];
  //for(var j = 0; j < markup.polyline.length; j++){
  //var polyline = markup.polyline[j];
  //console.log([markup, polyline]);
  //var _linePositionBuffer = gl.createBuffer();
  //gl.bindBuffer(gl.ARRAY_BUFFER, _linePositionBuffer);
  //gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(polyline.coords), gl.STATIC_DRAW);
  //_linePositionBuffer.itemSize = 3;
  //_linePositionBuffer.numItems = polyline.coords.length/3;
  //model.leaders.push({'leader': _linePositionBuffer});
  //}
  //}
  //}
  if (done) {
    setTimeout(done, 0);
  }
  return model;
};
Sculpteo3DViewerWebGL.prototype.drawModelWithPositionsAndNormals = function (
  vbos,
  positionAttribute,
  normalAttribute
) {
  var gl = this.gl;
  for (var vbi = 0; vbi < vbos.length; vbi++) {
    if (vbos[vbi].hidden) continue;
    var positions = vbos[vbi].positions;
    var normals;
    if (this.smooth_normals) {
      normals = vbos[vbi].smooth_normals;
    } else {
      normals = vbos[vbi].normals;
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, positions);
    gl.vertexAttribPointer(
      positionAttribute,
      positions.itemSize,
      gl.FLOAT,
      false,
      0,
      0
    );
    if (normalAttribute != null) {
      gl.bindBuffer(gl.ARRAY_BUFFER, normals);
      gl.vertexAttribPointer(
        normalAttribute,
        normals.itemSize,
        gl.FLOAT,
        false,
        0,
        0
      );
    }
    gl.drawArrays(gl.TRIANGLES, 0, positions.numItems);
  }
};
Sculpteo3DViewerWebGL.prototype.renderCSGNodeMap = function (nodes) {
  this.picking.runPickingCSG(nodes);
};
Sculpteo3DViewerWebGL.prototype.getActiveModel = function (node) {
  var vbos = node.model;
  if (!vbos) {
    return;
  }
  if (typeof node.group == "undefined") {
    return vbos;
  }
  var _vbos = [];
  for (var k = 0; k < vbos.length; k++) {
    if (vbos[k].gi != node.group) {
      continue;
    }
    _vbos.push(vbos[k]);
  }
  return _vbos;
};

Sculpteo3DViewerWebGL.prototype.activateOverhang = function (
  node_id,
  default_color,
  overhang_face_color,
  overhang_vertex_color,
  overhang_vertex_point_size,
  support_color
) {
  if (!node_id) {
    this.forEachNode(
      function (node) {
        if (node.name) {
          this.activateOverhang(
            node.name,
            default_color,
            overhang_face_color,
            overhang_vertex_color,
            overhang_vertex_point_size,
            support_color
          );
        }
      }.bind(this)
    );
    return;
  }
  node = this.scene.nodes[node_id];
  if (!node || !node.model || node.overhangActivated) return;
  node.overhangActivated = true;
  this._oldSetLocal = this.local;
  this.setLocal(true);
  var gl = this.gl;
  this.pointSize = [1, overhang_vertex_point_size];
  this.pointColor = overhang_vertex_color;
  this.setGroupColor(node.name, function (group) {
    if (group && group.data) {
      if (group.data.support) {
        return support_color;
      }
      if (group.data.overhang) {
        return overhang_face_color;
      }
      return default_color;
    }
  });
  this.issues |= Sculpteo3DViewerCommon.ISSUES_OVERHANG_VERTICES;
  return true;
};

Sculpteo3DViewerWebGL.prototype.deactivateOverhang = function (node_id) {
  if (!node_id) {
    this.forEachNode(
      function (node) {
        if (node.name) {
          this.deactivateOverhang(node.name);
        }
      }.bind(this)
    );
    return;
  }
  node = this.scene.nodes[node_id];
  if (!node || !node.model || !node.overhangActivated) return;
  this.pointSize = [0, 0];
  this.issues &= ~Sculpteo3DViewerCommon.ISSUES_OVERHANG_VERTICES;

  this.resetGroupColor(node.name);
  node.overhangActivated = false;
  this.setLocal(this._oldSetLocal);
};

Sculpteo3DViewerWebGL.prototype.showGroup = function (node_id, f) {
  node = this.scene.nodes[node_id];
  if (!node || !node.model) return;

  //this.setLocal(true); // Maybe not necessary (@amo and he sayed it's okay)
  var gl = this.gl;
  var changed = false;
  node.model.forEach(function (vbi) {
    if (f(vbi.group)) {
      vbi.hidden = false;
      changed = true;
    }
  });
  if (changed) {
    this.setUpdate(true);
  }
};
Sculpteo3DViewerWebGL.prototype.hideGroup = function (node_id, f) {
  node = this.scene.nodes[node_id];
  if (!node || !node.model) return;

  //this.setLocal(true); // Disable because this break the realistic & solidity view if we switch model during a render
  var gl = this.gl;
  var changed = false;
  node.model.forEach(function (vbi) {
    if (f(vbi.group)) {
      vbi.hidden = true;
      changed = true;
    }
  });
  if (changed) {
    this.setUpdate(true);
  }
};
Sculpteo3DViewerWebGL.prototype.setGroupColor = function (node_id, f) {
  node = this.scene.nodes[node_id];
  if (!node || !node.model) return;
  this._oldSetLocal = this.local;
  this.setLocal(true);
  var gl = this.gl;
  // save global material
  if (this.global_material && this.global_material.ambient) {
    this.old_global_material_ambient = this.global_material.ambient;
    // disable ambient
    this.global_material.ambient = undefined;
  }
  node.model.forEach(function (vbi) {
    var color = f(vbi.group);
    if (
      color &&
      (!vbi.color ||
        vbi.color[0] !== color[0] ||
        vbi.color[1] !== color[1] ||
        vbi.color[2] !== color[2])
    ) {
      // save material
      if (vbi.material) {
        vbi.old_material = vbi.material;
      }
      // set new color and material
      vbi.material = undefined;
      vbi.color = color;
      var colors = new Float32Array(vbi.face_count * 9);
      for (var j = 0; j < vbi.face_count; j++)
        for (var k = 0; k < 3; k++)
          for (var l = 0; l < 3; l++) colors[9 * j + 3 * k + l] = vbi.color[l];

      var _modelVertexColorBuffer = gl.createBuffer();

      gl.bindBuffer(gl.ARRAY_BUFFER, _modelVertexColorBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
      _modelVertexColorBuffer.itemSize = 3;
      _modelVertexColorBuffer.numItems = colors.length / 3;
      vbi.colors = _modelVertexColorBuffer;
    }
  });
  return true;
};

Sculpteo3DViewerWebGL.prototype.resetGroupColor = function (node) {
  if (!node) return;
  node = this.scene.nodes[node];
  if (!node || !node.model) return;

  this.setLocal(true);
  var gl = this.gl;
  // retrieve global material
  if (this.old_global_material_ambient) {
    if (this.global_material)
      this.global_material.ambient = this.old_global_material_ambient;
  }

  node.model.forEach(function (vbi) {
    // remove the current color
    delete vbi.color;
    if (vbi.colors) {
      delete vbi.colors;
    }
    // restore old material
    if (vbi.old_material) {
      vbi.material = vbi.old_material;
      delete vbi.old_material;
    }
  });
  return true;
};

Sculpteo3DViewerWebGL.prototype.renderShadowMap = function (
  nodes,
  light,
  texture,
  enabled
) {
  var gl = this.gl;
  // Computing light model view matrix
  var n;
  n = Math.sqrt(
    light.direction[0] * light.direction[0] +
      light.direction[1] * light.direction[1] +
      light.direction[2] * light.direction[2]
  );
  var z = $V([
    light.direction[0] / n,
    light.direction[1] / n,
    light.direction[2] / n,
  ]);
  var up = $V([
    light.direction[1] / n,
    light.direction[2] / n,
    light.direction[0] / n,
  ]);
  var x = up.cross(z).toUnitVector();
  var y = z.cross(x).toUnitVector();
  // Rotate to light
  lightmodelview = new Sculpteo3DViewerCommonTransform3D([
    x.e(1),
    x.e(2),
    x.e(3),
    0,
    y.e(1),
    y.e(2),
    y.e(3),
    0,
    z.e(1),
    z.e(2),
    z.e(3),
    0,
    0,
    0,
    0,
    1,
  ]);
  var m = Sculpteo3DViewerCommonTransform3D.rotation(Math.PI / 2, -1, 0, 0);
  lightmodelview = lightmodelview.x(m);
  lightmodelview = lightmodelview.x(this.getModelViewMatrix());
  var radius = this.shadow_bounding_radius;
  lightProjMatrix = this.makeOrtho(
    -radius,
    radius,
    -radius,
    radius,
    -3 * radius,
    radius
  );
  var _lightMvPMatrix = lightProjMatrix.x(lightmodelview);
  if (texture) {
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      texture,
      0
    );
  }
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  if (!enabled) {
    return _lightMvPMatrix;
  }
  gl.useProgram(this._programDepthMap);
  gl.uniform3f(this._programDepthMap.zBounds, -radius, radius, 0.0);
  gl.enableVertexAttribArray(this._programDepthMap.vertexAttribute);
  gl.uniformMatrix4fv(
    this._programDepthMap.projectionMatrix,
    false,
    lightProjMatrix.toFloat32Array()
  );
  // Render from the light pov
  gl.enable(gl.CULL_FACE);
  gl.cullFace(gl.FRONT);
  gl.bindTexture(gl.TEXTURE_2D, null);
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    // Save _lightMvPMatrix for use in final rendering
    // XXX: need adjustments for multinode rendering
    var mvMatrix = lightmodelview.x(this.scene_transform).x(node.transform);
    gl.uniformMatrix4fv(
      this._programDepthMap.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    this.drawModelWithPositionsAndNormals(
      vbos,
      this._programDepthMap.vertexAttribute,
      null
    );
  }
  gl.disableVertexAttribArray(this._programDepthMap.vertexAttribute);
  return _lightMvPMatrix;
};
Sculpteo3DViewerWebGL.prototype.renderShadowMap2 = function (
  nodes,
  light,
  texture,
  enabled
) {
  var gl = this.gl;
  // Computing light model view matrix
  var n;
  n = Math.sqrt(
    light.direction[0] * light.direction[0] +
      light.direction[1] * light.direction[1] +
      light.direction[2] * light.direction[2]
  );
  var z = $V([
    light.direction[0] / n,
    light.direction[1] / n,
    light.direction[2] / n,
  ]);
  var up = $V([
    light.direction[1] / n,
    light.direction[2] / n,
    light.direction[0] / n,
  ]);
  var x = up.cross(z).toUnitVector();
  var y = z.cross(x).toUnitVector();
  // Rotate to light
  lightmodelview = new Sculpteo3DViewerCommonTransform3D([
    x.e(1),
    x.e(2),
    x.e(3),
    0,
    y.e(1),
    y.e(2),
    y.e(3),
    0,
    z.e(1),
    z.e(2),
    z.e(3),
    0,
    0,
    0,
    0,
    1,
  ]);
  var m = Sculpteo3DViewerCommonTransform3D.rotation(Math.PI / 2, -1, 0, 0);
  lightmodelview = lightmodelview.x(m);
  lightmodelview = lightmodelview.x(this.getModelViewMatrix());
  var radius = this.shadow_bounding_radius;
  lightProjMatrix = this.makeOrtho(
    -radius,
    radius,
    -radius,
    radius,
    -3 * radius,
    radius
  );
  var _lightMvPMatrix = lightProjMatrix; // .x(lightmodelview);
  var modelView = lightmodelview.x(this.scene_transform);
  var lightProj = _lightMvPMatrix; // .translate(0.0,0.0,-0.5).scale(1.0,1.0,2.0);
  if (enabled) {
    this.depthMapComputation(
      nodes,
      modelView,
      lightProj,
      [-radius, radius, 0],
      texture,
      true
    );
  } else {
    // Offscreen render
    gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
    gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
    gl.colorMask(true, true, true, true);
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      texture,
      0
    );
    gl.clearColor(1.0, 1.0, 1.0, 1.0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  }
  var _lightMvPMatrix = lightProjMatrix.x(lightmodelview);
  return _lightMvPMatrix;
};
Sculpteo3DViewerWebGL.prototype.unpackf4i = function (array, o) {
  return (
    array[o] / 255.0 +
    array[o + 1] / (255.0 * 255.0) +
    array[o + 2] / (255.0 * 255.0 * 255.0) +
    array[o + 3] / (255.0 * 255.0 * 255.0 * 255.0)
  );
};
Sculpteo3DViewerWebGL.prototype.depthAndNormalAtLocation = function (x, y) {
  var gl = this.gl;
  var W = gl.viewportWidth;
  var H = gl.viewportHeight;
  var ar = this.width / this.height;
  var depthMap;
  if (this.csg_mode > Sculpteo3DViewerCommon.CSG_MODE_NONE) {
    depthMap = this.pingPongBuffer[1 - this.PPCurrent];
  } else {
    depthMap = this._depthMap;
  }
  var S = depthMap.width;
  var T = depthMap.height;
  var x = parseInt((x / this.zoomx + 1.0) * 0.5 * (W - 1));
  var y = parseInt((y / this.zoomy + 1.0) * 0.5 * (H - 1));
  if (x < 0) {
    x = 0;
  }
  if (x >= W) {
    x = W - 1;
  }
  if (y < 0) {
    y = 0;
  }
  if (y >= H) {
    y = H - 1;
  }
  if (!this.depth_frame || this.depth_frame != this.frame) {
    // Cache the depth buffer
    var gl = this.gl;
    // MUST be the case already (we should be called in the middle of the 1st render pass)
    // gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboHighQuality);
    // gl.viewport(0, 0, W, H);
    // gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, depthMap, 0);
    if (!this.depth_buffer) {
      this.depth_buffer = new Uint8Array(4 * depthMap.width * depthMap.height);
    }
    gl.readPixels(
      0,
      0,
      depthMap.width,
      depthMap.height,
      gl.RGBA,
      gl.UNSIGNED_BYTE,
      this.depth_buffer
    );
    // Gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    // gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
    this.depth_frame = this.frame;
  }
  var pixels = this.depth_buffer;
  if (pixels[4 * (y * S + x)] == 255) {
    return null;
  }
  var R = 2;
  var xp = x + R;
  if (xp >= W) {
    xp = W - 1;
  }
  var yp = y + R;
  if (yp >= H) {
    yp = H - 1;
  }
  var z =
    this.nearVal +
    this.unpackf4i(pixels, 4 * (y * S + x)) * (this.farVal - this.nearVal);
  // Approximate normal from depth derivative
  var zx =
    this.nearVal +
    this.unpackf4i(pixels, 4 * (y * S + xp)) * (this.farVal - this.nearVal);
  var zy =
    this.nearVal +
    this.unpackf4i(pixels, 4 * (yp * S + x)) * (this.farVal - this.nearVal);
  // Console.log(pixels[3]);
  // console.log("z=" + z + " zx=" + zx + " zy=" + zy);
  var dnx = (zx - z) / (((2 * R) / W) * this.zoomx);
  var dny = (zy - z) / (((2 * R) / H) * this.zoomy);
  l = Math.sqrt(dnx * dnx + dny * dny + 1.0);
  dnx /= l;
  dny /= l;
  var dnz = 1.0 / l;
  // Console.log("dn = " + dnx + "," + dny + "," + dnz);
  return { z: -z, nx: dnx, ny: dny, nz: dnz };
};
Sculpteo3DViewerWebGL.prototype._nodeAtLocation = function (x, y) {
  var gl = this.gl;
  var W = gl.viewportWidth;
  var H = gl.viewportHeight;
  var x = parseInt((x / this.zoomx + 1.0) * 0.5 * (W - 1));
  var y = parseInt((y / this.zoomy + 1.0) * 0.5 * (H - 1));
  if (x < 0) {
    x = 0;
  }
  if (x >= W) {
    x = W - 1;
  }
  if (y < 0) {
    y = 0;
  }
  if (y >= H) {
    y = H - 1;
  }
  var idx = this.picking.indexAt(x, y);
  if (idx == 0) {
    return null;
  }
  if (this.scene_flat == null) {
    this._sceneUpdate();
  }
  return idx;
};
Sculpteo3DViewerWebGL.prototype.nodeAtLocation = function (x, y) {
  var idx = this._nodeAtLocation(x, y);
  return this.map_nodes[idx];
};
Sculpteo3DViewerWebGL.prototype.vbosAtLocation = function (x, y) {
  if (this.vbosMap) {
    var idx = this._nodeAtLocation(x, y);
    return this.vbosMap[idx];
  }
  return null;
};
Sculpteo3DViewerWebGL.prototype.mouseOnMesh = function () {
  var x = ((2.0 * this.mouse_x) / (this.width - 1.0) - 1.0) * this.zoomx;
  var y = ((2.0 * this.mouse_y) / (this.height - 1.0) - 1.0) * -this.zoomy;
  var dn = this.depthAndNormalAtLocation(x, y);
  if (dn == null) {
    return null;
  }
  return { x: x, y: y, z: dn.z, nx: dn.nx, ny: dn.ny, nz: dn.nz };
};
Sculpteo3DViewerWebGL.prototype.renderDepthMap = function (nodes) {
  var gl = this.gl;
  gl.bindTexture(gl.TEXTURE_2D, null);
  gl.cullFace(gl.BACK);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._depthMap,
    0
  );
  gl.useProgram(this._programDepthMap);
  gl.enableVertexAttribArray(this._programDepthMap.vertexAttribute);
  var pMatrix = this.pMatrix.scale(1.0, 1.0, 0.5).translate(0.0, 0.0, 0.5);
  gl.uniformMatrix4fv(
    this._programDepthMap.projectionMatrix,
    false,
    pMatrix.toFloat32Array()
  );
  gl.uniform3f(
    this._programDepthMap.zBounds,
    this.zBounds[0],
    this.zBounds[1],
    this.zBounds[2]
  );
  this.picking.beforeDepthMapRender(nodes.length);
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }
    if (node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_ON_TOP) {
      continue;
    }
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    this.picking.whileDepthMapRender(nodes.length, n);
    var mvMatrix = this.mvMatrix.x(node.transform);
    gl.uniformMatrix4fv(
      this._programDepthMap.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    var invProjModelView = pMatrix.inverse();
    gl.uniformMatrix4fv(
      this._programDepthMap.invProjModelView,
      false,
      invProjModelView.toFloat32Array()
    );
    this.drawModelWithPositionsAndNormals(
      vbos,
      this._programDepthMap.vertexAttribute,
      null
    );
  }
  gl.clear(gl.DEPTH_BUFFER_BIT);
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_ON_TOP)) {
      continue;
    }
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    this.picking.whileDepthMapRender(nodes.length, n);
    var mvMatrix = this.mvMatrix.x(node.transform);
    gl.uniformMatrix4fv(
      this._programDepthMap.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    var invProjModelView = pMatrix.inverse();
    gl.uniformMatrix4fv(
      this._programDepthMap.invProjModelView,
      false,
      invProjModelView.toFloat32Array()
    );
    this.drawModelWithPositionsAndNormals(
      vbos,
      this._programDepthMap.vertexAttribute,
      null
    );
  }
  this.picking.afterDepthMapRender(nodes.length);
  var cursorInstance = this.getCursorInstance();
  if (cursorInstance) {
    nodes.push(cursorInstance);
  }
  this.cursorInstance = cursorInstance;
  for (; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    var mvMatrix = this.mvMatrix.x(node.transform);
    gl.uniformMatrix4fv(
      this._programDepthMap.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    this.drawModelWithPositionsAndNormals(
      vbos,
      this._programDepthMap.vertexAttribute,
      null
    );
  }
  gl.disableVertexAttribArray(this._programDepthMap.vertexAttribute);
};
Sculpteo3DViewerWebGL.prototype.renderNodeMap = function (nodes) {
  this.picking.runPicking(nodes);
};
Sculpteo3DViewerWebGL.prototype.renderVbosMap = function (nodes) {
  this.vbosMap = this.picking.runPickingVbos(nodes);
};
Sculpteo3DViewerWebGL.prototype.renderSSAO = function () {
  var gl = this.gl;
  gl.useProgram(this._programSSAO);
  gl.uniform2f(
    this._programSSAO.viewportSize,
    gl.viewportWidth,
    gl.viewportHeight
  );
  gl.activeTexture(gl.TEXTURE0);
  if (this.csg_mode > Sculpteo3DViewerCommon.CSG_MODE_NONE) {
    gl.bindTexture(gl.TEXTURE_2D, this.pingPongBuffer[1 - this.PPCurrent]);
  } else {
    gl.bindTexture(gl.TEXTURE_2D, this._depthMap);
  }
  gl.uniform1i(this._programSSAO.depthMap, 0);
  /* Noise texture for SSAO */
  gl.activeTexture(gl.TEXTURE1);
  gl.bindTexture(gl.TEXTURE_2D, this.noise_texture);
  gl.uniform1i(this._programSSAO.noiseSampler, 1);
  gl.uniform1f(this._programSSAO.ao_strength, this.ao.strength);
  gl.uniform1f(
    this._programSSAO.ao_scale_div_dmax,
    this.ao.scale / this.ao.dmax
  );
  gl.uniform1f(
    this._programSSAO.ao_radius_div_scale,
    this.ao.radius / this._aoMap.width
  );
  gl.uniform2f(
    this._programSSAO.viewportScale,
    gl.viewportWidth / this._csgWidth,
    gl.viewportHeight / this._csgHeight
  );
  gl.cullFace(gl.BACK);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._aoMap,
    0
  );
  gl.clearColor(1.0, 0.0, 0.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  // Draw only where geometry is
  gl.disable(gl.STENCIL_TEST);
  gl.stencilFunc(gl.NOTEQUAL, 0x00, 0xff);
  gl.stencilMask(0xff);
  gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
  // Draw a quad
  gl.disable(gl.DEPTH_TEST);
  gl.enableVertexAttribArray(this._programSSAO.vertexAttribute);
  this.drawQuad(this._programSSAO, 1.0);
  gl.enable(gl.DEPTH_TEST);
  gl.disable(gl.STENCIL_TEST);
  gl.disableVertexAttribArray(this._programSSAO.vertexAttribute);
  gl.bindTexture(gl.TEXTURE_2D, this._aoMap);
};
Sculpteo3DViewerWebGL.prototype.renderBlur = function (texture, blurMap) {
  var gl = this.gl;
  gl.useProgram(this._programBlur);
  gl.activeTexture(gl.TEXTURE0);
  gl.uniform1i(this._programBlur.sampler, 0);
  gl.clearColor(1.0, 0.0, 0.0, 1.0);
  gl.disable(gl.DEPTH_TEST);
  gl.enableVertexAttribArray(this._programBlur.vertexAttribute);
  // 1st pass, blur horizontally
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    blurMap,
    0
  );
  gl.uniform2f(this._programBlur.scale, 1.0 / texture.width, 0.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  this.drawQuad(this._programBlur, 1.0);
  // 2nd pass, blur vertically
  gl.bindTexture(gl.TEXTURE_2D, blurMap);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    texture,
    0
  );
  gl.uniform2f(this._programBlur.scale, 0.0, 1.0 / texture.height);
  gl.clear(gl.COLOR_BUFFER_BIT);
  this.drawQuad(this._programBlur, 1.0);
  gl.enable(gl.DEPTH_TEST);
  gl.disableVertexAttribArray(this._programBlur.vertexAttribute);
};
Sculpteo3DViewerWebGL.prototype.renderBlurGauss = function (
  texture,
  blurMap,
  clear_color
) {
  var gl = this.gl;
  gl.useProgram(this._programBlurGauss);
  gl.activeTexture(gl.TEXTURE0);
  gl.uniform1i(this._programBlurGauss.sampler, 0);
  if (!clear_color) {
    clear_color = { r: 1.0, g: 1.0, b: 1.0, a: 1.0 };
  } else {
    clear_color.r /= 255;
    clear_color.g /= 255;
    clear_color.b /= 255;
    clear_color.a /= 255;
  }
  gl.clearColor(clear_color.r, clear_color.g, clear_color.b, clear_color.a);
  gl.disable(gl.DEPTH_TEST);
  gl.enableVertexAttribArray(this._programBlurGauss.vertexAttribute);
  // Blur in both directions in the same time
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    blurMap,
    0
  );
  gl.uniform2f(
    this._programBlurGauss.scale,
    5.0 / texture.width,
    5.0 / texture.height
  );
  gl.uniform2f(this._programBlurGauss.gammaGain, 1.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  this.drawQuad(this._programBlurGauss, 1.0);
  gl.enable(gl.DEPTH_TEST);
  gl.disableVertexAttribArray(this._programBlurGauss.vertexAttribute);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    null,
    0
  );
};
Sculpteo3DViewerWebGL.prototype.renderNodesUniformColor = function (
  texture,
  nodes,
  color
) {
  var gl = this.gl;
  gl.useProgram(this._programConstantColor);
  gl.enableVertexAttribArray(this._programConstantColor.vertexAttribute);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    texture,
    0
  );
  var color_r, color_g, color_b, color_a;
  color_r = color.r / 255.0;
  color_g = color.g / 255.0;
  color_b = color.b / 255.0;
  color_a = color.a / 255.0;
  gl.uniform4f(
    this._programConstantColor.color,
    color_r,
    color_g,
    color_b,
    color_a
  );
  gl.uniformMatrix4fv(
    this._programConstantColor.projectionMatrix,
    false,
    this.pMatrix.toFloat32Array()
  );
  // We don't care about depth, everything will be drawn with the same color anyway
  gl.disable(gl.DEPTH_TEST);
  gl.clearColor(color_r, color_g, color_b, 0.0);
  // Gl.clearStencil(0);
  gl.clear(gl.COLOR_BUFFER_BIT); // | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
  // Set stencil bits to 1 where geometry is drawn
  // gl.enable(gl.STENCIL_TEST);
  // gl.stencilFunc(gl.ALWAYS, 0x01, 0xFF);
  // gl.stencilMask(0xFF);
  // gl.depthMask(false);
  // gl.stencilOp(gl.KEEP, gl.REPLACE, gl.REPLACE);
  // Draw the geometry
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    var mtype = node.material || "global";
    var mvMatrix = this.mvMatrix.x(node.transform);
    gl.uniformMatrix4fv(
      this._programConstantColor.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    for (var vbi = 0; vbi < vbos.length; vbi++) {
      var envmap = false;
      var positions = vbos[vbi].positions;
      gl.bindBuffer(gl.ARRAY_BUFFER, positions);
      gl.vertexAttribPointer(
        this._programConstantColor.vertexAttribute,
        positions.itemSize,
        gl.FLOAT,
        false,
        0,
        0
      );
      gl.drawArrays(gl.TRIANGLES, 0, positions.numItems);
    }
  }
  // Gl.depthMask(true);
  // gl.disable(gl.STENCIL_TEST);
  gl.enable(gl.DEPTH_TEST);
  gl.disableVertexAttribArray(this._programConstantColor.vertexAttribute);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    null,
    0
  );
};
Sculpteo3DViewerWebGL.prototype.renderSelectedNodes = function (nodes) {
  var gl = this.gl;
  var selected_nodes = [];
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }
    var vbos = node.model;
    if (!vbos) {
      continue;
    }
    if (node.instance.interactive & Sculpteo3DViewerCommon.INTERACTIVE_SELECT) {
      selected_nodes.push(node);
    }
  }
  if (selected_nodes.length == 0) {
    return;
  }
  var color = this.selcolor;
  // Change to a new framebuffer
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboHighQuality);
  gl.viewport(0, 0, this._selectMap.width, this._selectMap.height);
  // Render selected nodes using flat color
  this.renderNodesUniformColor(this._selectMap, selected_nodes, color);
  // Go back to the default framebuffer
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
  // Draw the blured map over the final render
  this.showTextureMap(this._selectMap, [-1, -1, 1, 1]);
};
Sculpteo3DViewerWebGL.prototype.renderGeometryPBR = function (
  nodes,
  light0MVPMatrix,
  light1MVPMatrix,
  global_material,
  l0,
  l1,
  opaque
) {
  var gl = this.gl;
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }
    var vbos = node.model;
    if (!vbos) {
      continue;
    }
    if (node.opacity != 1.0 && opaque) {
      continue;
    }
    if (node.opacity == 1.0 && !opaque) {
      continue;
    }
    if (this.csg_mode > Sculpteo3DViewerCommon.CSG_MODE_NONE) {
      gl.uniform1i(this._programPBRShader.csgMode, true);
    } else {
      gl.uniform1i(this._programPBRShader.csgMode, false);
    }
    var mtype = node.material || "global";
    if (this.perlin_val && this.perlin_val.amplitude > 0.0 && this.perlin) {
      var scale = Math.pow(Math.abs(node.transform.matrix.det()), 1.0 / 3.0);
      gl.uniform3f(
        this._programPBRShader.perlinScaleUniform,
        this.perlin_val.scale_x * scale,
        this.perlin_val.scale_y * scale,
        this.perlin_val.scale_z * scale
      );
      gl.uniform1i(this._programPBRShader.usePerlinUniform, true);
    }
    var mvMatrix = this.mvMatrix.x(node.transform);
    gl.uniformMatrix4fv(
      this._programPBRShader.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    var normalMatrix = mvMatrix.inverse();
    normalMatrix = normalMatrix.transpose();
    gl.uniformMatrix4fv(
      this._programPBRShader.normalMatrix,
      false,
      normalMatrix.toFloat32Array()
    );
    // XXX: combine shadow map in final shader
    gl.uniformMatrix4fv(
      this._programPBRShader.lightModelviewProjMatrix,
      false,
      light0MVPMatrix.x(this.scene_transform).x(node.transform).toFloat32Array()
    );
    gl.uniformMatrix4fv(
      this._programPBRShader.lightModelviewProjMatrix2,
      false,
      light1MVPMatrix.x(this.scene_transform).x(node.transform).toFloat32Array()
    );
    // Opacity
    // gl.uniform1f(this._programPBRShader.opacity, node.opacity);
    // Use proper culling and lighting (for CSG)
    if (node.complemented) {
      gl.uniform3f(
        this._programPBRShader.lightDirection1,
        -l0[0],
        -l0[1],
        -l0[2]
      );
      gl.uniform3f(
        this._programPBRShader.lightDirection2,
        -l1[0],
        -l1[1],
        -l1[2]
      );
      gl.cullFace(gl.FRONT);
    } else {
      gl.uniform3f(this._programPBRShader.lightDirection1, l0[0], l0[1], l0[2]);
      gl.uniform3f(this._programPBRShader.lightDirection2, l1[0], l1[1], l1[2]);
      gl.cullFace(gl.BACK);
    }
    for (var vbi = 0; vbi < vbos.length; vbi++) {
      if (vbos[vbi].hidden) continue;
      var envmap = false;
      var material = null;
      if (mtype == "global") {
        if (!global_material.diffuse) {
          material = vbos[vbi].material;
        }
      } else if (mtype == "mesh") {
        material = vbos[vbi].material;
      } else {
        material = this.parseMaterial(mtype);
      }
      if (!material) {
        material = {};
      }
      if (global_material.roughness) {
        var color_r, color_g, color_b;
        if (material && material.color) {
          color_r = material.color.r / 255.0;
          color_g = material.color.g / 255.0;
          color_b = material.color.b / 255.0;
        } else {
          if (global_material.diffuse) {
            color_r = global_material.diffuse.color.r / 255.0;
            color_g = global_material.diffuse.color.g / 255.0;
            color_b = global_material.diffuse.color.b / 255.0;
          } else {
            color_r = 1.0;
            color_g = 1.0;
            color_b = 1.0;
          }
        }
        gl.uniform3f(
          this._programPBRShader.materialDiffuseColor,
          color_r,
          color_g,
          color_b
        );
        color_r = global_material.specular.color.r / 255.0;
        color_g = global_material.specular.color.g / 255.0;
        color_b = global_material.specular.color.b / 255.0;
        gl.uniform3f(
          this._programPBRShader.materialSpecularColor,
          color_r,
          color_g,
          color_b
        );
        gl.uniform1f(
          this._programPBRShader.materialRoughness,
          global_material.roughness
        );
        gl.uniform1f(
          this._programPBRShader.materialFresnel0,
          global_material.fresnel0
        );
        gl.uniform1f(
          this._programPBRShader.materialGloss,
          global_material.gloss
        );
      } else {
        var color_r, color_g, color_b;
        color_r = 0.5;
        color_g = 0.5;
        color_b = 0.5;
        gl.uniform3f(
          this._programPBRShader.materialDiffuseColor,
          color_r,
          color_g,
          color_b
        );
        gl.uniform3f(
          this._programPBRShader.materialSpecularColor,
          color_r,
          color_g,
          color_b
        );
        gl.uniform1f(this._programPBRShader.materialRoughness, 0.7);
        gl.uniform1f(this._programPBRShader.materialFresnel0, 0.5);
        gl.uniform1f(this._programPBRShader.materialGloss, 0.2);
      }
      var render_type = 0;
      if (material.texture && !global_material.diffuse) {
        var texture = material.texture;
        if (texture && texture.loaded) {
          gl.activeTexture(gl.TEXTURE0);
          if (!texture.glid) {
            // Upload texture to GPU
            texture.glid = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture.glid);
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
            gl.texImage2D(
              gl.TEXTURE_2D,
              0,
              gl.RGBA,
              gl.RGBA,
              gl.UNSIGNED_BYTE,
              texture
            );
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
          } else {
            gl.bindTexture(gl.TEXTURE_2D, texture.glid);
          }
          render_type += 1;
        }
      }
      if (this.cubemap_texture) {
        gl.uniform1f(
          this._programPBRShader.envmapBias,
          global_material.roughness * this.cubemap_texture.mip_levels
        );
        gl.activeTexture(gl.TEXTURE1);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.cubemap_texture);
        gl.activeTexture(gl.TEXTURE7);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.cubemap_texture_diff);
        gl.uniform1i(this._programPBRShader.envSpecSampler, 1);
        gl.uniform1i(this._programPBRShader.envDiffSampler, 7);
        render_type += 2;
      } else {
        gl.uniform1i(this._programPBRShader.renderType, 0);
      }
      if (vbos[vbi].colors && !global_material.diffuse) {
        render_type += 4;
      }
      gl.uniform1i(this._programPBRShader.renderType, render_type);
      var positions = vbos[vbi].positions;
      var texcoords = vbos[vbi].texcoords;
      var normals;
      if (this.smooth_normals) {
        normals = vbos[vbi].smooth_normals;
      } else {
        normals = vbos[vbi].normals;
      }
      gl.bindBuffer(gl.ARRAY_BUFFER, positions);
      gl.vertexAttribPointer(
        this._programPBRShader.vertexAttribute,
        positions.itemSize,
        gl.FLOAT,
        false,
        0,
        0
      );
      gl.bindBuffer(gl.ARRAY_BUFFER, texcoords);
      gl.vertexAttribPointer(
        this._programPBRShader.texCoord0Attribute,
        texcoords.itemSize,
        gl.FLOAT,
        false,
        0,
        0
      );
      gl.bindBuffer(gl.ARRAY_BUFFER, normals);
      gl.vertexAttribPointer(
        this._programPBRShader.normalAttribute,
        normals.itemSize,
        gl.FLOAT,
        false,
        0,
        0
      );
      if (vbos[vbi].colors && !global_material.diffuse) {
        var colors = vbos[vbi].colors;
        gl.enableVertexAttribArray(this._programUberShader.colorAttribute);
        gl.bindBuffer(gl.ARRAY_BUFFER, colors);
        gl.vertexAttribPointer(
          this._programUberShader.colorAttribute,
          colors.itemSize,
          gl.FLOAT,
          false,
          0,
          0
        );
      }
      gl.drawArrays(gl.TRIANGLES, 0, positions.numItems);
    }
  }
  gl.cullFace(gl.BACK);
};
Sculpteo3DViewerWebGL.prototype.drawScenePBR = function (
  nodes,
  light0MVPMatrix,
  light1MVPMatrix,
  scene_ambient,
  light0,
  light1,
  global_material
) {
  var gl = this.gl;
  var start = new Date();
  // If (!(this.csg_mode > Sculpteo3DViewerCommon.CSG_MODE_NONE)) {
  // offscreen renders
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
  // Depth map
  // this.renderDepthMap(nodes); // 5ms
  // Render the nodemap.
  this.renderNodeMap(nodes);
  // Ssao
  if (this.ao.enabled) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboHighQuality);
    gl.viewport(0, 0, this._aoMap.width, this._aoMap.height);
    this.renderSSAO(); // 25ms
    this.renderBlur(this._aoMap, this._blurMap); // 2ms
    // this.renderBlur();
  } else {
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      this._aoMap,
      0
    );
    gl.clearColor(1.0, 1.0, 1.0, 1.0);
    gl.clear(gl.COLOR_BUFFER_BIT);
  }
  // Restore normal render
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
  gl.cullFace(gl.BACK);
  gl.enable(gl.CULL_FACE);
  gl.enable(gl.DEPTH_TEST);
  gl.enable(gl.BLEND);
  gl.colorMask(1.0, 1.0, 1.0, 1.0);
  // Final rendering pass
  gl.useProgram(this._programPBRShader);
  gl.enableVertexAttribArray(this._programPBRShader.vertexAttribute);
  gl.enableVertexAttribArray(this._programPBRShader.normalAttribute);
  gl.enableVertexAttribArray(this._programPBRShader.texCoord0Attribute);
  gl.uniformMatrix4fv(
    this._programPBRShader.projectionMatrix,
    false,
    this.pMatrix.toFloat32Array()
  );
  /** *** Uniform for Shadow Mapping **** */
  // XXX
  gl.activeTexture(gl.TEXTURE2);
  gl.bindTexture(gl.TEXTURE_2D, this._depthRenderBuffer);
  gl.uniform1i(this._programPBRShader.shadowMap, 2);
  gl.activeTexture(gl.TEXTURE3);
  gl.bindTexture(gl.TEXTURE_2D, this._depthRenderBuffer2);
  gl.uniform1i(this._programPBRShader.shadowMap2, 3);
  /** ** Uniform for Ambient occlusion *** */
  gl.activeTexture(gl.TEXTURE4);
  gl.bindTexture(gl.TEXTURE_2D, this._aoMap);
  gl.uniform1i(this._programPBRShader.aoMap, 4);
  /** ** Uniform for CSG *** */
  gl.activeTexture(gl.TEXTURE5);
  gl.bindTexture(gl.TEXTURE_2D, this.pingPongBuffer[1 - this.PPCurrent]);
  gl.uniform1i(this._programPBRShader.csgMap, 5);
  gl.uniform3f(
    this._programPBRShader.uZBounds,
    this.zBounds[0],
    this.zBounds[1],
    this.zBounds[2]
  );
  gl.uniform2f(
    this._programPBRShader.viewportScale,
    gl.viewportWidth / nearestUpperPow2(gl.viewportWidth),
    gl.viewportHeight / nearestUpperPow2(gl.viewportHeight)
  );
  gl.uniform4f(
    this._programPBRShader.cameraPos,
    this.cameraPos[0],
    this.cameraPos[1],
    this.cameraPos[2],
    this.cameraPos[3]
  );
  /** ** Uniform for Perlin noise *** */
  var perlin = false;
  if (this.perlin_val && this.perlin_val.amplitude > 0.0) {
    perlin = true;
  }
  if (perlin && this.perlin) {
    gl.activeTexture(gl.TEXTURE6);
    gl.bindTexture(gl.TEXTURE_2D, this.perlin);
    gl.uniform1i(this._programPBRShader.perlinSamplerUniform, 6);
    gl.uniform3f(this._programPBRShader.perlinOriginUniform, 0.0, 0.0, 0.0);
    gl.uniform1f(
      this._programPBRShader.perlinAmplitudeUniform,
      this.perlin_val.amplitude / Math.sqrt(this.zoom)
    );
    gl.uniform1i(this._programPBRShader.usePerlinUniform, true);
  } else {
    gl.uniform1f(this._programPBRShader.perlinAmplitudeUniform, 0.0);
    gl.uniform3f(this._programPBRShader.perlinScaleUniform, 0.0, 0.0, 0.0);
    gl.uniform1i(this._programPBRShader.usePerlinUniform, false);
  }
  /** ** Lighting Informations **** */
  // Light direction is computed, but set latter (for correct lighting of
  // flipped nodes of CSG)
  var n;
  n =
    1.0 /
    Math.sqrt(
      light0.direction[0] * light0.direction[0] +
        light0.direction[1] * light0.direction[1] +
        light0.direction[2] * light0.direction[2]
    );
  var l0 = [
    light0.direction[0] * n,
    light0.direction[1] * n,
    light0.direction[2] * n,
  ];
  gl.uniform3f(
    this._programPBRShader.lightDiffuseColor1,
    light0.diffuse[0],
    light0.diffuse[1],
    light0.diffuse[2]
  );
  // Gl.uniform3f(this._programPBRShader.lightSpecularColor1, light0.specular[0], light0.specular[1], light0.specular[2]);
  n =
    1.0 /
    Math.sqrt(
      light1.direction[0] * light1.direction[0] +
        light1.direction[1] * light1.direction[1] +
        light1.direction[2] * light1.direction[2]
    );
  var l1 = [
    light1.direction[0] * n,
    light1.direction[1] * n,
    light1.direction[2] * n,
  ];
  gl.uniform3f(
    this._programPBRShader.lightDiffuseColor2,
    light1.diffuse[0],
    light1.diffuse[1],
    light1.diffuse[2]
  );
  // Gl.uniform3f(this._programPBRShader.lightSpecularColor2, light1.specular[0], light1.specular[1], light1.specular[2]);
  // Gl.uniform3f(this._programPBRShader.ambientColor, scene_ambient[0], scene_ambient[1], scene_ambient[2]);
  /** *** Rendering our Triangles ***** */
  // 1st pass for opaque objects
  this.renderGeometryPBR(
    nodes,
    light0MVPMatrix,
    light1MVPMatrix,
    global_material,
    l0,
    l1,
    true
  );
  // 2nd pass for transparent objects
  this.renderGeometryPBR(
    nodes,
    light0MVPMatrix,
    light1MVPMatrix,
    global_material,
    l0,
    l1,
    false
  );
  gl.activeTexture(gl.TEXTURE0);
  gl.disableVertexAttribArray(this._programPBRShader.texCoord0Attribute);
  gl.disableVertexAttribArray(this._programPBRShader.normalAttribute);
  gl.disableVertexAttribArray(this._programPBRShader.vertexAttribute);
  // This.showTextureMap(this._depthRenderBuffer, [ -1.0, 0.0, 0.0, 1.0 ]);
  // this.showTextureMap(this._nodeMap, [ -1.0, 0.0, 0.0, 1.0 ]);
  // this.showTextureMap(this._debugMap, [ -1.0, -1.0, 1.0, 1.0 ]);
  // this.showTextureMap(this._DepthMap1, [ -1.0, -1.0, 1.0, 1.0 ]);
  // this.showTextureMap(this.pingPongBuffer[1 - this.PPCurrent], [ -1.0, 0.0, 0.0, 1.0 ]);
  // this.showTextureMap(this._tmpMap, [ -1.0, 0.0, 0.0, 1.0 ]);
  // this.showTextureMap(this._depthMap, [ -1.0, 0.0, 0.0, 1.0 ]);
};
Sculpteo3DViewerWebGL.prototype.renderGeometryHQ = function (
  nodes,
  light0MVPMatrix,
  light1MVPMatrix,
  global_material,
  l0,
  l1,
  opaque
) {
  var gl = this.gl;
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }
    if (node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_ON_TOP) {
      continue;
    }
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    var is_cursor =
      typeof this.cursorInstance != "undefined" && node == this.cursorInstance;
    if (is_cursor) {
      if (opaque) {
        continue;
      }
    } else {
      if (node.opacity != 1.0 && opaque) {
        continue;
      }
      if (node.opacity == 1.0 && !opaque) {
        continue;
      }
    }
    if (this.csg_mode > Sculpteo3DViewerCommon.CSG_MODE_NONE && opaque) {
      gl.uniform1i(this._programUberShader.csgMode, true);
    } else {
      gl.uniform1i(this._programUberShader.csgMode, false);
    }
    var perlin_val = this.perlin_val;
    // If there is material override the perlin noise
    if (node.instance.material && node.instance.perlin != null) {
      perlin_val = node.instance.perlin;
    }
    if (perlin_val && perlin_val.amplitude > 0.0 && this.perlin) {
      var scale = Math.pow(Math.abs(node.transform.matrix.det()), 1.0 / 3.0);
      gl.uniform3f(
        this._programUberShader.perlinScaleUniform,
        perlin_val.scale_x * scale,
        perlin_val.scale_y * scale,
        perlin_val.scale_z * scale
      );
      gl.uniform1i(this._programUberShader.usePerlinUniform, true);
    } else {
      gl.uniform1i(this._programUberShader.usePerlinUniform, false);
    }
    var gauss_val = this.gauss_val;
    if (
      node.instance.material &&
      typeof node.instance.gaussian_amplitude !== "undefined"
    ) {
      gauss_val = node.instance.gaussian_amplitude;
    }
    if (gauss_val) {
      gl.uniform1f(this._programUberShader.gaussAmplitude, gauss_val);
    } else {
      gl.uniform1f(this._programUberShader.gaussAmplitude, 0.0);
    }
    var mvMatrix = this.mvMatrix.x(node.transform);
    gl.uniformMatrix4fv(
      this._programUberShader.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    var normalMatrix = mvMatrix.inverse();
    normalMatrix = normalMatrix.transpose();
    gl.uniformMatrix4fv(
      this._programUberShader.normalMatrix,
      false,
      normalMatrix.toFloat32Array()
    );
    // XXX: combine shadow map in final shader
    gl.uniformMatrix4fv(
      this._programUberShader.lightModelviewProjMatrix,
      false,
      light0MVPMatrix.x(this.scene_transform).x(node.transform).toFloat32Array()
    );
    gl.uniformMatrix4fv(
      this._programUberShader.lightModelviewProjMatrix2,
      false,
      light1MVPMatrix.x(this.scene_transform).x(node.transform).toFloat32Array()
    );
    // Opacity
    gl.uniform1f(this._programUberShader.opacity, node.opacity);
    // Use proper culling and lighting (for CSG)
    if (node.complemented) {
      gl.uniform3f(
        this._programUberShader.lightDirection1,
        -l0[0],
        -l0[1],
        -l0[2]
      );
      gl.uniform3f(
        this._programUberShader.lightDirection2,
        -l1[0],
        -l1[1],
        -l1[2]
      );
      gl.cullFace(gl.FRONT);
    } else {
      gl.uniform3f(
        this._programUberShader.lightDirection1,
        l0[0],
        l0[1],
        l0[2]
      );
      gl.uniform3f(
        this._programUberShader.lightDirection2,
        l1[0],
        l1[1],
        l1[2]
      );
      gl.cullFace(gl.BACK);
    }
    var mtype = node.material || "global";
    var use_envmap = node.instance.envmap || this.envmap;
    var use_smooth = node.instance.smooth || this.smooth_normals;
    for (var vbi = 0; vbi < vbos.length; vbi++) {
      if (vbos[vbi].hidden) continue;
      var envmap = false;
      var material;
      switch (mtype) {
        case "global":
          if (global_material && !vbos[vbi].feature_picked) {
            material = global_material;
          } else {
            material = vbos[vbi].material;
          }
          break;
        case "mesh":
          material = vbos[vbi].material;
          break;
        default:
          material = this.parseMaterial(mtype);
      }
      if (!material) {
        material = {};
      }
      if (material.color) {
        gl.uniform1i(this._programUberShader.renderType, 0); // Simple
        // color
        var color_r, color_g, color_b;
        color_r = material.color.r / 255.0;
        color_g = material.color.g / 255.0;
        color_b = material.color.b / 255.0;
        gl.uniform3f(
          this._programUberShader.materialAmbientColor,
          color_r,
          color_g,
          color_b
        );
        gl.uniform3f(
          this._programUberShader.materialDiffuseColor,
          color_r,
          color_g,
          color_b
        );
        gl.uniform3f(
          this._programUberShader.materialSpecularColor,
          0.0,
          0.0,
          0.0
        );
        gl.uniform1f(this._programUberShader.materialShininess, 1.0);
      } else if (material.texture) {
        var texture = material.texture;
        if (texture && texture.loaded) {
          gl.activeTexture(gl.TEXTURE0);
          if (!texture.glid) {
            // Upload texture to GPU
            texture.glid = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture.glid);
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
            gl.texImage2D(
              gl.TEXTURE_2D,
              0,
              gl.RGBA,
              gl.RGBA,
              gl.UNSIGNED_BYTE,
              texture
            );
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
          } else {
            gl.bindTexture(gl.TEXTURE_2D, texture.glid);
          }
          gl.uniform1i(this._programUberShader.renderType, 2); // Texture
          gl.uniform3f(
            this._programUberShader.materialSpecularColor,
            0.0,
            0.0,
            0.0
          );
          gl.uniform1f(this._programUberShader.materialShininess, 1.0);
          gl.uniform1i(this._programUberShader.sampler, 0);
        } else {
          // Texture not there yet
          gl.uniform1i(this._programUberShader.renderType, 0); // Color
          gl.uniform3f(
            this._programUberShader.materialAmbientColor,
            1.0,
            1.0,
            1.0
          );
          gl.uniform3f(
            this._programUberShader.materialDiffuseColor,
            1.0,
            1.0,
            1.0
          );
          gl.uniform3f(
            this._programUberShader.materialSpecularColor,
            0.0,
            0.0,
            0.0
          );
          gl.uniform1f(this._programUberShader.materialShininess, 1.0);
        }
      } else if (material.ambient) {
        if (material.ambient) {
          if (material.ambient.color) {
            gl.uniform3f(
              this._programUberShader.materialAmbientColor,
              material.ambient.color.r / 255,
              material.ambient.color.g / 255,
              material.ambient.color.b / 255
            );
          } else {
            // TODO: texture
          }
        }
        if (material.diffuse) {
          if (material.diffuse.color) {
            gl.uniform3f(
              this._programUberShader.materialDiffuseColor,
              material.diffuse.color.r / 255,
              material.diffuse.color.g / 255,
              material.diffuse.color.b / 255
            );
          } else if (material.diffuse.texture) {
            var texture = material.diffuse.texture;
            if (texture && texture.loaded) {
              gl.activeTexture(gl.TEXTURE0);
              if (!texture.glid) {
                // Upload texture to GPU
                texture.glid = gl.createTexture();
                gl.bindTexture(gl.TEXTURE_2D, texture.glid);
                gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
                gl.texImage2D(
                  gl.TEXTURE_2D,
                  0,
                  gl.RGBA,
                  gl.RGBA,
                  gl.UNSIGNED_BYTE,
                  texture
                );
                gl.texParameteri(
                  gl.TEXTURE_2D,
                  gl.TEXTURE_MAG_FILTER,
                  gl.NEAREST
                );
                gl.texParameteri(
                  gl.TEXTURE_2D,
                  gl.TEXTURE_MIN_FILTER,
                  gl.NEAREST
                );
              } else {
                gl.bindTexture(gl.TEXTURE_2D, texture.glid);
              }
              gl.uniform1i(this._programUberShader.renderType, 2); // Texture
              gl.uniform3f(
                this._programUberShader.materialSpecularColor,
                0.0,
                0.0,
                0.0
              );
              gl.uniform1f(this._programUberShader.materialShininess, 1.0);
              gl.uniform1i(this._programUberShader.sampler, 0);
            } else {
              // Texture not there yet
              gl.uniform3f(
                this._programUberShader.materialDiffuseColor,
                1.0,
                1.0,
                1.0
              );
            }
          }
        }
        if (material.specular) {
          if (material.specular.color) {
            gl.uniform3f(
              this._programUberShader.materialSpecularColor,
              material.specular.color.r / 255,
              material.specular.color.g / 255,
              material.specular.color.b / 255
            );
            if (
              material.specular.color.r != 0 ||
              material.specular.color.g != 0 ||
              material.specular.color.b != 0
            ) {
              envmap = use_envmap;
            }
          } /* Comment out useless code
					else if (material.specular.texture) {
						// TODO: texture
					}*/
        }
        if (material.shininess != 0.0) {
          gl.uniform1f(
            this._programUberShader.materialShininess,
            material.shininess
          );
        } else {
          gl.uniform3f(
            this._programUberShader.materialSpecularColor,
            0.0,
            0.0,
            0.0
          );
          gl.uniform1f(this._programUberShader.materialShininess, 1.0);
        }
        if (material.shininess != 0.0 && envmap && this.envmap_texture) {
          gl.activeTexture(gl.TEXTURE1);
          gl.bindTexture(gl.TEXTURE_2D, this.envmap_texture);
          var envmap_width = this.envmap_texture.image.width;
          var bias =
            Math.log(
              (Math.acos(Math.pow(0.7, 1.0 / material.shininess)) *
                envmap_width) /
                Math.PI
            ) / Math.LN2;
          gl.uniform1f(this._programUberShader.envmapBias, bias);
          gl.uniform1i(this._programUberShader.envmapSampler, 1);
          gl.uniform1i(this._programUberShader.renderType, 1);
        } else {
          gl.uniform1i(this._programUberShader.renderType, 0);
        }
      } else {
        if (vbos[vbi].colors) {
          gl.uniform1i(this._programUberShader.renderType, 3); // Interpolated color
        } else {
          // No material
          gl.uniform1i(this._programUberShader.renderType, 0); // Simple color
        }
        gl.uniform3f(
          this._programUberShader.materialAmbientColor,
          1.0,
          1.0,
          1.0
        );
        gl.uniform3f(
          this._programUberShader.materialDiffuseColor,
          1.0,
          1.0,
          1.0
        );
        gl.uniform3f(
          this._programUberShader.materialSpecularColor,
          0.0,
          0.0,
          0.0
        );
        gl.uniform1f(this._programUberShader.materialShininess, 1.0);
      }
      var positions = vbos[vbi].positions;
      var texcoords = vbos[vbi].texcoords;
      var normals;
      if (use_smooth) {
        normals = vbos[vbi].smooth_normals;
      } else {
        normals = vbos[vbi].normals;
      }
      gl.bindBuffer(gl.ARRAY_BUFFER, positions);
      gl.vertexAttribPointer(
        this._programUberShader.vertexAttribute,
        positions.itemSize,
        gl.FLOAT,
        false,
        0,
        0
      );
      gl.bindBuffer(gl.ARRAY_BUFFER, texcoords);
      gl.vertexAttribPointer(
        this._programUberShader.texCoord0Attribute,
        texcoords.itemSize,
        gl.FLOAT,
        false,
        0,
        0
      );
      gl.bindBuffer(gl.ARRAY_BUFFER, normals);
      gl.vertexAttribPointer(
        this._programUberShader.normalAttribute,
        normals.itemSize,
        gl.FLOAT,
        false,
        0,
        0
      );
      if (vbos[vbi].colors) {
        var colors = vbos[vbi].colors;
        gl.enableVertexAttribArray(this._programUberShader.colorAttribute);
        gl.bindBuffer(gl.ARRAY_BUFFER, colors);
        gl.vertexAttribPointer(
          this._programUberShader.colorAttribute,
          colors.itemSize,
          gl.FLOAT,
          false,
          0,
          0
        );
      }

      gl.drawArrays(gl.TRIANGLES, 0, positions.numItems);

      if (vbos[vbi].colors) {
        gl.disableVertexAttribArray(this._programUberShader.colorAttribute);
      }
    }
  }
  gl.cullFace(gl.BACK);
};
Sculpteo3DViewerWebGL.prototype.drawSceneHQ = function (
  nodes,
  light0MVPMatrix,
  light1MVPMatrix,
  scene_ambient,
  light0,
  light1,
  global_material
) {
  var gl = this.gl;
  var start = new Date();
  // Offscreen renders
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
  // Node map for selection
  if (this.csg_mode > Sculpteo3DViewerCommon.CSG_MODE_NONE) {
    this.renderCSGNodeMap(nodes);
  } else {
    this.renderNodeMap(nodes);
  }
  // Ssao
  if (this.ao.enabled) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboHighQuality);
    gl.viewport(0, 0, this._aoMap.width, this._aoMap.height);
    this.renderSSAO(); // 25ms
    this.renderBlur(this._aoMap, this._blurMap); // 2ms
  } else {
    gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboHighQuality);
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      this._aoMap,
      0
    );
    gl.clearColor(1.0, 1.0, 1.0, 1.0);
    gl.clear(gl.COLOR_BUFFER_BIT);
  }
  // Restore normal render
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
  gl.cullFace(gl.BACK);
  gl.enable(gl.CULL_FACE);
  gl.enable(gl.DEPTH_TEST);
  gl.enable(gl.BLEND);
  gl.colorMask(1.0, 1.0, 1.0, 1.0);
  // Final rendering pass
  gl.useProgram(this._programUberShader);
  gl.enableVertexAttribArray(this._programUberShader.vertexAttribute);
  gl.enableVertexAttribArray(this._programUberShader.normalAttribute);
  gl.enableVertexAttribArray(this._programUberShader.texCoord0Attribute);
  gl.uniformMatrix4fv(
    this._programUberShader.projectionMatrix,
    false,
    this.pMatrix.toFloat32Array()
  );
  /** *** Uniform for Shadow Mapping **** */
  // XXX
  gl.activeTexture(gl.TEXTURE2);
  gl.bindTexture(gl.TEXTURE_2D, this._depthRenderBuffer);
  gl.uniform1i(this._programUberShader.shadowMap, 2);
  gl.activeTexture(gl.TEXTURE3);
  gl.bindTexture(gl.TEXTURE_2D, this._depthRenderBuffer2);
  gl.uniform1i(this._programUberShader.shadowMap2, 3);
  /** ** Uniform for Ambient occlusion *** */
  gl.activeTexture(gl.TEXTURE4);
  gl.bindTexture(gl.TEXTURE_2D, this._aoMap);
  gl.uniform1i(this._programUberShader.aoMap, 4);
  /** ** Uniform for CSG *** */
  gl.activeTexture(gl.TEXTURE5);
  gl.bindTexture(gl.TEXTURE_2D, this.pingPongBuffer[1 - this.PPCurrent]);
  gl.uniform1i(this._programUberShader.csgMap, 5);
  gl.uniform3f(
    this._programUberShader.uZBounds,
    this.zBounds[0],
    this.zBounds[1],
    this.zBounds[2]
  );
  gl.uniform2f(
    this._programUberShader.viewportScale,
    gl.viewportWidth / nearestUpperPow2(gl.viewportWidth),
    gl.viewportHeight / nearestUpperPow2(gl.viewportHeight)
  );
  gl.uniform4f(
    this._programUberShader.cameraPos,
    this.cameraPos[0],
    this.cameraPos[1],
    this.cameraPos[2],
    this.cameraPos[3]
  );
  /** ** Uniform for Perlin noise *** */
  var perlin = false;
  if (this.perlin_val && this.perlin_val.amplitude > 0.0) {
    perlin = true;
  }
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
      continue;
    }
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    if (node.instance.perlin_val && node.instance.perlin_val.amplitude > 0.0) {
      perlin = true;
    }
  }
  if (perlin && this.perlin) {
    gl.activeTexture(gl.TEXTURE6);
    gl.bindTexture(gl.TEXTURE_2D, this.perlin);
    gl.uniform1i(this._programUberShader.perlinSamplerUniform, 6);
    gl.uniform3f(this._programUberShader.perlinOriginUniform, 0.0, 0.0, 0.0);
    gl.uniform1f(
      this._programUberShader.perlinAmplitudeUniform,
      this.perlin_val.amplitude / Math.sqrt(this.zoom)
    );
    gl.uniform1i(this._programUberShader.usePerlinUniform, true);
  } else {
    gl.uniform1f(this._programUberShader.perlinAmplitudeUniform, 0.0);
    gl.uniform3f(this._programUberShader.perlinScaleUniform, 0.0, 0.0, 0.0);
    gl.uniform1i(this._programUberShader.usePerlinUniform, false);
  }
  /** ** Lighting Informations **** */
  // Light direction is computed, but set latter (for correct lighting of
  // flipped nodes of CSG)
  var n;
  n =
    1.0 /
    Math.sqrt(
      light0.direction[0] * light0.direction[0] +
        light0.direction[1] * light0.direction[1] +
        light0.direction[2] * light0.direction[2]
    );
  var l0 = [
    light0.direction[0] * n,
    light0.direction[1] * n,
    light0.direction[2] * n,
  ];
  gl.uniform3f(
    this._programUberShader.lightDiffuseColor1,
    light0.diffuse[0],
    light0.diffuse[1],
    light0.diffuse[2]
  );
  gl.uniform3f(
    this._programUberShader.lightSpecularColor1,
    light0.specular[0],
    light0.specular[1],
    light0.specular[2]
  );
  n =
    1.0 /
    Math.sqrt(
      light1.direction[0] * light1.direction[0] +
        light1.direction[1] * light1.direction[1] +
        light1.direction[2] * light1.direction[2]
    );
  var l1 = [
    light1.direction[0] * n,
    light1.direction[1] * n,
    light1.direction[2] * n,
  ];
  gl.uniform3f(
    this._programUberShader.lightDiffuseColor2,
    light1.diffuse[0],
    light1.diffuse[1],
    light1.diffuse[2]
  );
  gl.uniform3f(
    this._programUberShader.lightSpecularColor2,
    light1.specular[0],
    light1.specular[1],
    light1.specular[2]
  );
  gl.uniform3f(
    this._programUberShader.ambientColor,
    scene_ambient[0],
    scene_ambient[1],
    scene_ambient[2]
  );
  /** *** Rendering our Triangles ***** */
  // 1st pass for opaque objects
  this.renderGeometryHQ(
    nodes,
    light0MVPMatrix,
    light1MVPMatrix,
    global_material,
    l0,
    l1,
    true
  );
  // 2nd pass for transparent objects
  this.renderGeometryHQ(
    nodes,
    light0MVPMatrix,
    light1MVPMatrix,
    global_material,
    l0,
    l1,
    false
  );
  this.renderSelectedNodes(nodes);
  gl.activeTexture(gl.TEXTURE0);
  gl.disableVertexAttribArray(this._programUberShader.texCoord0Attribute);
  gl.disableVertexAttribArray(this._programUberShader.normalAttribute);
  gl.disableVertexAttribArray(this._programUberShader.vertexAttribute);
  // this.showTextureMap(this._depthRenderBuffer, [ -1.0, 0.0, 0.0, 1.0 ]);
  // this.showTextureMap(this._nodeMap, [ -1.0, 0.0, 0.0, 1.0 ]);
  // this.showTextureMap(this._debugMap, [ -1.0, -1.0, 1.0, 1.0 ]);
  // this.showTextureMap(this._DepthMap1, [ -1.0, -1.0, 1.0, 1.0 ]);
  // this.showTextureMap(this.pingPongBuffer[1 - this.PPCurrent], [ -1.0, 0.0, 0.0, 1.0 ]);
  // this.showTextureMap(this._tmpMap, [ -1.0, 0.0, 0.0, 1.0 ]);
  // this.showTextureMap(this._depthMap, [ -1.0, 0.0, 0.0, 1.0 ]);
};
Sculpteo3DViewerWebGL.prototype.drawSceneLQ = function (
  nodes,
  scene_ambient,
  light0,
  light1,
  global_material,
  wireframe,
  top
) {
  var gl = this.gl;
  gl.useProgram(this.shaderProgram);
  gl.disable(gl.CULL_FACE);
  var perlin = false;
  if (this.perlin_val && this.perlin_val.amplitude > 0.0) {
    perlin = true;
  }
  if (!wireframe && perlin && this.perlin) {
    gl.activeTexture(gl.TEXTURE6);
    gl.bindTexture(gl.TEXTURE_2D, this.perlin);
    gl.uniform1i(this.shaderProgram.perlinSamplerUniform, 6);
    gl.uniform3f(this.shaderProgram.perlinOriginUniform, 0.0, 0.0, 0.0);
    gl.uniform1f(
      this.shaderProgram.perlinAmplitudeUniform,
      this.perlin_val.amplitude / Math.sqrt(this.zoom)
    );
    gl.uniform1i(this.shaderProgram.usePerlinUniform, true);
  } else {
    gl.uniform1f(this.shaderProgram.perlinAmplitudeUniform, 0.0);
    gl.uniform3f(this.shaderProgram.perlinScaleUniform, 0.0, 0.0, 0.0);
    gl.uniform1i(this.shaderProgram.usePerlinUniform, false);
  }
  gl.enableVertexAttribArray(this.shaderProgram.vertexPositionAttribute);
  gl.enableVertexAttribArray(this.shaderProgram.vertexNormalAttribute);
  gl.enableVertexAttribArray(this.shaderProgram.textureCoordAttribute);
  if (wireframe || this.wireframe) {
    gl.uniform3f(this.shaderProgram.ambientColorUniform, 1.0, 1.0, 1.0);
    gl.uniform3f(this.shaderProgram.light0DiffuseColorUniform, 0.0, 0.0, 0.0);
    gl.uniform3f(this.shaderProgram.light0SpecularColorUniform, 0.0, 0.0, 0.0);
    gl.uniform3f(this.shaderProgram.light1DiffuseColorUniform, 0.0, 0.0, 0.0);
    gl.uniform3f(this.shaderProgram.light1SpecularColorUniform, 0.0, 0.0, 0.0);
  } else {
    gl.uniform3f(
      this.shaderProgram.ambientColorUniform,
      scene_ambient[0],
      scene_ambient[1],
      scene_ambient[2]
    );
    gl.uniform3f(
      this.shaderProgram.light0DiffuseColorUniform,
      light0.diffuse[0],
      light0.diffuse[1],
      light0.diffuse[2]
    );
    gl.uniform3f(
      this.shaderProgram.light0SpecularColorUniform,
      light0.specular[0],
      light0.specular[1],
      light0.specular[2]
    );
    gl.uniform3f(
      this.shaderProgram.light1DiffuseColorUniform,
      light1.diffuse[0],
      light1.diffuse[1],
      light1.diffuse[2]
    );
    gl.uniform3f(
      this.shaderProgram.light1SpecularColorUniform,
      light1.specular[0],
      light1.specular[1],
      light1.specular[2]
    );
  }
  gl.uniform3f(
    this.shaderProgram.light0DirectionUniform,
    light0.direction[0],
    light0.direction[1],
    light0.direction[2]
  );
  gl.uniform3f(
    this.shaderProgram.light1DirectionUniform,
    light1.direction[0],
    light1.direction[1],
    light1.direction[2]
  );
  if (top) {
    gl.clear(gl.DEPTH_BUFFER_BIT);
  }
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (wireframe) {
      if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_WIREFRAME)) {
        continue;
      }
    } else {
      if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
        continue;
      }
    }
    if (top && !(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_ON_TOP)) {
      continue;
    }
    if (!top && node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_ON_TOP) {
      continue;
    }
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    var mtype = node.material || "global";
    if (node.instance.interactive & Sculpteo3DViewerCommon.INTERACTIVE_SELECT) {
      mtype = "selected";
    }
    if (
      !(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_NO_CUT) &&
      (this.cutX || this.cutY || this.cutZ || this.cutAxis)
    ) {
      if (this.cutX) {
        gl.uniform3f(
          this.shaderProgram.cutX,
          this.cutX.min,
          this.cutX.max,
          this.cutX.thickness
        );
      } else {
        gl.uniform3f(this.shaderProgram.cutX, 0.0, 0.0, 0.0);
      }
      if (this.cutY) {
        gl.uniform3f(
          this.shaderProgram.cutY,
          this.cutY.min,
          this.cutY.max,
          this.cutY.thickness
        );
      } else {
        gl.uniform3f(this.shaderProgram.cutY, 0.0, 0.0, 0.0);
      }
      if (this.cutZ) {
        gl.uniform3f(
          this.shaderProgram.cutZ,
          this.cutZ.min,
          this.cutZ.max,
          this.cutZ.thickness
        );
      } else {
        gl.uniform3f(this.shaderProgram.cutZ, 0.0, 0.0, 0.0);
      }
      if (!this.cutColor) {
        gl.uniform4f(this.shaderProgram.cutColor, 0.0, 0.0, 0.0, 0.0);
      }
      if (!this.cutAxis) {
        gl.uniform4f(this.shaderProgram.cutAxis, 0.0, 0.0, 0.0, 0.0);
      }
      if (this.cutAxis && this.doubleCut) {
        var tmpArray = node.transform
          .transpose()
          .x([this.cutAxis.x, this.cutAxis.y, this.cutAxis.z, -this.doubleCut]);
        gl.uniform1f(this.shaderProgram.doubleCut, -tmpArray[3]);
        gl.uniform1i(this.shaderProgram.uDoubleCut, true);
      } else if (this.cutAxis) {
        gl.uniform1f(this.shaderProgram.doubleCut, 0.0);
        gl.uniform1i(this.shaderProgram.uDoubleCut, false);
      }
      gl.uniform3f(this.shaderProgram.cutXColor, 1.0, 0.0, 0.0);
      gl.uniform3f(this.shaderProgram.cutYColor, 0.0, 1.0, 0.0);
      gl.uniform3f(this.shaderProgram.cutZColor, 0.0, 0.0, 1.0);
      if (this.cutColor && this.cutColor.back_r) {
        gl.uniform3f(
          this.shaderProgram.badOrientationColorUniform,
          this.cutColor.back_r,
          this.cutColor.back_g,
          this.cutColor.back_b
        );
      } else {
        gl.uniform3f(
          this.shaderProgram.badOrientationColorUniform,
          0.5,
          0.5,
          0.5
        );
      }
    } else {
      gl.uniform4f(this.shaderProgram.cutColor, 0.0, 0.0, 0.0, 0.0);
      gl.uniform4f(this.shaderProgram.cutAxis, 0.0, 0.0, 0.0, 0.0);
      gl.uniform3f(this.shaderProgram.cutX, 0.0, 0.0, 0.0);
      gl.uniform3f(this.shaderProgram.cutY, 0.0, 0.0, 0.0);
      gl.uniform3f(this.shaderProgram.cutZ, 0.0, 0.0, 0.0);
      gl.uniform1f(this.shaderProgram.doubleCut, 0.0);
      gl.uniform1i(this.shaderProgram.uDoubleCut, false);
    }
    if (this.perlin_val && this.perlin_val.amplitude > 0.0 && this.perlin) {
      var scale = Math.pow(Math.abs(node.transform.matrix.det()), 1.0 / 3.0);
      gl.uniform3f(
        this.shaderProgram.perlinScaleUniform,
        this.perlin_val.scale_x * scale,
        this.perlin_val.scale_y * scale,
        this.perlin_val.scale_z * scale
      );
      gl.uniform1i(this.shaderProgram.usePerlinUniform, true);
    }
    var mvMatrix = this.mvMatrix.x(node.transform);
    gl.uniformMatrix4fv(
      this.shaderProgram.mvMatrixUniform,
      false,
      mvMatrix.toFloat32Array()
    );
    var normalMatrix = mvMatrix.inverse();
    normalMatrix = normalMatrix.transpose();
    gl.uniformMatrix4fv(
      this.shaderProgram.nMatrixUniform,
      false,
      normalMatrix.toFloat32Array()
    );
    if (
      !(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_NO_CUT) &&
      this.cutAxis
    ) {
      var tmpArray = node.transform
        .transpose()
        .x([this.cutAxis.x, this.cutAxis.y, this.cutAxis.z, -this.cutAxis.w]);
      var cutAxisSupport = {
        x: tmpArray[0],
        y: tmpArray[1],
        z: tmpArray[2],
        w: -tmpArray[3],
      };
      gl.uniform4f(
        this.shaderProgram.cutAxis,
        cutAxisSupport.x,
        cutAxisSupport.y,
        cutAxisSupport.z,
        cutAxisSupport.w
      );
    }
    if (
      !(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_NO_CUT) &&
      this.cutColor
    ) {
      var scale = node.transform.matrix.e(1, 1);
      gl.uniform4f(
        this.shaderProgram.cutColor,
        this.cutColor.r,
        this.cutColor.g,
        this.cutColor.b,
        this.cutColor.margin * scale
      );
    }
    for (var vbi = 0; vbi < vbos.length; vbi++) {
      if (vbos[vbi].hidden) continue;
      if (wireframe || this.wireframe) {
        var color = { r: 0, g: 0, b: 0 };
        if (wireframe) {
          color = node.instance.wireframeColor;
          if (!color) {
            color = { r: 0, g: 0, b: 0 };
          }
        }
        var color_r, color_g, color_b;
        color_r = color.r / 255.0;
        color_g = color.g / 255.0;
        color_b = color.b / 255.0;
        gl.uniform1i(this.shaderProgram.useTexturesUniform, false);
        gl.uniform3f(
          this.shaderProgram.materialAmbientColorUniform,
          color_r,
          color_g,
          color_b
        );
        gl.uniform3f(
          this.shaderProgram.materialDiffuseColorUniform,
          color_r,
          color_g,
          color_b
        );
        gl.uniform3f(
          this.shaderProgram.materialSpecularColorUniform,
          0.0,
          0.0,
          0.0
        );
        gl.uniform1f(this.shaderProgram.materialShininessUniform, 1.0);
        gl.uniform1i(this.shaderProgram.useEnvmapUniform, false);
        var positions = vbos[vbi].edges;
        gl.bindBuffer(gl.ARRAY_BUFFER, positions);
        gl.vertexAttribPointer(
          this.shaderProgram.vertexPositionAttribute,
          positions.itemSize,
          gl.FLOAT,
          false,
          0,
          0
        );
        // Unused but must be bound to something
        // (or we could just bind another shader)
        gl.vertexAttribPointer(
          this.shaderProgram.textureCoordAttribute,
          positions.itemSize,
          gl.FLOAT,
          false,
          0,
          0
        );
        gl.vertexAttribPointer(
          this.shaderProgram.vertexNormalAttribute,
          positions.itemSize,
          gl.FLOAT,
          false,
          0,
          0
        );
        gl.drawArrays(gl.LINES, 0, positions.numItems);
      } else {
        var envmap = false;
        var material;
        switch (mtype) {
          case "global":
            if (global_material) {
              material = global_material;
            } else {
              material = vbos[vbi].material;
            }
            break;
          case "selected":
            material = {
              color: this.selcolor,
            };
            break;
          case "mesh":
            material = vbos[vbi].material;
            break;
          default:
            material = this.parseMaterial(mtype);
        }
        if (!material) {
          material = {};
        }
        if (material.color) {
          var color_r, color_g, color_b;
          color_r = material.color.r / 255.0;
          color_g = material.color.g / 255.0;
          color_b = material.color.b / 255.0;
          gl.uniform1i(this.shaderProgram.useTexturesUniform, false);
          gl.uniform3f(
            this.shaderProgram.materialAmbientColorUniform,
            color_r,
            color_g,
            color_b
          );
          gl.uniform3f(
            this.shaderProgram.materialDiffuseColorUniform,
            color_r,
            color_g,
            color_b
          );
          gl.uniform3f(
            this.shaderProgram.materialSpecularColorUniform,
            0.0,
            0.0,
            0.0
          );
          gl.uniform1f(this.shaderProgram.materialShininessUniform, 1.0);
        } else if (material.texture) {
          var texture = material.texture;
          if (texture && texture.loaded) {
            if (!texture.glid) {
              // Upload texture to GPU
              texture.glid = gl.createTexture();
              gl.bindTexture(gl.TEXTURE_2D, texture.glid);
              gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
              gl.texImage2D(
                gl.TEXTURE_2D,
                0,
                gl.RGBA,
                gl.RGBA,
                gl.UNSIGNED_BYTE,
                texture
              );
              gl.texParameteri(
                gl.TEXTURE_2D,
                gl.TEXTURE_MAG_FILTER,
                gl.NEAREST
              );
              gl.texParameteri(
                gl.TEXTURE_2D,
                gl.TEXTURE_MIN_FILTER,
                gl.NEAREST
              );
              gl.bindTexture(gl.TEXTURE_2D, null);
            }
            gl.uniform1i(this.shaderProgram.useTexturesUniform, true);
            gl.uniform3f(
              this.shaderProgram.materialSpecularColorUniform,
              0.0,
              0.0,
              0.0
            );
            gl.uniform1f(this.shaderProgram.materialShininessUniform, 1.0);
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, texture.glid);
            gl.uniform1i(this.shaderProgram.samplerUniform, 0);
          } else {
            // Texture not there yet
            gl.uniform1i(this.shaderProgram.useTexturesUniform, false);
            gl.uniform3f(
              this.shaderProgram.materialAmbientColorUniform,
              1.0,
              1.0,
              1.0
            );
            gl.uniform3f(
              this.shaderProgram.materialDiffuseColorUniform,
              1.0,
              1.0,
              1.0
            );
            gl.uniform3f(
              this.shaderProgram.materialSpecularColorUniform,
              0.0,
              0.0,
              0.0
            );
            gl.uniform1f(this.shaderProgram.materialShininessUniform, 1.0);
          }
        } else if (material.ambient) {
          gl.uniform1i(this.shaderProgram.useTexturesUniform, false);
          if (material.ambient) {
            if (material.ambient.color) {
              gl.uniform3f(
                this.shaderProgram.materialAmbientColorUniform,
                material.ambient.color.r / 255,
                material.ambient.color.g / 255,
                material.ambient.color.b / 255
              );
            } /* Comment out unused code
						else {
							// TODO: texture
						}*/
          }
          if (material.diffuse) {
            if (material.diffuse.color) {
              gl.uniform3f(
                this.shaderProgram.materialDiffuseColorUniform,
                material.diffuse.color.r / 255,
                material.diffuse.color.g / 255,
                material.diffuse.color.b / 255
              );
            } else if (material.diffuse.texture) {
              var texture = material.diffuse.texture;
              if (texture && texture.loaded) {
                if (!texture.glid) {
                  // Upload texture to GPU
                  texture.glid = gl.createTexture();
                  gl.bindTexture(gl.TEXTURE_2D, texture.glid);
                  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
                  gl.texImage2D(
                    gl.TEXTURE_2D,
                    0,
                    gl.RGBA,
                    gl.RGBA,
                    gl.UNSIGNED_BYTE,
                    texture
                  );
                  gl.texParameteri(
                    gl.TEXTURE_2D,
                    gl.TEXTURE_MAG_FILTER,
                    gl.NEAREST
                  );
                  gl.texParameteri(
                    gl.TEXTURE_2D,
                    gl.TEXTURE_MIN_FILTER,
                    gl.NEAREST
                  );
                  gl.bindTexture(gl.TEXTURE_2D, null);
                }
                gl.uniform1i(this.shaderProgram.useTexturesUniform, true);
                gl.uniform3f(
                  this.shaderProgram.materialSpecularColorUniform,
                  0.0,
                  0.0,
                  0.0
                );
                gl.uniform1f(this.shaderProgram.materialShininessUniform, 1.0);
                gl.activeTexture(gl.TEXTURE0);
                gl.bindTexture(gl.TEXTURE_2D, texture.glid);
                gl.uniform1i(this.shaderProgram.samplerUniform, 0);
              } else {
                // Texture not there yet
                gl.uniform1i(this.shaderProgram.useTexturesUniform, false);
                gl.uniform3f(
                  this.shaderProgram.materialAmbientColorUniform,
                  1.0,
                  1.0,
                  1.0
                );
                gl.uniform3f(
                  this.shaderProgram.materialDiffuseColorUniform,
                  1.0,
                  1.0,
                  1.0
                );
                gl.uniform3f(
                  this.shaderProgram.materialSpecularColorUniform,
                  0.0,
                  0.0,
                  0.0
                );
                gl.uniform1f(this.shaderProgram.materialShininessUniform, 1.0);
              }
            }
          }
          if (material.specular) {
            if (material.specular.color) {
              gl.uniform3f(
                this.shaderProgram.materialSpecularColorUniform,
                material.specular.color.r / 255,
                material.specular.color.g / 255,
                material.specular.color.b / 255
              );
              if (
                material.specular.color.r != 0 ||
                material.specular.color.g != 0 ||
                material.specular.color.b != 0
              ) {
                envmap = this.envmap;
              }
            } else if (material.specular.texture) {
              // TODO: texture
            }
          } else {
            gl.uniform1i(this.shaderProgram.useEnvmapUniform, false);
          }
          gl.uniform1f(
            this.shaderProgram.materialShininessUniform,
            material.shininess
          );
        } else {
          gl.uniform1i(this.shaderProgram.useTexturesUniform, false);
          gl.uniform3f(
            this.shaderProgram.materialAmbientColorUniform,
            1.0,
            1.0,
            1.0
          );
          gl.uniform3f(
            this.shaderProgram.materialDiffuseColorUniform,
            1.0,
            1.0,
            1.0
          );
          gl.uniform3f(
            this.shaderProgram.materialSpecularColorUniform,
            0.0,
            0.0,
            0.0
          );
          gl.uniform1f(this.shaderProgram.materialShininessUniform, 1.0);
        }
        if (envmap && this.envmap_texture) {
          gl.activeTexture(gl.TEXTURE1);
          gl.bindTexture(gl.TEXTURE_2D, this.envmap_texture);
          gl.uniform1i(this.shaderProgram.envmapSamplerUniform, 1);
          gl.uniform1i(this.shaderProgram.useEnvmapUniform, true);
        } else {
          gl.uniform1i(this.shaderProgram.useEnvmapUniform, false);
        }
        var positions = vbos[vbi].positions;
        var texcoords = vbos[vbi].texcoords;
        var normals;
        if (this.smooth_normals) {
          normals = vbos[vbi].smooth_normals;
        } else {
          normals = vbos[vbi].normals;
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, positions);
        gl.vertexAttribPointer(
          this.shaderProgram.vertexPositionAttribute,
          positions.itemSize,
          gl.FLOAT,
          false,
          0,
          0
        );
        gl.bindBuffer(gl.ARRAY_BUFFER, texcoords);
        gl.vertexAttribPointer(
          this.shaderProgram.textureCoordAttribute,
          texcoords.itemSize,
          gl.FLOAT,
          false,
          0,
          0
        );
        gl.bindBuffer(gl.ARRAY_BUFFER, normals);
        gl.vertexAttribPointer(
          this.shaderProgram.vertexNormalAttribute,
          normals.itemSize,
          gl.FLOAT,
          false,
          0,
          0
        );
        gl.drawArrays(gl.TRIANGLES, 0, positions.numItems);
      }
    }
  }
};
Sculpteo3DViewerWebGL.prototype.setBbox = function (name, bbox) {
  var gl = this.gl;
  Sculpteo3DViewerCommon.prototype.setBbox.call(this, name, bbox);
  // Patch the edge buffer
  var positions = this.scene.nodes[name].bboxModel[0].edges;
  bbox = this.expandBBox(this.scene.nodes[name].bbox);
  gl.bindBuffer(gl.ARRAY_BUFFER, positions);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array([
      bbox[0].x,
      bbox[0].y,
      bbox[0].z,
      bbox[1].x,
      bbox[0].y,
      bbox[0].z,
      bbox[1].x,
      bbox[0].y,
      bbox[0].z,
      bbox[1].x,
      bbox[1].y,
      bbox[0].z,
      bbox[1].x,
      bbox[1].y,
      bbox[0].z,
      bbox[0].x,
      bbox[1].y,
      bbox[0].z,
      bbox[0].x,
      bbox[1].y,
      bbox[0].z,
      bbox[0].x,
      bbox[0].y,
      bbox[0].z,
      bbox[0].x,
      bbox[0].y,
      bbox[1].z,
      bbox[1].x,
      bbox[0].y,
      bbox[1].z,
      bbox[1].x,
      bbox[0].y,
      bbox[1].z,
      bbox[1].x,
      bbox[1].y,
      bbox[1].z,
      bbox[1].x,
      bbox[1].y,
      bbox[1].z,
      bbox[0].x,
      bbox[1].y,
      bbox[1].z,
      bbox[0].x,
      bbox[1].y,
      bbox[1].z,
      bbox[0].x,
      bbox[0].y,
      bbox[1].z,
      bbox[0].x,
      bbox[0].y,
      bbox[0].z,
      bbox[0].x,
      bbox[0].y,
      bbox[1].z,
      bbox[1].x,
      bbox[0].y,
      bbox[0].z,
      bbox[1].x,
      bbox[0].y,
      bbox[1].z,
      bbox[0].x,
      bbox[1].y,
      bbox[0].z,
      bbox[0].x,
      bbox[1].y,
      bbox[1].z,
      bbox[1].x,
      bbox[1].y,
      bbox[0].z,
      bbox[1].x,
      bbox[1].y,
      bbox[1].z,
    ]),
    gl.STATIC_DRAW
  );
  positions.itemSize = 3;
  positions.numItems = 24;
};
Sculpteo3DViewerWebGL.prototype.drawSceneBbox = function (
  nodes,
  scene_ambient,
  light0,
  light1,
  global_material
) {
  var gl = this.gl;
  gl.enable(gl.BLEND);
  gl.useProgram(this._programFlatTransparent);
  gl.uniform3f(
    this._programFlatTransparent.ambientColor,
    scene_ambient[0],
    scene_ambient[1],
    scene_ambient[2]
  );
  gl.uniform3f(
    this._programFlatTransparent.lightDirection1,
    light0.direction[0],
    light0.direction[1],
    light0.direction[2]
  );
  gl.uniform3f(
    this._programFlatTransparent.lightDiffuseColor1,
    light0.diffuse[0],
    light0.diffuse[1],
    light0.diffuse[2]
  );
  gl.uniform3f(
    this._programFlatTransparent.lightDirection2,
    light1.direction[0],
    light1.direction[1],
    light1.direction[2]
  );
  gl.uniform3f(
    this._programFlatTransparent.lightDiffuseColor2,
    light1.diffuse[0],
    light1.diffuse[1],
    light1.diffuse[2]
  );
  gl.enableVertexAttribArray(
    this._programFlatTransparent.vertexPositionAttribute
  );
  gl.enableVertexAttribArray(
    this._programFlatTransparent.vertexNormalAttribute
  );
  gl.uniformMatrix4fv(
    this._programFlatTransparent.projectionMatrix,
    false,
    this.pMatrix.toFloat32Array()
  );
  var color = { r: 0, g: 0, b: 0 };
  var color_r, color_g, color_b;
  color_r = color.r / 255.0;
  color_g = color.g / 255.0;
  color_b = color.b / 255.0;
  gl.uniform1f(this._programFlatTransparent.opacity, 1.0);
  gl.uniform3f(
    this._programFlatTransparent.materialAmbientColor,
    color_r,
    color_g,
    color_b
  );
  gl.uniform3f(
    this._programFlatTransparent.materialDiffuseColor,
    color_r,
    color_g,
    color_b
  );
  // Do not write to z-buffer
  gl.depthMask(false);
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_BBOX) && node.model) {
      continue;
    }
    var vbos = node.proto.bboxModel;
    if (!vbos) {
      continue;
    }
    color = node.instance.bboxColor;
    if (!color) {
      color = { r: 0, g: 0, b: 0 };
    }
    var color_r, color_g, color_b;
    color_r = color.r / 255.0;
    color_g = color.g / 255.0;
    color_b = color.b / 255.0;
    gl.uniform1f(this._programFlatTransparent.opacity, color.a / 255.0);
    gl.uniform3f(
      this._programFlatTransparent.materialAmbientColor,
      color_r,
      color_g,
      color_b
    );
    gl.uniform3f(
      this._programFlatTransparent.materialDiffuseColor,
      color_r,
      color_g,
      color_b
    );
    var mvMatrix = this.mvMatrix.x(node.transform);
    mvMatrix = mvMatrix.x(node.proto.transform.inverse());
    gl.uniformMatrix4fv(
      this._programFlatTransparent.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    var normalMatrix = mvMatrix.inverse();
    normalMatrix = normalMatrix.transpose();
    gl.uniformMatrix4fv(
      this._programFlatTransparent.normalMatrix,
      false,
      normalMatrix.toFloat32Array()
    );
    var positions = vbos[0].positions;
    var normals = vbos[0].normals;
    gl.bindBuffer(gl.ARRAY_BUFFER, positions);
    gl.vertexAttribPointer(
      this._programFlatTransparent.vertexPositionAttribute,
      positions.itemSize,
      gl.FLOAT,
      false,
      0,
      0
    );
    gl.bindBuffer(gl.ARRAY_BUFFER, normals);
    gl.vertexAttribPointer(
      this._programFlatTransparent.vertexNormalAttribute,
      normals.itemSize,
      gl.FLOAT,
      false,
      0,
      0
    );
    gl.drawArrays(gl.TRIANGLES, 0, positions.numItems);
  }
  gl.disable(gl.BLEND);
  gl.lineWidth(2.0);
  for (var n = 0; n < nodes.length; n++) {
    var node = nodes[n];
    if (typeof node == "undefined") {
      continue;
    }
    if (!(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_BBOX) && node.model) {
      continue;
    }
    var vbos = node.proto.bboxModel;
    if (!vbos) {
      continue;
    }
    color = node.instance.wireframeColor;
    if (!color) {
      color = { r: 0, g: 0, b: 0 };
    }
    var color_r, color_g, color_b;
    color_r = color.r / 255.0;
    color_g = color.g / 255.0;
    color_b = color.b / 255.0;
    gl.uniform1f(this._programFlatTransparent.opacity, 1.0);
    gl.uniform3f(
      this._programFlatTransparent.materialAmbientColor,
      color_r,
      color_g,
      color_b
    );
    gl.uniform3f(
      this._programFlatTransparent.materialDiffuseColor,
      color_r,
      color_g,
      color_b
    );
    var mvMatrix = this.mvMatrix.x(node.transform);
    mvMatrix = mvMatrix.x(node.proto.transform.inverse());
    gl.uniformMatrix4fv(
      this._programFlatTransparent.modelViewMatrix,
      false,
      mvMatrix.toFloat32Array()
    );
    var normalMatrix = mvMatrix.inverse();
    normalMatrix = normalMatrix.transpose();
    gl.uniformMatrix4fv(
      this._programFlatTransparent.normalMatrix,
      false,
      normalMatrix.toFloat32Array()
    );
    var positions = vbos[0].edges;
    var bbox = node.proto.bbox;
    gl.bindBuffer(gl.ARRAY_BUFFER, positions);
    gl.vertexAttribPointer(
      this._programFlatTransparent.vertexPositionAttribute,
      positions.itemSize,
      gl.FLOAT,
      false,
      0,
      0
    );
    gl.vertexAttribPointer(
      this._programFlatTransparent.vertexNormalAttribute,
      positions.itemSize,
      gl.FLOAT,
      false,
      0,
      0
    );
    gl.drawArrays(gl.LINES, 0, positions.numItems);
  }
  gl.disableVertexAttribArray(
    this._programFlatTransparent.vertexPositionAttribute
  );
  gl.disableVertexAttribArray(
    this._programFlatTransparent.vertexNormalAttribute
  );
  // Restore write to z-buffer
  gl.depthMask(true);
};
Sculpteo3DViewerWebGL.prototype.copyToDestinationTexture = function (texture) {
  var gl = this.gl;
  gl.disable(gl.DEPTH_TEST);
  if (typeof this._programCopyDM.projectionMatrix != "undefined") {
    gl.uniformMatrix4fv(
      this._programCopyDM.projectionMatrix,
      false,
      this.identity
    );
  }
  if (typeof this._programCopyDM.modelViewMatrix != "undefined") {
    gl.uniformMatrix4fv(
      this._programCopyDM.modelViewMatrix,
      false,
      this.identity
    );
  }
  var scale_x = gl.viewportWidth / nearestUpperPow2(gl.viewportWidth);
  var scale_y = gl.viewportHeight / nearestUpperPow2(gl.viewportHeight);
  var p = [-1.0, -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0];
  var t = [0.0, 0.0, scale_x, 0.0, scale_x, scale_y, 0.0, scale_y];
  this.drawTexturedQuad(this._programCopyDM, texture, 1.0, p, t);
  gl.enable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.copyDepthMapOverForbiddenRegion = function (
  parity,
  mask
) {
  var gl = this.gl;
  // Draw a quad and set depth to MAX if fragment is discarded
  // clears the stencil buffer as well
  gl.disable(gl.DEPTH_TEST);
  gl.stencilMask(mask);
  gl.stencilFunc(gl.NOTEQUAL, parity, mask);
  gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
  if (typeof this._programCopyDM.projectionMatrix != "undefined") {
    gl.uniformMatrix4fv(
      this._programCopyDM.projectionMatrix,
      false,
      this.identity
    );
  }
  if (typeof this._programCopyDM.modelViewMatrix != "undefined") {
    gl.uniformMatrix4fv(
      this._programCopyDM.modelViewMatrix,
      false,
      this.identity
    );
  }
  var scale_x = gl.viewportWidth / nearestUpperPow2(gl.viewportWidth);
  var scale_y = gl.viewportHeight / nearestUpperPow2(gl.viewportHeight);
  var p = [-1.0, -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0];
  var t = [0.0, 0.0, scale_x, 0.0, scale_x, scale_y, 0.0, scale_y];
  this.drawTexturedQuad(
    this._programCopyDM,
    this.pingPongBuffer[1 - this.PPCurrent],
    1.0,
    p,
    t
  );
  gl.enable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.combiningDepthMap = function (parity, mask) {
  var gl = this.gl;
  // Draw a quad and set depth to MAX if fragment is discarded
  // clears the stencil buffer as well
  gl.disable(gl.DEPTH_TEST);
  gl.stencilMask(mask);
  gl.stencilFunc(gl.EQUAL, parity, mask);
  gl.stencilOp(gl.ZERO, gl.ZERO, gl.ZERO);
  if (typeof this._programCombineDM.projectionMatrix != "undefined") {
    gl.uniformMatrix4fv(
      this._programCombineDM.projectionMatrix,
      false,
      this.identity
    );
  }
  if (typeof this._programCombineDM.modelViewMatrix != "undefined") {
    gl.uniformMatrix4fv(
      this._programCombineDM.modelViewMatrix,
      false,
      this.identity
    );
  }
  var scale_x = gl.viewportWidth / nearestUpperPow2(gl.viewportWidth);
  var scale_y = gl.viewportHeight / nearestUpperPow2(gl.viewportHeight);
  var p = [-1.0, -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0];
  var t = [0.0, 0.0, scale_x, 0.0, scale_x, scale_y, 0.0, scale_y];
  gl.activeTexture(gl.TEXTURE1);
  gl.bindTexture(gl.TEXTURE_2D, this.pingPongBuffer[1 - this.PPCurrent]);
  gl.uniform1i(this._programCombineDM.sampler2, 1);
  this.drawTexturedQuad(this._programCombineDM, this._tmpMap, 1.0, p, t);
  gl.bindTexture(gl.TEXTURE_2D, null);
  gl.activeTexture(gl.TEXTURE0);
  gl.enable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.showTextureMap = function (texture, rect) {
  var gl = this.gl;
  if (!rect) {
    rect = [-1.0, -1.0, 1.0, 1.0];
  }
  gl.useProgram(this._programSingleTexture);
  gl.enableVertexAttribArray(this._programSingleTexture.vertexAttribute);
  gl.enableVertexAttribArray(this._programSingleTexture.texCoord0Attribute);
  gl.disable(gl.DEPTH_TEST);
  gl.uniformMatrix4fv(
    this._programSingleTexture.projectionMatrix,
    false,
    this.identity
  );
  gl.uniformMatrix4fv(
    this._programSingleTexture.modelViewMatrix,
    false,
    this.identity
  );
  this.drawTexturedQuad(this._programSingleTexture, texture, 1.0, [
    rect[0],
    rect[1],
    rect[2],
    rect[1],
    rect[2],
    rect[3],
    rect[0],
    rect[3],
  ]);
  gl.disableVertexAttribArray(this._programSingleTexture.texCoord0Attribute);
  gl.enable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.showStencil = function (parity, mask) {
  var gl = this.gl;
  gl.useProgram(this._programConstantColor);
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  gl.colorMask(true, true, true, true);
  // Draw a quad and set depth to MAX if fragment is discarded
  gl.disable(gl.DEPTH_TEST);
  gl.depthMask(false);
  gl.stencilMask(mask);
  gl.stencilFunc(gl.EQUAL, parity, mask);
  gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
  gl.uniform4f(this._programConstantColor.color, 1.0, 0.0, 0.0, 1.0);
  gl.uniformMatrix4fv(
    this._programConstantColor.projectionMatrix,
    false,
    this.identity
  );
  gl.uniformMatrix4fv(
    this._programConstantColor.modelViewMatrix,
    false,
    this.identity
  );
  gl.enableVertexAttribArray(this._programConstantColor.vertexAttribute);
  this.drawQuad(this._programConstantColor, 1.0);
  gl.disableVertexAttribArray(this._programConstantColor.vertexAttribute);
  gl.enable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.drawSceneCSGDepthMap = function (
  nodes,
  index,
  modelView,
  projection,
  zBounds,
  texture,
  shadows
) {
  var gl = this.gl;
  var node_main = nodes[index];
  // Iterating on the number of layers in the node_main primitive
  for (var layer = 0; layer < node_main.nb_layers; layer++) {
    gl.enable(gl.DEPTH_TEST);
    // Step 1: Drawing Z of main_node
    // ------------------------------
    // Cull front or back faces of main primitive depending on type of operation
    gl.enable(gl.CULL_FACE);
    if (node_main.complemented) {
      if (shadows) {
        gl.cullFace(gl.BACK);
      } else {
        gl.cullFace(gl.FRONT);
      }
    } else {
      if (shadows) {
        gl.cullFace(gl.FRONT);
      } else {
        gl.cullFace(gl.BACK);
      }
    }
    gl.depthMask(true); // Writing in the z-buffer
    // Rendering a single layer at a time
    this.renderSingleLayerDM(
      node_main,
      layer,
      true,
      modelView,
      projection,
      zBounds
    );
    // Step 2: Parity Checked
    // ----------------------
    gl.clearStencil(1);
    gl.clear(gl.STENCIL_BUFFER_BIT);
    gl.colorMask(false, false, false, false);
    gl.useProgram(this._programConstantColor);
    gl.enableVertexAttribArray(this._programConstantColor.vertexAttribute);
    // Count number of primitives in front, toggling bit in the stencil buffer
    // for fragments in front of the principal shape
    gl.depthMask(false);
    gl.enable(gl.STENCIL_TEST);
    gl.disable(gl.CULL_FACE);
    var bit = 1;
    var cmp = 1;
    var n;
    for (n = 0; n < nodes.length; n++) {
      if (n == index) {
        continue;
      }
      var node_other = nodes[n];
      if (!(node_other.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)) {
        continue;
      }
      var model = this.getActiveModel(node_other);
      if (!model) {
        continue;
      }
      gl.stencilFunc(gl.ALWAYS, 0, 0);
      gl.stencilMask(1 << bit);
      // If z test fails, other primitive is behind and does not interfere
      // if z test succeeds, other primitive is in front, so toggle parity
      gl.stencilOp(gl.REPLACE, gl.KEEP, gl.INVERT);
      var pMatrix = projection.scale(1.0, 1.0, 0.5).translate(0.0, 0.0, 0.5);
      gl.uniformMatrix4fv(
        this._programConstantColor.projectionMatrix,
        false,
        pMatrix.toFloat32Array()
      );
      mvMatrix = modelView.x(node_other.transform);
      gl.uniformMatrix4fv(
        this._programConstantColor.modelViewMatrix,
        false,
        mvMatrix.toFloat32Array()
      );
      // Draw the other primitive, with parts in front of main primitive
      // toggling a parity bit in the stencil buffer
      this.drawModelWithPositionsAndNormals(
        model,
        this._programConstantColor.vertexAttribute,
        null
      );
      // For intersection, main primitive must be inside other primitive
      // for difference, main primitive must be outside other primitive
      if (!node_other.complemented) {
        cmp |= 1 << bit;
      }
      bit++;
      // Breaking the 8bit limitation
      if (bit >= 8) {
        this.packStencilBitsForCSG(cmp, index);
        bit = 1;
        cmp = 0x01;
      }
    }
    gl.disableVertexAttribArray(this._programConstantColor.vertexAttribute);
    // Step 3: Draw node_main only inside the primitives as determine by stencil buffer
    // ---------------------------------------------------------------------------------
    // Set the color to CSG mask in the texture map where the main primitive
    // should be drawn
    gl.colorMask(true, true, true, true);
    gl.disable(gl.BLEND);
    // Keep only fragments of main primitive that are:
    // - inside all other intersected primitives
    // - outside all other subtracted primitives
    // -----------------------
    // Copy of the previous DepthMap over the Forbidden Region
    // -----------------------
    gl.useProgram(this._programCopyDM);
    gl.enableVertexAttribArray(this._programCopyDM.vertexAttribute);
    gl.enableVertexAttribArray(this._programCopyDM.texCoord0Attribute);
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      this.pingPongBuffer[this.PPCurrent],
      0
    );
    this.copyDepthMapOverForbiddenRegion(cmp, (1 << bit) - 1);
    gl.disableVertexAttribArray(this._programCopyDM.vertexAttribute);
    gl.disableVertexAttribArray(this._programCopyDM.texCoord0Attribute);
    // ------------------------------------------------------------------
    // -----------------------
    // Combining the DepthMap
    // -----------------------
    gl.useProgram(this._programCombineDM);
    gl.enableVertexAttribArray(this._programCombineDM.vertexAttribute);
    gl.enableVertexAttribArray(this._programCombineDM.texCoord0Attribute);
    this.combiningDepthMap(cmp, (1 << bit) - 1);
    gl.disableVertexAttribArray(this._programCombineDM.vertexAttribute);
    gl.disableVertexAttribArray(this._programCombineDM.texCoord0Attribute);
    // ------------------------------------------------------------------
    // Restore normal render
    gl.enable(gl.BLEND);
    gl.disable(gl.STENCIL_TEST);
    gl.stencilMask(0xff);
    gl.depthMask(true);
    gl.colorMask(false, false, false, false);
    // Index swap buffer
    this.PPCurrent = 1 - this.PPCurrent;
  }
  // Step 4: Copy the depth Map into the Destination texture
  // ------------------------------------------------------
  // In order to compute the shadows map
  if (shadows) {
    gl.disable(gl.BLEND);
    // Gl.depthMask(false);
    gl.colorMask(true, true, true, true);
    gl.useProgram(this._programCopyDM);
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      texture,
      0
    );
    gl.enableVertexAttribArray(this._programCopyDM.vertexAttribute);
    gl.enableVertexAttribArray(this._programCopyDM.texCoord0Attribute);
    this.copyToDestinationTexture(this.pingPongBuffer[1 - this.PPCurrent]);
    gl.disableVertexAttribArray(this._programCopyDM.vertexAttribute);
    gl.disableVertexAttribArray(this._programCopyDM.texCoord0Attribute);
    // TEMP: Cursor ShadowMap Bug :p
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      null,
      0
    );
  }
  // Restore normal render
  gl.enable(gl.CULL_FACE);
  gl.cullFace(gl.BACK);
  gl.stencilMask(0xff);
  gl.disable(gl.BLEND);
  gl.colorMask(true, true, true, true);
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
  gl.enable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.packStencilBitsForCSG = function (
  ref_cmp,
  index
) {
  var gl = this.gl;
  gl.disable(gl.DEPTH_TEST);
  gl.uniformMatrix4fv(
    this._programConstantColor.projectionMatrix,
    false,
    this.identity
  );
  gl.uniformMatrix4fv(
    this._programConstantColor.modelViewMatrix,
    false,
    this.identity
  );
  // First pass:
  // put 0 in the stencil buffer where ref_cmp != stencil[x,y]
  // put ref_cmp otherwise
  gl.stencilFunc(gl.NOTEQUAL, ref_cmp, 0xff);
  gl.stencilMask(0xff);
  gl.stencilOp(gl.REPLACE, gl.KEEP, gl.ZERO);
  this.drawQuad(this._programConstantColor, 1.0);
  // Second pass:
  // put 1 in the stencil buffer where 1 <= stencil[x,y]
  // put 0 otherwise
  gl.stencilFunc(gl.LEQUAL, 0x01, 0xff);
  gl.stencilMask(0xff);
  gl.stencilOp(gl.ZERO, gl.KEEP, gl.REPLACE);
  this.drawQuad(this._programConstantColor, 1.0);
  gl.enable(gl.DEPTH_TEST);
};
Sculpteo3DViewerWebGL.prototype.updateProjectionMatrix = function () {
  var ar = this.width / this.height;
  if (!this.use_perspective) {
    if (ar > 1.0) {
      this.pMatrix = this.makeOrtho(
        -this.zoom * ar,
        this.zoom * ar,
        -this.zoom,
        this.zoom,
        this.nearVal,
        this.farVal
      );
    } else {
      this.pMatrix = this.makeOrtho(
        -this.zoom,
        this.zoom,
        -this.zoom / ar,
        this.zoom / ar,
        this.nearVal,
        this.farVal
      );
    }
    this.cameraMat = new Sculpteo3DViewerCommonTransform3D();
    this.cameraPos = [0.0, 0.0, 1.0, 0.0];
    this.cameraZ = 0;
    this.zBounds = [this.nearVal, this.farVal, 0];
  } else {
    this.cameraFov = 30.0;
    this.cameraZ = -1.0 / Math.tan((this.cameraFov * Math.PI) / 180.0 / 2.0);
    this.cameraZ *= this.zoom;
    if (-this.cameraZ + this.nearVal < 0.1) {
      this.cameraZ = this.nearVal - 0.1;
      this.cameraFov =
        ((Math.atan2(this.zoom, -this.cameraZ) * 180) / Math.PI) * 2.0;
    }
    this.zBounds = [
      -this.cameraZ + this.nearVal,
      -this.cameraZ + this.farVal,
      0,
    ];
    this.pMatrix = this.makePerspective(
      this.cameraFov,
      ar,
      this.zBounds[0],
      this.zBounds[1]
    );
    this.cameraMat = new Sculpteo3DViewerCommonTransform3D().translate(
      0.0,
      0.0,
      this.cameraZ
    );
    this.cameraPos = [0.0, 0.0, -this.cameraZ, 1.0];
  }
};
Sculpteo3DViewerWebGL.prototype.countCSGLayers = function (
  vbos,
  transform,
  modelView,
  projection,
  shadows
) {
  var gl = this.gl;
  // Rendering off-screen
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._debugMap,
    0
  );
  // Activating Blending in order to count in the texture
  gl.enable(gl.BLEND);
  gl.blendFunc(gl.ONE, gl.ONE);
  // Using the Unicolor Shader in order to paint in red color
  gl.useProgram(this._programConstantColor);
  gl.uniform4f(this._programConstantColor.color, 1.0 / 255.0, 0.0, 0.0, 1.0);
  // Desactivating the depth and stencil test
  gl.disable(gl.DEPTH_TEST);
  // Activating the Culling for the Back faces
  gl.enable(gl.CULL_FACE);
  gl.cullFace(gl.BACK);
  // Clearing the color buffer with a black color
  gl.colorMask(true, true, true, true);
  gl.clearColor(0.0, 0.0, 0.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  // Drawing pass
  gl.enableVertexAttribArray(this._programConstantColor.vertexAttribute);
  var mvMatrix = modelView.x(transform);
  gl.uniformMatrix4fv(
    this._programConstantColor.projectionMatrix,
    false,
    projection.toFloat32Array()
  );
  gl.uniformMatrix4fv(
    this._programConstantColor.modelViewMatrix,
    false,
    mvMatrix.toFloat32Array()
  );
  this.drawModelWithPositionsAndNormals(
    vbos,
    this._programConstantColor.vertexAttribute,
    null
  );
  gl.disableVertexAttribArray(this._programConstantColor.vertexAttribute);
  // Transmitting the informations from GPU to CPU
  if (!this.debug_buffer) {
    this.debug_buffer = new Uint8Array(
      4 *
        nearestUpperPow2(gl.viewportWidth) *
        nearestUpperPow2(gl.viewportHeight)
    );
  }
  // Looking for the max value in the texture
  var max = this.PingPongMax(
    this._debugMap,
    nearestUpperPow2(gl.viewportWidth),
    nearestUpperPow2(gl.viewportHeight)
  );
  // Var max = this.textureMax(this.debug_buffer);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    null,
    0
  );
  return max;
};
Sculpteo3DViewerWebGL.prototype.textureMax = function (map) {
  var gl = this.gl;
  var max = 0;
  gl.readPixels(
    0,
    0,
    nearestUpperPow2(gl.viewportWidth),
    nearestUpperPow2(gl.viewportHeight),
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    map
  );
  // Looking only for the max on the Red component of the texture
  for (var i = 0; i < map.length; i += 4) {
    if (map[i] >= max) {
      max = map[i];
    }
  }
  return max;
};
Sculpteo3DViewerWebGL.prototype.log2 = function (val) {
  return Math.log(val) / Math.LN2;
};
Sculpteo3DViewerWebGL.prototype.PingPongMax = function (
  texture,
  texture_w,
  texture_h
) {
  var gl = this.gl;
  var size_min = Math.min(texture_w, texture_h);
  var size_max = Math.max(texture_w, texture_h);
  // *	Drawing Settings
  gl.disable(gl.BLEND);
  gl.disable(gl.DEPTH_TEST);
  gl.colorMask(true, true, true, true);
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  gl.viewport(0, 0, texture_w, texture_h);
  gl.useProgram(this._programCSGmax);
  var step = 2.0;
  var scale;
  var pace = 0.0; // UPPER LEFT
  this.pingPongBuffer = [this._DepthMap1, texture];
  this.PPCurrent = 0;
  gl.enableVertexAttribArray(this._programCSGmax.vertexAttribute);
  gl.enableVertexAttribArray(this._programCSGmax.texCoord0Attribute);
  // *	Number of Iteration: log2(size_max) times
  for (var i = 0; i < this.log2(size_max); i++) {
    gl.disable(gl.BLEND);
    gl.colorMask(true, true, true, true);
    // *	Writing the output to the PingPong Buffer
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      this.pingPongBuffer[this.PPCurrent],
      0
    );
    gl.uniformMatrix4fv(
      this._programCSGmax.projectionMatrix,
      false,
      this.identity
    );
    gl.uniformMatrix4fv(
      this._programCSGmax.modelViewMatrix,
      false,
      this.identity
    );
    gl.uniform1f(this._programCSGmax.dimension_x, 1.0 / texture_w);
    gl.uniform1f(this._programCSGmax.dimension_y, 1.0 / texture_h);
    // * NO over-the-edge limits allowed
    if (i >= this.log2(size_min)) {
      if (texture_w > texture_h) {
        gl.uniform1f(this._programCSGmax.dimension_y, 0.0);
      }
      if (texture_h > texture_w) {
        gl.uniform1f(this._programCSGmax.dimension_x, 0.0);
      }
    }
    // * Scaling
    scale = 1.0 / step;
    pace += scale; // UPPER LEFT
    // * Positioning
    var invtw = 2.0 / texture_w;
    var invth = 2.0 / texture_h;
    var px = scale * 2.0;
    var py = scale * 2.0;
    if (px < invtw) {
      px = invtw;
    }
    if (py < invth) {
      py = invth;
    }
    var p = [-1.0, 1.0 - py, -1.0 + px, 1.0 - py, -1.0 + px, 1.0, -1.0, 1.0];
    // * Sampling
    var tx = 1.0 / (texture_w * 2.0);
    var ty = 1.0 / (texture_h * 2.0);
    var t = [0.0, pace, scale - tx, pace, scale - tx, 1.0 - ty, 0.0, 1.0 - ty];
    // *	Clearing the texture background with black
    gl.clearColor(0.0, 0.0, 0.0, 1.0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    // *	Drawing Step: Looking for the Max
    this.drawTexturedQuad(
      this._programCSGmax,
      this.pingPongBuffer[1 - this.PPCurrent],
      1.0,
      p,
      t
    );
    // Switching PingPong Buffers
    this.PPCurrent = 1 - this.PPCurrent;
    step *= 2;
  }
  gl.disableVertexAttribArray(this._programCSGmax.vertexAttribute);
  gl.disableVertexAttribArray(this._programCSGmax.texCoord0Attribute);
  // * Read the max in the ONLY pixel
  if (!this.debug_buffer2) {
    this.debug_buffer2 = new Uint8Array(4);
  }
  gl.readPixels(
    0,
    texture_h - 1,
    1.0,
    1.0,
    gl.RGBA,
    gl.UNSIGNED_BYTE,
    this.debug_buffer2
  );
  // REALLY IMPORTANT FOR DEBUG: DEBINDING FRAMEBUFFER AT NULL
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    null,
    0
  );
  // Normal rendering back
  this.pingPongBuffer = [this._DepthMap1, this._DepthMap2];
  this.PPCurrent = 0;
  return this.debug_buffer2[0];
};
Sculpteo3DViewerWebGL.prototype.renderSingleLayerDM = function (
  node,
  index,
  debug,
  modelView,
  projection,
  zBounds
) {
  var gl = this.gl;
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._tmpMap,
    0
  );
  // Using the depthmap program
  gl.useProgram(this._programDepthMap);
  // Rendering each layer
  gl.disable(gl.BLEND);
  // Clear of the color buffer
  if (debug) {
    gl.colorMask(true, true, true, true);
  } else {
    gl.colorMask(false, false, false, false);
  }
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clearStencil(0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.STENCIL_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  // Rendering only if it belongs to the current layer
  gl.enable(gl.STENCIL_TEST);
  gl.stencilFunc(gl.EQUAL, index, 0xff);
  gl.stencilMask(0xff);
  gl.stencilOp(gl.INCR, gl.KEEP, gl.INCR);
  // Drawing pass
  gl.enableVertexAttribArray(this._programDepthMap.vertexAttribute);
  var pMatrix = projection.scale(1.0, 1.0, 0.5).translate(0.0, 0.0, 0.5);
  gl.uniformMatrix4fv(
    this._programDepthMap.projectionMatrix,
    false,
    pMatrix.toFloat32Array()
  );
  gl.uniform3f(
    this._programDepthMap.zBounds,
    zBounds[0],
    zBounds[1],
    zBounds[2]
  );
  var mvMatrix = modelView.x(node.transform);
  gl.uniformMatrix4fv(
    this._programDepthMap.modelViewMatrix,
    false,
    mvMatrix.toFloat32Array()
  );
  var model = this.getActiveModel(node);
  if (model && node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT) {
    this.drawModelWithPositionsAndNormals(
      model,
      this._programDepthMap.vertexAttribute,
      null
    );
  }
  // Reinitialize the normal rendering
  gl.disableVertexAttribArray(this._programDepthMap.vertexAttribute);
  gl.enable(gl.BLEND);
  gl.disable(gl.STENCIL_TEST);
};
Sculpteo3DViewerWebGL.prototype.depthMapComputation = function (
  nodes,
  modelView,
  projection,
  zBounds,
  texture,
  shadows
) {
  var gl = this.gl;
  // Test at /en/workshops/create/geometry/
  // with
  // viewer = $("#_3dView").Sculpteo3DViewer();
  // viewer._getViewerInstance().csg_mode = 1;
  // n = viewer.createNode("test");
  // viewer.exec('append(new Sphere(1.5));', {},
  // "test").then(function(node) {
  // $("#_3dView").Sculpteo3DViewer().getScene().appendChild(node,
  // "difference"); });
  // $("#_3dView").Sculpteo3DViewer().exec('append((new
  // Sphere(0.5)).translate(-1,-1,-1));').then(function(node) {
  // $("#_3dView").Sculpteo3DViewer().getScene().appendChild(node,
  // "intersection"); });
  // and
  // here we draw the intersection, works only with convex shapes so
  // far
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
  // Counting the number of covered layers in each primitives in the scene
  for (var k = 0; k < nodes.length; k++) {
    var node = nodes[k];
    var vbos = this.getActiveModel(node);
    if (!vbos) {
      continue;
    }
    nodes[k].nb_layers = this.countCSGLayers(
      vbos,
      node.transform,
      modelView,
      projection,
      shadows
    );
  }
  // Union all products by drawing them to the framebuffer
  var csg_nodes = [];
  // Offscreen render
  gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
  gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
  gl.colorMask(true, true, true, true);
  // Clearing textures for the DepthMap Computation
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._DepthMap1,
    0
  );
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._DepthMap2,
    0
  );
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    this._tmpMap,
    0
  );
  gl.clearColor(1.0, 1.0, 1.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  for (var p = 0; p < this.scene_csg.length; p++) {
    var product = this.scene_csg[p];
    // Prune product if any operand has no model
    var product_nodes = [];
    for (var i = 0; i < product.length; i++) {
      var ref = product[i];
      var node = nodes[ref > 0 ? ref - 1 : -ref - 1];
      if (typeof node == "undefined") {
        log(product);
        throw new Error("no such node at " + ref);
      }
      // TODO: intersect bounding boxes here to prune more
      var model = this.getActiveModel(node);
      if (
        !model ||
        !model.length ||
        !(node.drawmode & Sculpteo3DViewerCommon.DRAWMODE_FLAT)
      ) {
        if (ref > 0) {
          // Intersection with empty model is empty
          product_nodes = [];
          break;
        }
      } else {
        node.complemented = ref < 0;
        product_nodes.push(node);
      }
    }
    if (!product_nodes.length) {
      continue;
    }
    for (var i = 0; i < product_nodes.length; i++) {
      this.drawSceneCSGDepthMap(
        product_nodes,
        i,
        modelView,
        projection,
        zBounds,
        texture,
        shadows
      );
      csg_nodes.push(product_nodes[i]);
    }
  }
  if (!shadows) {
    var n = csg_nodes.length;
    var cursorInstance = this.getCursorInstance();
    if (cursorInstance) {
      csg_nodes.push(cursorInstance);
    }
    this.cursorInstance = cursorInstance;
  }
  return csg_nodes;
};
Sculpteo3DViewerWebGL.prototype.drawScene = function (deltaT) {
  if (!this.update || this.disable3D || this.locked) {
    return;
  }
  this.update = false;
  this.$canvas.show();
  var gl = this.gl;
  var shininess = 30.0;
  gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
  gl.clearColor(0.0, 0.0, 0.0, 0.0);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
  gl.useProgram(this.shaderProgram);
  gl.uniform2f(this.shaderProgram.uPointSize, 0, 0);
  this.frame++;
  var nodes;
  if (this.scene_flat == null) {
    this._sceneUpdate();
  }
  nodes = this.scene_flat.slice();
  if (this.ui.cursorNode) {
    this.setUpdate(false);
  }
  if (this.autorotate && !this.loading) {
    // Small rotation
    var angle = ((1.0 * Math.PI) / 180.0) * (deltaT / 66);
    var ca = Math.cos(angle * 0.5);
    var sa = Math.sin(angle * 0.5);
    var arot = { w: ca, x: 0, y: 0, z: sa };
    this.rotq = this.quatMul(arot, this.rotq);
    this.setUpdate(true);
  }
  this.rotq = this.quatNormalize(this.rotq);
  if (this.autorotate && !this.loading) {
    this.postEvent(
      "camera",
      this.rotq.w,
      this.rotq.x,
      this.rotq.y,
      this.rotq.z
    );
  }
  this.mvLoadIdentity();
  this.multMatrix(this.cameraMat);
  this.mvTranslate([this.pan_x * this.zoom, this.pan_y * this.zoom, 0]);
  this.mvRotate(-90.0, [1, 0, 0]);
  var thisRot = this.getModelViewMatrix();
  this.multMatrix(thisRot);
  this.multMatrix(this.scene_transform);
  this.setMatrixUniforms(gl);
  this.invProjCamMatrix = this.pMatrix.x(this.cameraMat).inverse();
  gl.uniform4f(
    this.shaderProgram.cameraPos,
    this.cameraPos[0],
    this.cameraPos[1],
    this.cameraPos[2],
    this.cameraPos[3]
  );
  var global_material;
  if (this.wireframe) {
    global_material = {
      color: { r: 0, g: 0, b: 0 },
    };
  } else if (this.orientation) {
    global_material = {
      color: { r: 255, g: 255, b: 255 },
    };
  } else {
    global_material = this.global_material;
  }
  /* Lighting parameters */
  // TODO: normalize light direction instead of letting the shader do it
  gl.uniform3f(
    this.shaderProgram.ambientColorUniform,
    this.scene_ambient[0],
    this.scene_ambient[1],
    this.scene_ambient[2]
  );
  gl.uniform3f(
    this.shaderProgram.light0DirectionUniform,
    this.light0.direction[0],
    this.light0.direction[1],
    this.light0.direction[2]
  );
  gl.uniform3f(
    this.shaderProgram.light0DiffuseColorUniform,
    this.light0.diffuse[0],
    this.light0.diffuse[1],
    this.light0.diffuse[2]
  );
  gl.uniform3f(
    this.shaderProgram.light0SpecularColorUniform,
    this.light0.specular[0],
    this.light0.specular[1],
    this.light0.specular[2]
  );
  gl.uniform3f(
    this.shaderProgram.light1DirectionUniform,
    this.light1.direction[0],
    this.light1.direction[1],
    this.light1.direction[2]
  );
  gl.uniform3f(
    this.shaderProgram.light1DiffuseColorUniform,
    this.light1.diffuse[0],
    this.light1.diffuse[1],
    this.light1.diffuse[2]
  );
  gl.uniform3f(
    this.shaderProgram.light1SpecularColorUniform,
    this.light1.specular[0],
    this.light1.specular[1],
    this.light1.specular[2]
  );
  gl.lineWidth(1.0);
  if (
    (this.orientation || this.cutX || this.cutY || this.cutZ || this.cutAxis) &&
    !this.wireframe
  ) {
    gl.uniform1i(this.shaderProgram.useBadOrientationUniform, true);
    gl.uniform3f(this.shaderProgram.badOrientationColorUniform, 0.5, 0.0, 0.5);
  } else {
    gl.uniform1i(this.shaderProgram.useBadOrientationUniform, false);
  }
  if (this.wireframe) {
    var tmp_csg_mode = this.csg_mode;
    this.csg_mode = 0;
  }
  if (this.scene_drawmask & Sculpteo3DViewerCommon.DRAWMODE_FLAT) {
    if (this.csg_mode > Sculpteo3DViewerCommon.CSG_MODE_NONE) {
      gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
      gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
      var light0MVPMatrix = this.renderShadowMap2(
        nodes,
        this.light0,
        this._depthRenderBuffer,
        this.shadows && this.quality > 1
      );
      var light1MVPMatrix = this.renderShadowMap2(
        nodes,
        this.light1,
        this._depthRenderBuffer2,
        this.shadows && this.quality > 1
      );
      // Ssao
      csg_nodes = this.depthMapComputation(
        nodes,
        this.mvMatrix,
        this.pMatrix,
        this.zBounds,
        this.pingPongBuffer[1 - this.PPCurrent],
        false
      );
      // Restore normal render
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
      this.drawSceneHQ(
        csg_nodes,
        light0MVPMatrix,
        light1MVPMatrix,
        this.scene_ambient,
        this.light0,
        this.light1,
        global_material
      );
      this.map_nodes = csg_nodes;
    } else {
      // Non-CSG rendering modes
      if (
        !this.wireframe &&
        !this.orientation &&
        this.quality > 1 &&
        this.experimental_hq &&
        !this.cutX &&
        !this.cutY &&
        !this.cutZ &&
        !this.cutAxis
      ) {
        // Offscreen renders
        gl.bindFramebuffer(gl.FRAMEBUFFER, this._fboCSG);
        gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
        var light0MVPMatrix = this.renderShadowMap(
          nodes,
          this.light0,
          this._depthRenderBuffer,
          this.shadows && this.quality > 1
        );
        var light1MVPMatrix = this.renderShadowMap(
          nodes,
          this.light1,
          this._depthRenderBuffer2,
          this.shadows && this.quality > 1
        ); // Ssao
        this.renderDepthMap(nodes); // 5ms
        // Restore normal render
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.viewport(0, 0, gl.viewportWidth, gl.viewportHeight);
        if (global_material && global_material.roughness) {
          this.drawScenePBR(
            nodes,
            light0MVPMatrix,
            light1MVPMatrix,
            this.scene_ambient,
            this.light0,
            this.light1,
            global_material
          );
        } else {
          this.drawSceneHQ(
            nodes,
            light0MVPMatrix,
            light1MVPMatrix,
            this.scene_ambient,
            this.light0,
            this.light1,
            global_material
          );
        }
      } else {
        this.drawSceneLQ(
          nodes,
          this.scene_ambient,
          this.light0,
          this.light1,
          global_material,
          false,
          false
        );
      }
      this.map_nodes = nodes;
    }
  }
  if (this.wireframe) {
    this.csg_mode = tmp_csg_mode;
  }
  // Additional draw steps for node styling
  if (this.scene_drawmask & Sculpteo3DViewerCommon.DRAWMODE_WIREFRAME) {
    this.drawSceneLQ(
      nodes,
      this.scene_ambient,
      this.light0,
      this.light1,
      global_material,
      true,
      false
    );
  }
  if (this.scene_drawmask & Sculpteo3DViewerCommon.DRAWMODE_BBOX) {
    this.drawSceneBbox(
      nodes,
      this.scene_ambient,
      this.light0,
      this.light1,
      global_material
    );
  }
  // Pass for top objects
  if (this.scene_drawmask & Sculpteo3DViewerCommon.DRAWMODE_ON_TOP) {
    this.drawSceneLQ(
      nodes,
      this.scene_ambient,
      this.light0,
      this.light1,
      global_material,
      false,
      true
    );
  }

  var leaders = this.scene.nodes["model"].leaders || [];
  if (this.issues || this.selectedfaces || leaders) {
    var vbos = this.scene.nodes["model"].model || [];
    var _nodes = this.scene_flat.slice();
    _nodes.forEach(
      function (node) {
        if (!node.model) return;
        gl.useProgram(this.shaderProgram);
        gl.disable(gl.CULL_FACE);
        gl.uniform1f(this.shaderProgram.perlinAmplitudeUniform, 0.0);
        gl.uniform3f(this.shaderProgram.perlinScaleUniform, 0.0, 0.0, 0.0);
        gl.uniform1i(this.shaderProgram.usePerlinUniform, false);
        gl.enableVertexAttribArray(this.shaderProgram.vertexPositionAttribute);
        gl.enableVertexAttribArray(this.shaderProgram.vertexNormalAttribute);
        gl.enableVertexAttribArray(this.shaderProgram.textureCoordAttribute);
        gl.uniform1i(this.shaderProgram.useBadOrientationUniform, false);
        // Disable lighting (ambient only)
        gl.uniform3f(this.shaderProgram.ambientColorUniform, 1.0, 1.0, 1.0);
        gl.uniform3f(
          this.shaderProgram.light0DirectionUniform,
          this.light0.direction[0],
          this.light0.direction[1],
          this.light0.direction[2]
        );
        gl.uniform3f(
          this.shaderProgram.light0DiffuseColorUniform,
          0.0,
          0.0,
          0.0
        );
        gl.uniform3f(
          this.shaderProgram.light0SpecularColorUniform,
          0.0,
          0.0,
          0.0
        );
        gl.uniform3f(
          this.shaderProgram.light1DirectionUniform,
          this.light1.direction[0],
          this.light1.direction[1],
          this.light1.direction[2]
        );
        gl.uniform3f(
          this.shaderProgram.light1DiffuseColorUniform,
          0.0,
          0.0,
          0.0
        );
        gl.uniform3f(
          this.shaderProgram.light1SpecularColorUniform,
          0.0,
          0.0,
          0.0
        );
        // Unbind texture coordinates and normals and non-ambient material
        // properties
        gl.uniform1i(this.shaderProgram.useTexturesUniform, false);
        gl.uniform3f(
          this.shaderProgram.materialDiffuseColorUniform,
          0.0,
          0.0,
          0.0
        );
        gl.uniform3f(
          this.shaderProgram.materialSpecularColorUniform,
          0.0,
          0.0,
          0.0
        );
        gl.uniform1f(this.shaderProgram.materialShininessUniform, 1.0);
        gl.disable(gl.DEPTH_TEST);
        var mvMatrix = this.mvMatrix.x(node.transform);
        gl.uniformMatrix4fv(
          this.shaderProgram.mvMatrixUniform,
          false,
          mvMatrix.toFloat32Array()
        );
        var normalMatrix = mvMatrix.inverse();
        normalMatrix = normalMatrix.transpose();
        gl.uniformMatrix4fv(
          this.shaderProgram.nMatrixUniform,
          false,
          normalMatrix.toFloat32Array()
        );
        if (leaders) {
          for (var i = 0; i < leaders.length; i++) {
            var leader = this.leaders[i].leader;
            gl.lineWidth(2.0);
            gl.uniform3f(
              this.shaderProgram.materialAmbientColorUniform,
              0.0,
              0.0,
              0.0
            );
            // Edges
            gl.bindBuffer(gl.ARRAY_BUFFER, leader);
            gl.vertexAttribPointer(
              this.shaderProgram.vertexPositionAttribute,
              leader.itemSize,
              gl.FLOAT,
              false,
              0,
              0
            );
            // Unused but must be bound to something
            // (or we could just bind another shader)
            gl.vertexAttribPointer(
              this.shaderProgram.textureCoordAttribute,
              leader.itemSize,
              gl.FLOAT,
              false,
              0,
              0
            );
            gl.vertexAttribPointer(
              this.shaderProgram.vertexNormalAttribute,
              leader.itemSize,
              gl.FLOAT,
              false,
              0,
              0
            );
            gl.drawArrays(gl.LINE_STRIP, 0, leader.numItems);
          }
        }
        var vbos = node.model;
        for (var vbi = 0; vbi < vbos.length; vbi++) {
          if (this.issues) {
            var positions;
            gl.lineWidth(2.0);
            if (this.issues & Sculpteo3DViewerCommon.ISSUES_BORDER_EDGES) {
              positions = vbos[vbi].border_edges;
              if (positions.numItems > 0) {
                // Yellow
                gl.uniform3f(
                  this.shaderProgram.materialAmbientColorUniform,
                  1.0,
                  1.0,
                  0.0
                );
                // Border edges
                gl.bindBuffer(gl.ARRAY_BUFFER, positions);
                gl.vertexAttribPointer(
                  this.shaderProgram.vertexPositionAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.vertexAttribPointer(
                  this.shaderProgram.textureCoordAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.vertexAttribPointer(
                  this.shaderProgram.vertexNormalAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.drawArrays(gl.LINES, 0, positions.numItems);
              }
            }
            if (
              this.issues & Sculpteo3DViewerCommon.ISSUES_NON_MANIFOLD_EDGES
            ) {
              positions = vbos[vbi].non_manifold_edges;
              if (positions.numItems > 0) {
                // Red
                gl.uniform3f(
                  this.shaderProgram.materialAmbientColorUniform,
                  1.0,
                  0.0,
                  0.0
                );
                // Non-manifold edges
                gl.bindBuffer(gl.ARRAY_BUFFER, positions);
                gl.vertexAttribPointer(
                  this.shaderProgram.vertexPositionAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.vertexAttribPointer(
                  this.shaderProgram.textureCoordAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.vertexAttribPointer(
                  this.shaderProgram.vertexNormalAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.drawArrays(gl.LINES, 0, positions.numItems);
              }
            }
            if (
              this.issues & Sculpteo3DViewerCommon.ISSUES_NON_MANIFOLD_VERTICES
            ) {
              positions = vbos[vbi].non_manifold_vertices;
              if (positions.numItems > 0) {
                gl.uniform2f(this.shaderProgram.uPointSize, 0, 5.5);
                // Orange
                gl.uniform3f(
                  this.shaderProgram.materialAmbientColorUniform,
                  1.0,
                  0.5,
                  0.0
                );
                // Non-manifold vertices
                gl.bindBuffer(gl.ARRAY_BUFFER, positions);
                gl.vertexAttribPointer(
                  this.shaderProgram.vertexPositionAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.vertexAttribPointer(
                  this.shaderProgram.textureCoordAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.vertexAttribPointer(
                  this.shaderProgram.vertexNormalAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.drawArrays(gl.POINTS, 0, positions.numItems);
                gl.uniform2f(this.shaderProgram.uPointSize, 0, 0);
              }
            }
            if (this.issues & Sculpteo3DViewerCommon.ISSUES_OVERHANG_VERTICES) {
              positions = vbos[vbi].overhang_vertex_positions;
              if (positions && positions.numItems > 0) {
                gl.uniform2f(
                  this.shaderProgram.uPointSize,
                  this.pointSize[0],
                  this.pointSize[1]
                );
                gl.uniform3f(
                  this.shaderProgram.materialAmbientColorUniform,
                  this.pointColor[0],
                  this.pointColor[1],
                  this.pointColor[2]
                );
                gl.bindBuffer(
                  gl.ARRAY_BUFFER,
                  vbos[vbi].overhang_vertex_normals
                );
                gl.vertexAttribPointer(
                  this.shaderProgram.vertexNormalAttribute,
                  vbos[vbi].overhang_vertex_normals.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                // Overhang vertices
                gl.bindBuffer(gl.ARRAY_BUFFER, positions);
                gl.vertexAttribPointer(
                  this.shaderProgram.vertexPositionAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.vertexAttribPointer(
                  this.shaderProgram.textureCoordAttribute,
                  positions.itemSize,
                  gl.FLOAT,
                  false,
                  0,
                  0
                );
                gl.enable(gl.CULL_FACE);
                gl.enable(gl.DEPTH_TEST);
                gl.drawArrays(gl.POINTS, 0, positions.numItems);
                gl.disable(gl.CULL_FACE);
                gl.disable(gl.DEPTH_TEST);
                gl.uniform2f(this.shaderProgram.uPointSize, 0, 0);
              }
            }
          }
          if (this.selectedfaces) {
            var positions = vbos[vbi].selected_edges;
            if (positions.numItems > 0) {
              gl.lineWidth(1.0);
              // Green
              gl.uniform3f(
                this.shaderProgram.materialAmbientColorUniform,
                186.0 / 255.0,
                1.0,
                38.0 / 255.0
              );
              // Selected edges
              gl.bindBuffer(gl.ARRAY_BUFFER, positions);
              gl.vertexAttribPointer(
                this.shaderProgram.vertexPositionAttribute,
                positions.itemSize,
                gl.FLOAT,
                false,
                0,
                0
              );
              // Unused but must be bound to something
              // (or we could just bind another shader)
              gl.vertexAttribPointer(
                this.shaderProgram.textureCoordAttribute,
                positions.itemSize,
                gl.FLOAT,
                false,
                0,
                0
              );
              gl.vertexAttribPointer(
                this.shaderProgram.vertexNormalAttribute,
                positions.itemSize,
                gl.FLOAT,
                false,
                0,
                0
              );
              gl.drawArrays(gl.LINES, 0, positions.numItems);
            }
          }
          if (
            node.proto.curves.length &&
            this.issues & Sculpteo3DViewerCommon.ISSUES_INTERSECTING_FACES
          ) {
            var curves = node.proto.curves;
            for (var vbi = 0; vbi < curves.length; vbi++) {
              var positions = curves[vbi].edges;
              gl.lineWidth(2.0);
              // Blue
              gl.uniform3f(
                this.shaderProgram.materialAmbientColorUniform,
                0x93 / 255,
                0x74 / 255,
                0xfa / 255
              );
              // Edges
              gl.bindBuffer(gl.ARRAY_BUFFER, positions);
              gl.vertexAttribPointer(
                this.shaderProgram.vertexPositionAttribute,
                positions.itemSize,
                gl.FLOAT,
                false,
                0,
                0
              );
              // Unused but must be bound to something
              // (or we could just bind another shader)
              gl.vertexAttribPointer(
                this.shaderProgram.textureCoordAttribute,
                positions.itemSize,
                gl.FLOAT,
                false,
                0,
                0
              );
              gl.vertexAttribPointer(
                this.shaderProgram.vertexNormalAttribute,
                positions.itemSize,
                gl.FLOAT,
                false,
                0,
                0
              );
              gl.drawArrays(gl.LINES, 0, positions.numItems);
            }
          }
        }
      }.bind(this)
    );
    gl.enable(gl.DEPTH_TEST);
    gl.enable(gl.CULL_FACE);
  }
  this.drawUI(this.ui);
  gl.disableVertexAttribArray(this.shaderProgram.vertexPositionAttribute);
  gl.disableVertexAttribArray(this.shaderProgram.vertexNormalAttribute);
  gl.disableVertexAttribArray(this.shaderProgram.textureCoordAttribute);
  // Fps
  var fps_date = new Date().getTime();
  if (fps_date > this.last_fps_date + 1000.0) {
    var time_delta = fps_date - this.last_fps_date;
    var frame_delta = this.frame - this.last_fps_frame;
    this.last_fps_date = fps_date;
    this.last_fps_frame = this.frame;
    if (this.log_fps) {
      console.log(
        "fps: " +
          (1000.0 * frame_delta) / time_delta +
          " time: " +
          time_delta / frame_delta +
          "ms"
      );
    }
  }
  // draw the selection rectangle if there's any
  if (this.selectionRect) {
    this.drawSelectionRect(this.selectionRect);
  }
};
Sculpteo3DViewerWebGL.prototype.resize = function (width, height) {
  this.width = width;
  this.height = height;
  this.dim = this.width;
  if (this.height > this.dim) {
    this.dim = this.height;
  }
  this.canvas.width = width;
  this.canvas.height = height;
  this.gl.viewportWidth = width;
  this.gl.viewportHeight = height;
  Sculpteo3DViewerCommon.prototype.resizeViewerFrame.call(
    this,
    this.viewerId,
    width,
    height
  );
  this.updateTextures();
  this.updateProjectionMatrix();
  this.setUpdate(true);
};
Sculpteo3DViewerWebGL.prototype.webGLInit = function () {
  var gl = this.gl;
  if (gl) {
    return;
  }
  var canvas = document.getElementById(
    "Sculpteo3DViewerCanvas" + this.viewerId
  );
  // Canvas = WebGLDebugUtils.makeLostContextSimulatingCanvas(canvas);
  // window.xxcanvas = canvas;
  this.canvas = canvas;
  var names = ["webgl", "experimental-webgl", "webkit-3d", "moz-webgl"];

  // Anti-aliasing breaks some features, but we'd like them on AMT
  // A conditional activation will prevent regressions on site_v1
  var aaVal = false;
  if (typeof amt_options !== "undefined") {
    aaVal = amt_options.antialias;
  }
  for (var i = 0; i < names.length; ++i) {
    try {
      gl = canvas.getContext(names[i], {
        antialias: aaVal,
        stencil: true,
        premultipliedAlpha: false,
      });
    } catch (e) {
      console.log("WEBGL ERROR:" + e.toString());
    }
    if (gl) {
      break;
    }
  }
  if (!gl) {
    // JAlert(String.format(gettext("Could not initialise WebGL shaders, switching back to default 3D technology<br><a href='{0}#webgl' target='_blank'>More information here</a>"), URLS['help']));
    if (this.restartTimeout) {
      clearTimeout(this.restartTimeout);
    }
    var that = this;
    this.restartTimeout = setTimeout(function () {
      that.sculpteo3dviewer.Sculpteo3DViewer(
        "selectViewer",
        Sculpteo3DViewerCaps & Sculpteo3DViewerCap_flash ? "flash" : "static",
        true
      );
    });
    return;
  }
  if (typeof WebGLDebugUtils != "undefined") {
    gl = WebGLDebugUtils.makeDebugContext(gl);
  }
  gl.INCOMPLETE_DRAW_BUFFER = 0x8cdb;
  gl.INCOMPLETE_READ_BUFFER = 0x8cdc;
  var enum_to_string = {};
  for (var k in gl) {
    if (typeof gl[k] == "number") {
      enum_to_string[gl[k]] = k;
    }
  }
  this.enum_to_string = enum_to_string;
  gl.viewportWidth = canvas.width;
  gl.viewportHeight = canvas.height;
  this.texture_size = Math.max(
    Math.min(
      nearestUpperPow2(Math.max(gl.viewportWidth, gl.viewportHeight)),
      1024
    ),
    16
  );
  //log("texture size: " + this.texture_size); // Can be uncommented if we have test to do
  this.texture_size = 1024;
  this.initShaders(gl);
  this.initTextures(gl);
  this.mvLoadIdentity();
  this.mvMatrixStack = [];
  gl.clearColor(0.0, 0.0, 0.0, 0.0);
  gl.clearDepth(1.0);
  gl.enable(gl.DEPTH_TEST);
  gl.depthFunc(gl.LEQUAL);
  var lineWidth = gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE);
  if (lineWidth[1] == 1) {
    gl.lineWidth = function () {};
  }
  this.gl = gl;
  this.frame = 0;
  this.last_fps_date = new Date().getTime();
  this.last_fps_frame = this.frame;
};
Sculpteo3DViewerWebGL.prototype.processHash = function () {
  if (
    window.location.hash.indexOf("viewer.webgl.experimental_hq=false") != -1
  ) {
    this.experimental_hq = false;
  }
  if (
    window.location.hash.indexOf("viewer.webgl.experimental_envmap_lod=true") !=
    -1
  ) {
    this.experimental_envmap_lod = true;
  }
  if (
    window.location.hash.indexOf("viewer.webgl.experimental_theme=test") != -1
  ) {
    this.scene_ambient = [
      2 * 0.17647058823529413,
      2 * 0.17647058823529413,
      2 * 0.18823529411764706,
    ];
    this.light0.direction = [-100, 100, 75];
    this.light0.diffuse = [1, 1, 1];
    this.light1.direction = [0, -100, 50];
    this.light1.diffuse = [0.45, 0.38823529411764707, 0.20294117647058824];
  }
};
Sculpteo3DViewerUI.prototype.insideRotatedBox = function (
  x,
  y,
  x0,
  y0,
  x1,
  y1,
  angle,
  inset
) {
  // Rotate the point, then test the box
  var w = x1 - x0;
  var h = y1 - y0;
  var xo = x - x0;
  var yo = y - y0;
  var ca = Math.cos((-angle * Math.PI) / 180.0);
  var sa = Math.sin((-angle * Math.PI) / 180.0);
  var xr = ca * xo - sa * yo;
  var yr = sa * xo + ca * yo;
  return this.viewer._insideBox(xr, yr, w, h, inset);
};
Sculpteo3DViewerUI.prototype.overElement = function (x, y) {
  for (var k in this.textinputs) {
    if (!this.textinputs.hasOwnProperty(k)) continue;
    var textinput = this.textinputs[k];
    var box = textinput.box();
    var w = box[2] - box[0];
    var h = box[3] - box[1];
    var inset = 0.1 * (w < h ? w : h); // Assume rotate/scale if on
    // border
    var code = this.insideRotatedBox(
      x,
      y,
      box[0],
      box[1],
      box[2],
      box[3],
      box[4],
      inset
    );
    var region = ["sw", "s", "se", "w", "c", "e", "nw", "n", "ne"];
    if (code != 9) {
      return { control: textinput, sensor: region[code] };
    }
  }
  return null;
};
Sculpteo3DViewerUI.prototype.cursorForScale = function (control) {
  var angle = control.angle;
  angle += 45.0;
  var a = parseInt(angle) % 360;
  if (a < 0) {
    a += 360;
  }
  if (a < 90) {
    return "ne-resize";
  } else if (a < 180) {
    return "nw-resize";
  } else if (a < 270) {
    return "sw-resize";
  } else {
    return "se-resize";
  }
};
Sculpteo3DViewerUI.prototype.mousedown = function (x, y) {
  // Log("UI mousedown hook");
  var over = this.overElement(x, y);
  if (over) {
    this.focus = over.control;
    this.capture = true;
    this.start_x = x;
    this.start_y = y;
    this.origin_x = over.control.x;
    this.origin_y = over.control.y;
    this.start_box = over.control.box();
    this.start_scale = over.control.scale;
    this.start_angle = over.control.angle;
    this.tool = null;
    if (over.sensor == "sw") {
      this.tool = "move";
      this.viewer.setCursorStyle("move");
    }
    if (over.sensor == "ne") {
      this.tool = "scale";
      this.viewer.setCursorStyle(this.cursorForScale(over.control));
    }
    if (over.sensor == "se") {
      this.tool = "rotate";
      this.viewer.setCursorStyle("crosshair");
    }
    if (over.sensor == "c") {
      this.viewer.setCursorStyle("text");
    }
    return false;
  }
  this.focus = null;
  return true;
};
Sculpteo3DViewerUI.prototype.mouseup = function (x, y) {
  this.capture = false;
  this.tool = null;
  return true;
};
Sculpteo3DViewerUI.prototype.mousemove = function (x, y) {
  var over = this.overElement(x, y);
  if (!this.tool) {
    if (over) {
      if (over.sensor == "sw") {
        this.viewer.setCursorStyle("move");
      }
      if (over.sensor == "ne") {
        var a = parseInt(over.control.angle) % 360;
        this.viewer.setCursorStyle(this.cursorForScale(over.control));
      }
      if (over.sensor == "se") {
        this.viewer.setCursorStyle("crosshair");
      }
      if (over.sensor == "c") {
        this.viewer.setCursorStyle("text");
      }
    } else {
      this.viewer.setCursorStyle("default");
    }
  }
  if (this.capture) {
    if (this.focus) {
      var dx = x - this.start_x;
      var dy = y - this.start_y;
      if (this.tool == "move") {
        this.focus.x = this.origin_x + dx;
        this.focus.y = this.origin_y + dy;
      } else if (this.tool == "scale") {
        var v0x = this.start_x - this.origin_x;
        var v0y = this.start_y - this.origin_y;
        var v1x = x - this.origin_x;
        var v1y = y - this.origin_y;
        var l0 = Math.sqrt(v0x * v0x + v0y * v0y);
        var l1 = Math.sqrt(v1x * v1x + v1y * v1y);
        this.focus.scale = (this.start_scale * l1) / l0;
      } else if (this.tool == "rotate") {
        var v0x = this.start_x - this.origin_x;
        var v0y = this.start_y - this.origin_y;
        var v1x = x - this.origin_x;
        var v1y = y - this.origin_y;
        var det = v0x * v1y - v1x * v0y;
        var angle =
          (Math.acos(
            (v0x * v1x + v0y * v1y) /
              (Math.sqrt(v0x * v0x + v0y * v0y) *
                Math.sqrt(v1x * v1x + v1y * v1y))
          ) *
            180.0) /
          Math.PI;
        if (det < 0) {
          angle = -angle;
        }
        this.focus.angle = this.start_angle + angle;
      }
    }
    return false;
  }
  return true;
};
Sculpteo3DViewerUI.prototype.click = function (x, y) {
  // Log("UI click hook");
  if (this.viewer.scene) {
    var viewer = this.viewer;
    var pos = viewer.getPositionFromXY(viewer.mouse_x, viewer.mouse_y);
    var nodes = viewer.rayIntersectScene(
      pos[0],
      pos[1],
      pos[2],
      pos[3],
      pos[4],
      pos[5]
    );
    for (var k = 0; k < nodes.length; k++) {
      if (nodes[k].instance.onclick) {
        nodes[k].instance.onclick.apply(nodes[k].instance, pos);
      }
    }
    // Log(nodes);
  }
  // TEMP: place text on mesh at mouse location
  if (this.text_on_mesh) {
    var font_id = this.text_on_mesh.font;
    if (this.viewer.fonts[font_id]) {
      var font = this.viewer.fonts[font_id];
      // Get mouse location in object coordinates
      x *= this.viewer.zoom;
      y *= this.viewer.zoom;
      var str = this.text_on_mesh.str;
      var scale = this.text_on_mesh.scale;
      var color = this.text_on_mesh.color;
      var angle = this.text_on_mesh.angle;
      var height = this.text_on_mesh.height;
      var margin = 0.2;
      var ofx = margin * scale;
      var ofy = margin * scale;
      this.viewer.appendTextOnMesh(
        x,
        y,
        ofx,
        ofy,
        font,
        str,
        color,
        scale,
        angle,
        height
      );
    }
  }
  return true;
};
Sculpteo3DViewerUI.prototype.keypress = function (code, character) {
  // Log("UI keypress hook");
  if (this.focus) {
    var textinput = this.focus;
    var s = textinput.str ? textinput.str : "";
    if (code == "0") {
      s += character;
    }
    if (code == "8") {
      s = s.substr(0, s.length - 1);
    }
    textinput.str = s;
  }
  return true;
};
function Sculpteo3DViewerUI(viewer) {
  this.labels = new Array();
  this.textinputs = new Array();
  this.selection_rect = null;
  this.focus = null;
  this.capture = false;
  this.viewer = viewer;
  this.layers = {};
  this.images = {};
  this.layout = [];
  this.viewer.ui = this;
  this.root = this.layers[this.viewer.createLayer()];
  this.viewer.setLayerFrame(
    this.root.key,
    0,
    0,
    this.viewer.width,
    this.viewer.height
  );
  this.viewer._setRootLayer(this.root);
}
function Sculpteo3DViewerWebGL(jself, viewerId, options) {
  this.init(jself, viewerId, options);
}
Sculpteo3DViewerWebGL.prototype.init = function (jself, viewerId, options) {
  var _width = parseInt(jself.width());
  var _height = parseInt(jself.height());
  /*
   * If (_width > _height) _width = _height; if (_height > _width) _height =
   * _width;
   */
  this.viewerId = viewerId;
  this.use_features = options.use_features;
  this.viewer_src_type = "webgl"; // The type used to access the src array of
  // precomputed models
  this.viewer_remote_type = "webgl2"; // The type reported to the server for
  // previews
  this.local = options.local;
  this.viewer_uuid = options.uuid;
  this.envmap_url = options.envmapurl;
  this.cubemap_url = options.cubemapurl;
  this.envmap = options.envmap;
  this.gauss_val = options.gaussian_amplitude;
  this.smooth_normals = options.smooth_normals;
  this.translucency = options.translucency;
  this.quality = options.quality;
  this.remote_quality = options.remote_quality;
  this.patch_render = options.patch_render;
  this.patch_fill_type = options.patch_fill_type;
  this.patch_frequency = options.patch_frequency;
  this.patch_width = options.patch_width;
  this.patch_height = options.patch_height;
  this.width = _width;
  this.height = _height;
  this.renderurl = options.render;
  this.newSceneUrl = options.new_scene_url;
  this.dim = this.width;
  if (this.height > this.dim) {
    this.dim = this.height;
  }
  this.setMaterial(options.material);
  this.setUnits(options.unitmm);
  this.eventHandler = options._eventhandler;
  this.wireframe = options.wireframe;
  this.pointcloud = options.pointcloud;
  this.orientation = options.orientation;
  this.issues = options.issues;
  this.selectedfaces = options.selectedfaces;
  this.overhangActivated = false;
  this.pointSize = [0, 0];
  this.pointColor = [0.15, 0.15, 0.7];
  this.solidity = null;
  this.fading = options.fading;
  this.render_timeout = 500;
  this.render_timeout2 = 5000;
  this.render_cache = options.rendercache;
  this.render_age = 1;
  this.remote_age = 0;
  this.identity = Sculpteo3DViewerCommonTransform3D.identity.toFloat32Array();
  if (options.rendertimeout) {
    var T = options.rendertimeout.split(/,/);
    if (T.length > 0) {
      this.render_timeout = parseInt(T[0]);
    }
    if (T.length > 1) {
      this.render_timeout2 = parseInt(T[1]);
    }
  }
  this.render_width = 0; // Unlimited
  this.render_height = 0;
  if (options.rendersize) {
    var T = options.rendersize.split(/,/);
    if (T.length == 2) {
      this.render_width = parseInt(T[0]);
      this.render_height = parseInt(T[1]);
    }
  }
  if (options.transform) {
    this.setTransform(options.transform, true);
  } else {
    this.setTransform("0.9928826,0.07926025,-0.014972103,0.08762345", true);
  }
  if (options.bumpnoise) {
    this.setBumpNoise(options.bumpnoise);
  }
  // Lighting
  this.scene_ambient = [0.72, 0.72, 0.72];
  this.light0 = {
    direction: [-5.0, 5.0, 2.0],
    diffuse: [0.5, 0.5, 0.5],
    specular: [1.0, 1.0, 1.0],
  };
  this.light1 = {
    direction: [5.0, 5.0, 2.0],
    diffuse: [0.3, 0.3, 0.3],
    specular: [1.0, 1.0, 1.0],
  };
  this.createViewerFrame(jself, viewerId, options, this.width, this.height);
  this.sculpteo3dviewer = jself;
  this.jself = $(".Sculpteo3DViewerWebGL", jself);
  this.mouseInit();
  document.body.oncontextmenu = function (event) {
    event = event ? event : window.event;
    var target = event.target ? event.target : event.srcElement;
    if (
      target.className == "Sculpteo3DViewerCommonLayer" ||
      target.id == "Sculpteo3DViewerImage" ||
      target.id.substr(0, 22) == "Sculpteo3DViewerCanvas"
    ) {
      return false;
    }
  };
  this.zoom = this.zoom_init = options.zoom;
  this.setZoom(this.zoom);
  this.pan_x = 0;
  this.pan_y = 0;
  this.autorotate = options.autorotate;
  this.solidity = options.solidity;
  this.loadid = 0;
  this.loading = false;
  this.loading_bbox = false;
  this.update = true;
  this.locked = false;
  this.disable3D = false;
  this.touches = 0;
  this.experimental_hq = true;
  this.experimental_envmap_lod = false;
  this.csg_mode = options.csgmode;
  this.use_perspective = options.perspective;
  this.scene_transform = Sculpteo3DViewerCommonTransform3D.identity;
  if (options.bgcolor) {
    this.setBackgroundColor(
      options.bgcolor[0],
      options.bgcolor[1],
      options.bgcolor[2]
    );
  }
  this.setSelectionColor(
    options.selcolor[0],
    options.selcolor[1],
    options.selcolor[2],
    options.selcolor[3]
  );
  if (options.bgImage) {
    this.setBackgroundImage(options.bgImage);
  }
  if (options.designUUID) {
    this.setDesignUUID(options.designUUID);
  }
  if (options.sceneTransform) {
    this.setSceneTransform(options.sceneTransform);
  }
  if (options.cutAxis != null) {
    this.setCutColor(
      options.cutColor[0],
      options.cutColor[1],
      options.cutColor[2],
      options.cutColor[3]
    );
    this.setCutAxis(
      options.cutAxis[0],
      options.cutAxis[1],
      options.cutAxis[2],
      options.cutAxis[3]
    );
  }
  // XXX: ugly hack for easier testing
  var viewer = this;
  $(window).bind("hashchange", function () {
    viewer.processHash();
  });
  this.processHash();
  this.nearVal = -2.0;
  this.farVal = 2.0;
  this.updateProjectionMatrix();
  // Shadowmap parameters
  this.shadows = true;
  // SSAO parameters
  this.ao = {
    enabled: true,
    strength: 2.5,
    scale: 1.0,
    radius: 0.0,
    dmax: 0.3,
  };
  this.webGLInit();
  var _this = this;
  this.canvas.addEventListener(
    "webglcontextlost",
    function (event) {
      console.log("webgl context crashed");
      event.preventDefault();
      _this.cleanUp();
      _this.gl = null;
    },
    false
  );
  this.canvas.addEventListener(
    "webglcontextrestored",
    function (event) {
      console.log("restoring webgl context");
      _this.init(jself, viewerId, options);
    },
    false
  );
  this.reinit = function () {
    console.log("Reinitializing 3D Viewer");
    _this.cleanUp();
    _this.gl = null;
    _this.init(jself, viewerId, options);
  };
  this.ao.radius = this.texture_size / 16.0;
  // Always add a node to represent the main model
  // even if it is not loaded yet
  this.scene = { nodes: {}, instances: {} };
  var rootkey = this.sceneReset();
  var modelkey = this.createNode("model");
  this._attachNode(rootkey, modelkey);
  this.ui = new Sculpteo3DViewerUI(this);
  if (typeof options.set3d != "undefined") {
    this.setdisable3D(!options.set3d);
  }
  this.startRenderLoop();
  if (options.src) {
    this.loadModel(options.src);
  } else if (options.load) {
    for (var k in options.load) {
      this.loadModel(options.load[k], k);
    }
  } else {
    this.postEvent("progress", "0");
    this.postEvent("progress", "100");
  }
  this.postEvent("init");
  this.control_hidden = false;
  if (!this.touch_device && this.showControls) {
    this.showControls();
  }
  this.fonturl = options.fonturl;
  this.fonts = new Object();
  this.nodes = new Array();
  this.map_nodes = [];
  this.forceNodeMap = false;
  // Picking object for selection; we pass the viewer because we need to have access to its shader
  // programs, uniforms, nodes and so on and so forth...
  this.picking = new Sculpteo.Picking(this._csgWidth, this._csgHeight, this);
  // OpenGL vertex buffer object that contains the four vertices defining the selection rectangle.
  this.selectRectVBO = this.gl.createBuffer();
  this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.selectRectVBO);
  this.gl.bufferData(this.gl.ARRAY_BUFFER, 4 * 2 * 4, this.gl.STATIC_DRAW); // 4 vertices of 2 floats (4 bytes)
  this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null);
  return;
};
